<template>
  <div class="show-header">
    <AppHeader :current-page="currentGuidePage" @update-page="handlePageChange" :droppedImages="droppedImages" @price-modal-opened="handlePriceModalOpened" @open-guide="openGuide" @download-image="downloadContentWithFilters" :disableSideMenu="true" />
  </div>
  <AppGuide v-if="showGuide" :initial-page="currentGuidePage" @close="closeGuide" @update-page="handlePageChange" :pages="localizedGuidePages" :totalPages="localizedGuidePages.length" />

  <div class="app-container" :class="{ 'modal-open': isAnyModalOpen }">
    <AppSidebar
      ref="sidebarRef"
      :show-content="shaw.sidebar"
      :show-layers-panel="showLayersPanel && !isMobile"
      :show-calculator-panel="showCalculatorPanel && !isMobile"
      :layers-list="layersList"
      :grouped-layers-list="groupedLayersList"
      :calculator-items="layersList"
      :active-item-id="activeItemId"
      :active-group="activeGroup"
      @add-image="addImageToContent"
      @add-font="(element) => addFontToContent(element)"
      @add-text="handleAddText"
      @icon-change="setActiveIcon"
      @background-color-change="setBackgroundColor"
      @close-sidebar="showSidebar = false"
      @select-layer="selectLayerItem"
      @reorder-layers="handleReorderLayers"
      @reorder-group-children="handleReorderGroupChildren"
      @toggle-group-expand="toggleGroupExpand"
      @show-subscription-required="handleSubscriptionRequired"
      @close-calculator="closeCalculatorPanel"
      @calculator-highlight="handleCalculatorHighlight"
      @calculator-delete="handleCalculatorDelete"
      @calculator-excluded="handleCalculatorExcludedUpdate"
      @calculator-refresh-prices="refreshAllPricesFromDB"
    />

    <div class="main-content-wrapper">
      <div class="slides-section" :style="showSaveModal || showClearModal ? 'z-index: 0' : ''">
        <AppContentSlides :slides="fotozones" :activeSlideId="activeZoneId" :projectId="currentProjectId" :can-undo="canUndo" :can-redo="canRedo" :layers-panel-open="showLayersPanel" :can-use-calculator="canUseCalculator" @slide-change="onSlideChange" @modal-opened="handleModalOpened" @open-background="handleMobileOpenBackground" @open-layers="handleMobileOpenLayers" @toggle-layers="handleToggleLayers" @open-save="handleMobileOpenSave" @download-image="handleMobileDownload" @clear-all="handleMobileClearAll" @toggle-selection="handleMobileToggleSelection" @delete-zone="handleDeleteCurrentZone" @open-ai-modal="handleOpenAiModal" @undo="handleUndo" @redo="handleRedo" @open-calculator="openCalculatorPanel" />
      </div>
      <CanvasZoomControls
        v-if="useKonvaEditor"
        :zoom="canvasZoom"
        :is-mobile="isMobile"
        :pan-mode="canvasPanMode"
        @zoom-in="zoomCanvasIn"
        @zoom-out="zoomCanvasOut"
        @fit="fitCanvas"
        @toggle-pan="toggleCanvasPanMode"
      />
      <div class="content-section-wrap">
        <div class="canvas-and-sidebar">
        <div
          :class="{ 'selection-mode': isSelectionMode, 'content-section-downloading': isDownloadingContent, 'konva-mode': useKonvaEditor }"
          class="content-section"
          @mousedown="!useKonvaEditor && startSelection($event)"
          @touchstart="!useKonvaEditor && startSelection($event)"
          @mousemove="!useKonvaEditor && handleSelection($event)"
          @touchmove="!useKonvaEditor && handleSelection($event)"
          @mouseup="!useKonvaEditor && endSelection()"
          @touchend="!useKonvaEditor && endSelection()"
          @contextmenu="handleContextMenu"
          @click="handleContentSectionClick"
          ref="contentRef"
        >
          <!-- Zone Loading Skeleton -->
          <div v-if="isZoneLoading" class="zone-loading-skeleton">
            <div class="skeleton-content">
              <div class="skeleton-element skeleton-large"></div>
              <div class="skeleton-element skeleton-medium"></div>
              <div class="skeleton-element skeleton-small"></div>
            </div>
          </div>

          <!-- <div v-if="isSelecting" class="selection-box" :style="selectionBoxStyle"></div> -->

          <!-- Линия лассо во время рисования -->
          <svg v-if="isDrawing && selectionPath" class="selection-lasso-drawing" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 1000">
            <path :d="selectionPath" stroke="#007bff" stroke-width="2" fill="none" stroke-dasharray="5,5" />
          </svg>

          <!-- Заполненный полигон после завершения рисования -->
          <svg
            v-if="tempSelectionPolygon.visible && selectionPath"
            class="selection-lasso-filled"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 999"
          >
            <path :d="selectionPath" stroke="#007bff" stroke-width="2" fill="rgba(0, 123, 255, 0.1)" stroke-dasharray="5,5" />
          </svg>

          <!-- Граница выделенной группы (показывается только если есть выделенные элементы) -->
          <!-- <div v-if="selectedItems.length > 1 && showGroupBorder" class="group-boundary" :style="groupBoundaryStyle">
        </div> -->

          <!-- Кнопка группировки -->
          <div
            v-if="selectedItems.length > 1 && showGroupButton"
            class="group-button"
            :style="{
              left: `${groupButtonPosition.x}px`,
              top: `${groupButtonPosition.y}px`,
            }"
          >
            <button @click.stop="createGroup" @touchstart.stop.prevent="createGroup">{{ $t('legacy.Группировка') }}</button>
          </div>

          <div v-if="shaw.content">
            <div v-if="showEmptyMessage" class="empty-content-message">
              {{ emptyMessageText }}
            </div>

            <AppSaveProjectModal :visible="showSaveModal" :current-zone-title="currentZoneTitle" :project-data="currentProjectData" @close="showSaveModal = false" @save="handleProjectSave" />
            <AppSaveSuccessModal :visible="showSuccessModal" :projectName="savedProjectName" @close="showSuccessModal = false" @continue="showSuccessModal = false" @goto-projects="goToProjectsPage" />
            <AppClearContentModal :visible="showClearModal" @close="showClearModal = false" @clear-content="clearContent" />
            <Teleport to="body">
              <BackgroundModal v-if="showBackgroundModal" @close="showBackgroundModal = false" @apply-background="applyBackground" />
            </Teleport>
            
            <!-- Export Modal for Mobile -->
            <ExportModal
              v-if="showExportModal"
              :status="exportStatus"
              :render-progress="exportRenderProgress"
              :upload-progress="exportUploadProgress"
              :download-url="exportDownloadUrl"
              :error-message="exportErrorMessage"
              @close="closeExportModal"
              @retry="retryExport"
            />
            
            <!-- AI Processing Modal -->
            <div v-if="showAiModal" class="ai-modal-overlay" @click.self="closeAiModal">
              <div class="ai-modal">
                <div class="ai-modal-header">
                  <h3>{{ $t('legacy.Фотореалистичная обработка') }}</h3>
                  <button class="ai-modal-close" @click="closeAiModal">&times;</button>
                </div>
                <div class="ai-modal-body">
                  <div class="ai-credits-info">
                    <span>{{ $t('legacy.Доступно кредитов:') }}</span>
                    <span class="credits-value">{{ aiCredits }}</span>
                  </div>
                  <div class="ai-feature-description">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" class="ai-icon">
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#667eea" stroke="#667eea" stroke-width="1"/>
                    </svg>
                    <p class="ai-description">{{ $t('ИИ сделает ваш коллаж гиперреалистичным: улучшит освещение, добавит глубину теней, повысит чёткость текстур и насыщенность цветов, сохраняя естественный вид. За обработку одного изображения списывается 1 кредит.') }}</p>
                    <ul class="ai-features-list">
                      <li>{{ $t('legacy.Улучшение освещения и цветопередачи') }}</li>
                      <li>{{ $t('legacy.Повышение чёткости и детализации') }}</li>
                      <li>{{ $t('legacy.Естественные тени и глубина') }}</li>
                      <li>{{ $t('legacy.Сохранение всех элементов композиции') }}</li>
                    </ul>
                  </div>
                  <p class="ai-processing-note">{{ $t('Обработка занимает 1-2 минуты. Результат появится в разделе "Мои обработки".') }}</p>
                </div>
                <div class="ai-modal-footer">
                  <button class="ai-btn ai-btn-cancel" @click="closeAiModal" :disabled="aiProcessing">{{ $t('common.cancel') }}</button>
                  <button class="ai-btn ai-btn-process" @click="handleAiProcess" :disabled="aiProcessing">
                    <span v-if="aiProcessing">{{ $t('Отправка...') }}</span>
                    <span v-else>{{ $t('legacy.Обработать') }}</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- AI Progress Modal -->
            <div v-if="showAiProgressModal" class="ai-modal-overlay">
              <div class="ai-progress-modal">
                <div class="ai-progress-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#667eea" stroke-width="2" class="ai-spinner">
                    <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/>
                  </svg>
                </div>
                <p class="ai-progress-status">{{ aiProgressStatusText }}</p>
                <div class="ai-progress-bar">
                  <div class="ai-progress-fill" :style="{ width: aiProgress + '%' }"></div>
                </div>
                <span class="ai-progress-percent">{{ aiProgress }}%</span>
              </div>
            </div>

            <!-- AI Success Modal -->
            <div v-if="showAiSuccessModal" class="ai-modal-overlay" @click.self="closeAiSuccessModal">
              <div class="ai-success-modal">
                <button class="ai-success-close" @click="closeAiSuccessModal">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18" stroke="#7A8A99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 6L18 18" stroke="#7A8A99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="ai-success-icon">
                  <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" fill="#10B981" opacity="0.1"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#10B981"/>
                  </svg>
                </div>
                <p class="ai-success-message">{{ $t('legacy.Обработка запущена!') }}</p>
                <p class="ai-success-description">{{ $t('Результат появится в разделе "Мои обработки" через 1-2 минуты.') }}</p>
                <div class="ai-success-actions">
                  <button class="ai-success-btn ai-success-btn-secondary" @click="closeAiSuccessModal">{{ $t('legacy.Продолжить работу') }}</button>
                  <button class="ai-success-btn ai-success-btn-primary" @click="goToMyProcessings">{{ $t('processing.title') }}</button>
                </div>
              </div>
            </div>

            <!-- Buy Credits Modal -->
            <div v-if="showBuyCreditsModal" class="credits-modal-overlay" @click.self="closeBuyCreditsModal">
              <div class="credits-modal">
                <div class="credits-modal-header">
                  <h3>{{ $t('legacy.Покупка кредитов') }}</h3>
                  <button class="credits-modal-close" @click="closeBuyCreditsModal">&times;</button>
                </div>
                <div class="credits-modal-body">
                  <div class="credits-current">
                    <span>{{ $t('legacy.Текущий баланс:') }}</span>
                    <span class="credits-current-value">{{ aiCredits }} {{ $t('processing.credits') }}</span>
                  </div>
                  <p class="credits-description">{{ $t('legacy.Выберите пакет кредитов для ИИ обработки изображений:') }}</p>
                  <div v-if="creditPackagesLoading" class="credits-loading">{{ $t('common.loading') }}</div>
                  <div v-else class="credits-packages">
                    <div 
                      v-for="pkg in creditPackages" 
                      :key="pkg.id" 
                      class="credits-package"
                      :class="{ 'selected': selectedCreditPackage === pkg.id }"
                      @click="selectedCreditPackage = pkg.id"
                    >
                      <div class="package-credits">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#f59e0b"/>
                        </svg>
                        <span>{{ pkg.credits }} {{ $t('processing.credits') }}</span>
                      </div>
                      <div class="package-price">{{ pkg.price }} ₽</div>
                      <div v-if="pkg.price_usd" class="package-price">{{ $formatCurrency(pkg.price_usd, 'USD') }} · Prodamus</div>
                    </div>
                  </div>
                </div>
                <div class="credits-modal-footer">
                  <button class="credits-btn credits-btn-cancel" @click="closeBuyCreditsModal">{{ $t('common.cancel') }}</button>
                  <button 
                    class="credits-btn credits-btn-buy" 
                    @click="proceedToCreditsPurchase"
                    :disabled="!selectedCreditPackage"
                  >
                    {{ $t('legacy.Купить') }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Konva Editor (Mobile & Desktop) -->
            <MobileKonvaEditor
              ref="konvaEditor"
              v-if="useKonvaEditor"
              :transform-mode="transformMode"
              :lock-aspect="lockAspect"
              :elements="droppedImages"
              :groups="groups"
              :canvas-width="canvasBaseWidth"
              :canvas-height="canvasBaseHeight"
              :aspect-ratio="4/3"
              :selection-mode="isSelectionMode"
              :pan-mode="canvasPanMode"
              :eraser-enabled="eraserEnabled"
              :eraser-size="eraserSize"
              :eraser-mode="eraserMode"
              :background="zoneBackground"
              :viewport-key="activeZoneId"
              :excluded-items="konvaExcludedItems"
              :highlighted-item-id="highlightedCalculatorItemId"
              @update:elements="handleKonvaElementsUpdate"
              @update:groups="handleKonvaGroupsUpdate"
              @element-selected="handleKonvaElementSelected"
              @element-deleted="handleKonvaElementDeleted"
              @group-selected="handleKonvaGroupSelected"
              @group-deleted="handleKonvaGroupDeleted"
              @create-group="handleKonvaCreateGroup"
              @selection-complete="handleKonvaSelectionComplete"
              @viewport-change="handleCanvasViewportChange"
              @exit-pan="canvasPanMode = false"
              @exit-eraser="eraserEnabled=false"
              @save-history="saveHistoryState"
            />

            <!-- DOM Editor (fallback when Konva disabled) -->
            <template v-if="!useKonvaEditor">
            <!-- Цветовые элементы -->
            <template v-for="(item, index) in visibleDroppedImages.filter((img) => img?.isColor)">
              <div v-if="item?.isColor" :key="`bg-color-${index}`" class="background-color" :style="{ backgroundColor: item?.color }" />
            </template>

            <!-- Unified canvas items (groups and elements sorted by zIndex) -->
            <template v-for="canvasItem in sortedCanvasItems" :key="`${canvasItem.type}-${canvasItem.data.id}-z${canvasItem.zIndex}`">
              <!-- Group rendering -->
              <template v-if="canvasItem.type === 'group'">
                <div class="group-container" :ref="(el) => setGroupContainerRef(el, canvasItem.data.id)" :data-group-id="canvasItem.data.id" :class="{ active: activeGroup === canvasItem.data.id, locked: canvasItem.data.locked }" :style="getGroupStyleWithoutRotate(canvasItem.data)" @click.stop="selectGroup(canvasItem.data.id)" @touchend.stop="selectGroup(canvasItem.data.id)">
                  <div
                    class="group-rotatable-block"
                    :style="{
                      width: '100%',
                      height: '100%',
                      position: 'relative',
                    }"
                  >
                    <template v-if="activeGroup === canvasItem.data.id && showControls && !canvasItem.data.locked">
                      <div
                        v-for="handle in ['right', 'left', 'bottom', 'top', 'top-right', 'top-left', 'bottom-left', 'bottom-right']"
                        :key="handle"
                        class="resize-handle"
                        :class="[`resize-handle-${handle}`, { 'resize-handle-active': activeResizeHandle === `group-${handle}` }]"
                        @mousedown.stop="startGroupResize(canvasItem.data, $event, handle)"
                        @touchstart.stop.prevent="handleGroupResizeHandleTap(canvasItem.data, $event, handle)"
                      ></div>
                    </template>
                    <template v-for="itemId in canvasItem.data.items.filter(id => !calculatorExcludedItems.includes(id))">
                      <div
                        v-for="(item, index) in visibleDroppedImages.filter((i) => i?.id === itemId)"
                        :key="getItemKey(item, index)"
                        class="grouped-item"
                        :style="getGroupedItemStyle(item, canvasItem.data)"
                        @mousedown.stop="(e) => startGroupDrag(canvasItem.data, e, $refs.contentRef)"
                        @touchstart.stop="(e) => startGroupDrag(canvasItem.data, e, $refs.contentRef)"
                        @click="closeAllMenus"
                      >
                        <template v-if="item.type === 'text'">
                          <AppTextElement :item="item" :active="false" :show-controls="false" :locked="item.locked || canvasItem.data.locked" :in-group="true" :scale="currentScale" />
                        </template>
                        <img v-else-if="item?.src" :src="item.src" alt="Grouped element" :style="getGroupedImageStyle(item, canvasItem.data)" />
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <!-- Element rendering (not in group) -->
              <template v-else-if="canvasItem.type === 'element'">
              <!-- Текст -->
              <template v-if="canvasItem.data.type === 'text'">
                <AppTextElement
                  :style="isSelectionMode ? 'pointer-events: none' : ''"
                  :item="canvasItem.data"
                  :active="activeItemId === canvasItem.data.id"
                  :show-controls="showControls"
                  :locked="canvasItem.data.locked"
                  :is-mobile="isMobile"
                  :scale="currentScale"
                  :filters-list="filtersList"
                  :settings-icon="settingsIcon"
                  :get-filter-label="getFilterLabel"
                  :get-slider-style="getSliderStyle"
                  :handle-filter-change="handleFilterChange"
                  :apply-filters-to-dom="applyFiltersToDom"
                  @select-item="handleItemClick"
                  @update-text="updateTextContent"
                  @copy-item="handleCopyItem"
                  @update-rotation="rotateItem"
                  @delete-item="deleteItem"
                  @update-position="updateItemPosition"
                  @update-size-position="updateItemSize"
                  @update:text="updateText(canvasItem.data.id, $event)"
                  @update:color="handleTextColorChange"
                  @update:textShadow="(id, shadow) => handleTextShadowChange(id, shadow)"
                  @move-layer="changeZIndex($event, canvasItem.data.id)"
                  @click.stop="handleItemClick(canvasItem.data?.id, $event)"
                />
              </template>

              <div
                v-if="canvasItem.data?.src && canvasItem.data.type !== 'text' && !canvasItem.data.isColor"
                class="dropped-image-container"
                :ref="(el) => setItemContainerRef(el, canvasItem.data.id)"
                :data-item-id="canvasItem.data.id"
                :class="{
                  active: isItemActive(canvasItem.data),
                  selected: selectedItems.includes(canvasItem.data.id),
                  'show-controls': isItemActive(canvasItem.data) && showControls,
                  locked: canvasItem.data?.locked,
                  'is-background-container': canvasItem.data._isBackground,
                  'calculator-highlight': highlightedCalculatorItemId === canvasItem.data.id,
                }"
                :style="[getItemStyle(canvasItem.data), hideActiveElement && activeItemId === canvasItem.data.id ? { display: 'none' } : {}, isSelectionMode ? 'pointer-events: none' : '']"
                @click.stop="handleItemClick(canvasItem.data?.id, $event)"
                @touchend.stop="handleItemClick(canvasItem.data?.id, $event)"
              >
                <!-- Внутренний контейнер с ресайз хендлами (вращение теперь на родителе) -->
                <div
                  class="rotatable-block"
                >
                  <!-- Картинка -->
                  <img
                    :src="canvasItem.data.src"
                    alt="Content element"
                    :class="{ 'with-border': activeItemId === canvasItem.data.id && showControls }"
                    :style="{
                      ...getImageStyle(canvasItem.data),
                    }"
                    :data-image-id="canvasItem.data.id"
                    @mousedown="handleItemMouseDown(canvasItem.data, $event)"
                    @touchstart.stop="handleItemMouseDown(canvasItem.data, $event)"
                    @touchend.stop="handleItemClick(canvasItem.data.id, $event)"
                    @click.stop="closeAllMenus"
                  />

                  <!-- Ресайз хендлы (внутри rotatable-block, вращаются вместе с элементом) -->
                  <!-- Показываем точки resize при выделении элемента (на всех устройствах) -->
                  <template v-if="activeItemId === canvasItem.data?.id && showControls && !canvasItem.data?.locked && canvasItem.data?.type !== 'text'">
                    <div
                      v-for="handle in ['right', 'left', 'bottom', 'top', 'top-right', 'top-left', 'bottom-left', 'bottom-right']"
                      :key="handle"
                      class="resize-handle"
                      :class="[`resize-handle-${handle}`, { 'resize-handle-active': activeResizeHandle === handle }]"
                      @mousedown.stop="startResize(canvasItem.data, $event, handle)"
                      @touchstart.stop.prevent="handleResizeHandleTap(canvasItem.data, $event, handle)"
                    ></div>
                  </template>
                </div>

                <!-- Контролы (не вращаются) -->
                <div v-if="!isMobile && activeItemId === canvasItem.data?.id && showControls && canvasItem.data?.type !== 'text'" class="item-controls">
                  <div class="images-buttons" :class="{ 'toolbar-below': shouldShowToolbarBelow(canvasItem.data) }">
                    <img :src="keyIcon" @touchend.stop="toggleLock(canvasItem.data.id)" @click.stop="toggleLock(canvasItem.data.id)" :class="{ active: canvasItem.data.locked }" />
                    <img :src="copyIcon" @touchend.stop="copyItem(canvasItem.data.id)" @click.stop="copyItem(canvasItem.data.id)" />
                    <img :src="mirrorIcon" @touchend.stop="mirrorFun(canvasItem.data.id)" @click.stop="mirrorFun(canvasItem.data.id)" v-if="canvasItem.data.type !== 'text'" />

                    <div class="indexIcon" :class="{ 'is-active': activeControlButton === 'opacity' }">
                      <img :src="indexIcon" @click.stop="handleControlButtonClick('opacity')" />
                      <div class="index-block-input">
                        <div class="index-inputs-block">
                          <span class="index-text">{{ $t('legacy.Прозрачность') }}</span>
                          <input
                            type="range"
                            class="index-input"
                            :value="Math.round((canvasItem.data.opacity ?? 1) * 100)"
                            @input="handleOpacityInput($event, canvasItem.data.id)"
                            min="0"
                            max="100"
                            step="1"
                            :style="getSliderStyle(canvasItem.data)"
                          />
                          <span class="index-number">{{ Math.round((canvasItem.data.opacity ?? 1) * 100) }}%</span>
                        </div>
                      </div>
                    </div>

                    <!-- Скрыто: кнопки порядка слоёв для объектов
                    <div class="layers-control" :class="{ 'is-active': activeControlButton === 'layers' }">
                      <img :src="layersIcon" @click.stop="handleControlButtonClick('layers')" />
                      <div class="layers-menu">
                        <div @click.stop="changeZIndex('front', canvasItem.data.id)"><img :src="upFull" /> {{ $t('legacy.На передний план') }}</div>
                        <div @click.stop="changeZIndex('up', canvasItem.data.id)"><img :src="up" /> {{ $t('editor.moveUp') }}</div>
                        <div @click.stop="changeZIndex('down', canvasItem.data.id)"><img :src="down" /> {{ $t('editor.moveDown') }}</div>
                        <div @click.stop="changeZIndex('back', canvasItem.data.id)"><img :src="downFull" /> {{ $t('legacy.На задний план') }}</div>
                      </div>
                    </div>
                    -->

                    <div class="settings-block" :class="{ 'is-active': activeControlButton === 'settings' }">
                      <img :src="settingsIcon" alt="settings" class="settings-icon" @click.stop="handleControlButtonClick('settings')" />
                      <div class="settings-inputs">
                        <div class="settings-inputs-block" v-for="filter in filtersList" :key="filter.name">
                          <span class="settings-text">{{ getFilterLabel(filter.name) }}</span>
                          <input
                            type="range"
                            class="settings-input"
                            :style="getFilterSliderStyle(canvasItem.data.filters[filter.name] || 0, filter.min, filter.max)"
                            @input="(e) => handleFilterChange(e, canvasItem.data.id, filter.name)"
                            @change="applyFiltersToDom(canvasItem.data.id)"
                            :min="filter.min"
                            :max="filter.max"
                            :step="filter.step"
                            :value="Math.round(canvasItem.data.filters[filter.name]) || 0"
                          />
                          <span class="settings-number">{{ Math.round(canvasItem.data.filters[filter.name] > 100 ? 100 : canvasItem.data.filters[filter.name]) || 0 }}</span>
                        </div>
                      </div>
                    </div>

                    <img :src="rotate" @touchend.stop="rotateItem(canvasItem.data.id)" @click.stop="rotateItem(canvasItem.data.id)" class="rotate-icon" />
                    <img :src="deleteElement" @touchend.stop="deleteItem(canvasItem.data.id)" @click.stop="deleteItem(canvasItem.data.id)" class="delete-icon" />
                  </div>

                  <AppClockRotatePicker
                    v-if="showRotateClock && selectedRotateItemId === canvasItem.data.id"
                    :initialAngle="getItemRotation(canvasItem.data.id)"
                    @start="saveHistoryState"
                    @update="setItemRotation"
                    @close="showRotateClock = false"
                  />
                </div>
              </div>
            </template>
            </template><!-- End sortedCanvasItems loop -->
            </template><!-- End Desktop/DOM Editor -->
          </div>
        </div>

        </div>
      </div>

    <!-- Desktop Toolbar Sidebar -->
    <DesktopToolbarSidebar
      v-if="!isMobile"
      :selection-type="sidebarSelectionType"
      :is-locked="sidebarIsLocked"
      :opacity="sidebarOpacity"
      :rotation="sidebarRotation"
      :filters="sidebarFilters"
      :text-color="sidebarTextColor"
      :text-shadow="sidebarTextShadow"
      :filters-list="filtersList"
      :fonts="allFonts"
      :current-font="sidebarCurrentFont"
      :font-size="sidebarFontSize"
      :project-colors="sidebarProjectColors"
      :can-undo="canUndo"
      :can-redo="canRedo"
      :can-use-ai="canUseAi"
      :zone-total-price="currentZoneTotal"
      :project-total-price="totalProjectPrice"
      :can-see-prices="canSeePrices"
      :can-use-calculator="canUseCalculator"
      :calculator-panel-open="showCalculatorPanel"
      @toggle-lock="handleSidebarToggleLock"
      @copy="handleSidebarCopy"
      @mirror="handleSidebarMirror"
      @undo="handleUndo"
      @redo="handleRedo"
      @update-rotation="handleSidebarUpdateRotation"
      @update-opacity="handleSidebarUpdateOpacity"
      @move-layer="handleSidebarMoveLayer"
      @update-filter="handleSidebarUpdateFilter"
      @update-color="handleSidebarColorChange"
      @update-font="handleSidebarFontChange"
      @update-font-size="handleSidebarFontSizeChange"
      @toggle-shadow="handleSidebarToggleShadow"
      @ungroup="handleSidebarUngroup"
      @delete="handleSidebarDelete"
      @toggle-selection-mode="toggleSelectionMode"
      @open-background="openBackgroundModal"
      @open-layers="openLayersPanel"
      @save="openSaveModal"
      @download="startDownload"
      @ai-process="openAIProcessing"
      @export-pdf="handleExportPDF"
      @export-excel="handleExportExcel"
      @clear-all="openClearModal"
      @delete-zone="deleteCurrentZone"
      @open-calculator="openCalculatorPanel"
    >
      <template v-if="useKonvaEditor" #transform-tools>
        <TransformTools :mode="transformMode" :lock-aspect="lockAspect"
          :has-perspective="selectedHasPerspective" :disabled="sidebarIsLocked || isSelectionMode"
          @update-mode="transformMode = $event" @update-lock="lockAspect = $event"
          @reset="$refs.konvaEditor?.resetPerspective()" />
      </template>
      <template v-if="useKonvaEditor" #eraser-tools>
        <EraserTools
          :enabled="eraserEnabled"
          :size="eraserSize"
          :mode="eraserMode"
          :disabled="sidebarIsLocked || isSelectionMode"
          @toggle="handleEraserToggle"
          @update-mode="handleEraserModeUpdate"
          @update-size="handleEraserSizeUpdate"
        />
      </template>
    </DesktopToolbarSidebar>

      <!-- Мобильная панель инструментов элемента (показывается когда элемент выбран в Konva редакторе) -->
      <div v-if="isMobile && useKonvaEditor && (activeItemId !== null || activeGroup) && showControls && !isSelectionMode" class="mobile-element-toolbar">
        <!-- Для обычных элементов -->
        <template v-if="activeItemId !== null && !activeGroup && activeItemData">
          <div :key="activeItemData.id" class="toolbar-content">
            <img :src="keyIcon" @touchend.stop.prevent="toggleLock(activeItemData.id)" @click.stop="toggleLock(activeItemData.id)" :class="{ active: activeItemData.locked }" />
            <img :src="copyIcon" @touchend.stop.prevent="copyItem(activeItemData.id)" @click.stop="copyItem(activeItemData.id)" />
            <img :src="mirrorIcon" @touchstart.prevent.stop="mirrorFun(activeItemData.id)" @click.stop="mirrorFun(activeItemData.id)" v-if="activeItemData.type !== 'text'" />

            <div class="indexIcon" :class="{ 'is-active': showOpacitySheet }">
              <img :src="indexIcon" @touchend.stop.prevent="openOpacitySheet" @click.stop="openOpacitySheet" />
            </div>

            <div class="rotateIcon" :class="{ 'is-active': showRotationSheet }">
              <img :src="rotate" @touchend.stop.prevent="openRotationSheet" @click.stop="openRotationSheet" />
            </div>

            <img :src="up" @touchend.stop.prevent="changeZIndex('up', activeItemData.id)" @click.stop="changeZIndex('up', activeItemData.id)" class="layer-up-icon" :title="$t('legacy.Поднять слой')" />
            <img :src="down" @touchend.stop.prevent="changeZIndex('down', activeItemData.id)" @click.stop="changeZIndex('down', activeItemData.id)" class="layer-down-icon" :title="$t('legacy.Опустить слой')" />

            <!-- Text-specific controls: color picker and shadow -->
            <template v-if="activeItemData.type === 'text'">
              <div
                v-if="activeControlButton === 'color'"
                class="settings-backdrop-transparent"
                @touchend.stop="handleControlButtonClick('color')"
                @click.stop="handleControlButtonClick('color')"
              ></div>

              <div class="color-block" :class="{ 'is-active': activeControlButton === 'color' }">
                <div class="color-preview-button" @touchend.stop="handleControlButtonClick('color')" @click.stop="handleControlButtonClick('color')" :style="{ backgroundColor: activeItemData.color || '#000000' }"></div>
                <div class="color-picker-sheet">
                  <AppColorPicker
                    :model-value="activeItemData.color || '#000000'"
                    @update:model-value="(color) => setTextColor(activeItemData.id, color)"
                    :is-bottom-sheet="true"
                    :title="$t('legacy.Цвет текста')"
                  />
                </div>
              </div>

              <img :src="shadowIcon" @touchstart.stop.prevent @touchend.stop.prevent="toggleMobileTextShadow(activeItemData.id)" @click.stop="toggleMobileTextShadow(activeItemData.id)" class="shadow-icon" :class="{ active: activeItemData.textShadow }" />

              <!-- Font size control -->
              <div
                v-if="mobileFontSizePanelOpen"
                class="settings-backdrop-transparent"
                @touchend.stop="mobileFontSizePanelOpen = false"
                @click.stop="mobileFontSizePanelOpen = false"
              ></div>
              
              <div class="font-size-block" :class="{ 'is-active': mobileFontSizePanelOpen }">
                <div class="font-size-button" @touchend.stop.prevent="mobileFontSizePanelOpen = !mobileFontSizePanelOpen" @click.stop="mobileFontSizePanelOpen = !mobileFontSizePanelOpen">
                  {{ activeItemData.fontSize || 32 }}
                </div>
                <div class="font-size-picker-sheet">
                  <div class="font-size-picker-header">
                    <span class="font-size-picker-title">{{ $t('legacy.Размер шрифта') }}</span>
                    <button class="font-size-picker-close" @touchend.stop="mobileFontSizePanelOpen = false" @click.stop="mobileFontSizePanelOpen = false">×</button>
                  </div>
                  <div class="font-size-picker-content">
                    <input
                      type="range"
                      class="font-size-slider"
                      :value="activeItemData.fontSize || 32"
                      @input="handleMobileFontSizeChange($event, activeItemData.id)"
                      min="12"
                      max="360"
                      step="1"
                      :style="getFontSizeSliderStyle(activeItemData.fontSize || 32)"
                    />
                    <div class="font-size-value">{{ activeItemData.fontSize || 32 }}px</div>
                  </div>
                </div>
              </div>

              <!-- Font selection button -->
              <div
                v-if="mobileFontPanelOpen"
                class="settings-backdrop-transparent"
                @touchend.stop="mobileFontPanelOpen = false"
                @click.stop="mobileFontPanelOpen = false"
              ></div>

              <div class="font-block" :class="{ 'is-active': mobileFontPanelOpen }">
                <div class="font-button" @touchend.stop.prevent="mobileFontPanelOpen = !mobileFontPanelOpen" @click.stop="mobileFontPanelOpen = !mobileFontPanelOpen">
                  Тт
                </div>
                <div class="font-picker-sheet">
                  <div class="font-picker-header">
                    <span class="font-picker-title">{{ $t('legacy.Выбор шрифта') }}</span>
                    <button class="font-picker-close" @touchend.stop="mobileFontPanelOpen = false" @click.stop="mobileFontPanelOpen = false">×</button>
                  </div>
                  <div class="font-picker-list">
                    <template v-if="userFonts.length > 0">
                      <div class="font-picker-section-header">{{ $t('legacy.Мои шрифты') }}</div>
                      <div
                        v-for="font in allFonts.filter(f => f.isUserFont)"
                        :key="'user-' + font.family"
                        class="font-picker-item user-font-item"
                        :class="{ active: activeItemData.fontName === font.family }"
                        :style="{ fontFamily: font.family }"
                        @touchstart.stop="handleFontTouchStart($event)"
                        @touchend.stop="handleFontTouchEnd($event, activeItemData.id, font)"
                        @click.stop="applyFontToText(activeItemData.id, font)"
                      >
                        {{ font.family }}
                      </div>
                      <div class="font-picker-section-header">Google Fonts</div>
                    </template>
                    <div
                      v-for="font in allFonts.filter(f => !f.isUserFont)"
                      :key="font.family"
                      class="font-picker-item"
                      :class="{ active: activeItemData.fontName === font.family }"
                      :style="{ fontFamily: font.family + ', ' + font.category }"
                      @touchstart.stop="handleFontTouchStart($event)"
                      @touchend.stop="handleFontTouchEnd($event, activeItemData.id, font)"
                      @click.stop="applyFontToText(activeItemData.id, font)"
                    >
                      {{ font.family }}
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div
              v-if="activeControlButton === 'settings'"
              class="settings-backdrop-transparent"
              @touchend.stop="handleControlButtonClick('settings')"
              @click.stop="handleControlButtonClick('settings')"
            ></div>

            <div v-if="activeItemData.type !== 'text'" class="settings-block" :class="{ 'is-active': activeControlButton === 'settings' }">
              <img :src="settingsIcon" alt="settings" class="settings-icon" @touchend.stop="handleControlButtonClick('settings')" @click.stop="handleControlButtonClick('settings')" />
              <div class="settings-inputs">
                <div class="settings-inputs-block" v-for="filter in filtersList" :key="filter.name">
                  <span class="settings-text">{{ getFilterLabel(filter.name) }}</span>
                  <input
                    type="range"
                    class="settings-input"
                    :style="getFilterSliderStyle(activeItemData.filters[filter.name] || 0, filter.min, filter.max)"
                    @input="(e) => handleFilterChange(e, activeItemData.id, filter.name)"
                    @change="applyFiltersToDom(activeItemData.id)"
                    :min="filter.min"
                    :max="filter.max"
                    :step="filter.step"
                    :value="Math.round(activeItemData.filters[filter.name]) || 0"
                  />
                  <span class="settings-number">{{ Math.round(activeItemData.filters[filter.name] > 100 ? 100 : activeItemData.filters[filter.name]) || 0 }}</span>
                </div>
              </div>
            </div>

            <EraserToolsButton
              mode="erase"
              :disabled="sidebarIsLocked || isSelectionMode"
              :expanded="eraserEnabled && eraserMode === 'erase'"
              @open="openEraserSheet"
            />
            <EraserToolsButton
              mode="restore"
              :disabled="sidebarIsLocked || isSelectionMode"
              :expanded="eraserEnabled && eraserMode === 'restore'"
              @open="openEraserSheet"
            />
            <TransformToolsButton :disabled="sidebarIsLocked" :expanded="showTransformSheet" @open="openTransformSheet" />
            <img :src="deleteElement" @touchend.stop.prevent="deleteItem(activeItemData.id)" @click.stop="deleteItem(activeItemData.id)" class="delete-icon" />
          </div>
        </template>

        <!-- Для групп -->
        <template v-if="activeGroup && activeItemId === null">
          <div v-for="group in groups.filter((g) => g.id === activeGroup)" :key="group.id" class="toolbar-content">
            <img :src="keyIcon" @touchend.stop.prevent="toggleGroupLock(group.id)" @click.stop="toggleGroupLock(group.id)" :class="{ active: group.locked }" />
            <img :src="copyIcon" @touchend.stop.prevent="copyGroup(group.id)" @click.stop="copyGroup(group.id)" />
            <img :src="mirrorIcon" @touchend.stop.prevent="mirrorGroup(group.id)" @click.stop="mirrorGroup(group.id)" />

            <div class="indexIcon" :class="{ 'is-active': showOpacitySheet }">
              <img :src="indexIcon" @touchend.stop.prevent="openOpacitySheet" @click.stop="openOpacitySheet" />
            </div>

            <div class="rotateIcon" :class="{ 'is-active': showRotationSheet }">
              <img :src="rotate" @touchend.stop.prevent="openRotationSheet" @click.stop="openRotationSheet" />
            </div>

            <img :src="up" @touchend.stop.prevent="changeGroupZIndex('up', group.id)" @click.stop="changeGroupZIndex('up', group.id)" class="layer-up-icon" :title="$t('legacy.Поднять слой')" />
            <img :src="down" @touchend.stop.prevent="changeGroupZIndex('down', group.id)" @click.stop="changeGroupZIndex('down', group.id)" class="layer-down-icon" :title="$t('legacy.Опустить слой')" />

            <!-- Скрыто: фильтры для группы
            <div
              v-if="activeControlButton === 'settings'"
              class="settings-backdrop-transparent"
              @touchend.stop="handleControlButtonClick('settings')"
              @click.stop="handleControlButtonClick('settings')"
            ></div>

            <div class="settings-block" :class="{ 'is-active': activeControlButton === 'settings' }">
              <img :src="settingsIcon" alt="settings" class="settings-icon" @touchend.stop="handleControlButtonClick('settings')" @click.stop="handleControlButtonClick('settings')" />
              <div class="settings-inputs">
                <div class="settings-inputs-block" v-for="filter in filtersList" :key="filter.name">
                  <span class="settings-text">{{ getFilterLabel(filter.name) }}</span>
                  <input
                    type="range"
                    class="settings-input"
                    :style="getFilterSliderStyle(group.filters ? group.filters[filter.name] || 0 : 0, filter.min, filter.max)"
                    @input="(e) => handleGroupFilterChange(e, group.id, filter.name)"
                    @change="applyGroupFiltersToDom(group.id)"
                    :min="filter.min"
                    :max="filter.max"
                    :step="filter.step"
                    :value="group.filters ? group.filters[filter.name] || 0 : 0"
                  />
                  <span class="settings-number">{{ group.filters ? group.filters[filter.name] || 0 : 0 }}</span>
                </div>
              </div>
            </div>
            -->

            <svg class="copy-group-icon" @touchend.stop="copyGroup(group.id)" @click.stop="copyGroup(group.id)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :title="$t('editor.copyGroup')">
              <rect x="9" y="9" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5"/>
              <path d="M5 15V6C5 5.44772 5.44772 5 6 5H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <svg class="ungroup-icon" @touchend.stop="ungroupElements(group.id)" @click.stop="ungroupElements(group.id)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :title="$t('legacy.Разгруппировать')">
              <rect x="3" y="3" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <rect x="13" y="13" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <path d="M11 7L13 7M17 11L17 13M7 11L7 13M11 17L13 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <EraserToolsButton
              mode="erase"
              :disabled="sidebarIsLocked || isSelectionMode"
              :expanded="eraserEnabled && eraserMode === 'erase'"
              @open="openEraserSheet"
            />
            <EraserToolsButton
              mode="restore"
              :disabled="sidebarIsLocked || isSelectionMode"
              :expanded="eraserEnabled && eraserMode === 'restore'"
              @open="openEraserSheet"
            />
            <TransformToolsButton :disabled="sidebarIsLocked" :expanded="showTransformSheet" @open="openTransformSheet" />
            <img :src="deleteElement" @touchend.stop="deleteGroupWithItems(group.id)" @click.stop="deleteGroupWithItems(group.id)" class="delete-icon" />
          </div>
        </template>
      </div>

      <!-- Mobile Bottom Sheet для прозрачности -->
      <Teleport to="body">
        <div v-if="showOpacitySheet && isMobile" class="sheet-backdrop" @click="closeOpacitySheet" @touchend.prevent="closeOpacitySheet"></div>
        <RotationOpacitySheet
          v-if="showOpacitySheet && isMobile"
          :title="$t('legacy.Прозрачность')"
          :value="currentOpacityValue"
          :min="0"
          :max="100"
          :step="1"
          suffix="%"
          :is-percentage="true"
          @update="handleSheetOpacityUpdate"
          @start="saveHistoryState"
          @close="closeOpacitySheet"
        />
      </Teleport>

      <Teleport to="body">
        <div v-if="showTransformSheet && isMobile && (activeItemId !== null || activeGroup) && showControls && !isSelectionMode"
          class="transform-sheet-backdrop" @click.self="showTransformSheet = false" @keydown.esc="showTransformSheet = false">
          <section class="transform-sheet" role="dialog" aria-modal="true" :aria-label="$t('editor.transformTools')">
            <header>
              <strong>{{ $t('editor.transformTools') }}</strong>
              <button type="button" :aria-label="$t('common.close')" @click="showTransformSheet = false">&times;</button>
            </header>
            <TransformTools :mode="transformMode" :lock-aspect="lockAspect" :has-perspective="selectedHasPerspective"
              :disabled="sidebarIsLocked || isSelectionMode"
              @update-mode="chooseTransformMode" @update-lock="lockAspect = $event"
              @reset="$refs.konvaEditor?.resetPerspective()" />
          </section>
        </div>
      </Teleport>

      <Teleport to="body">
        <div
          v-if="showEraserSheet && isMobile && (activeItemId !== null || activeGroup) && showControls && !isSelectionMode"
          class="transform-sheet-backdrop eraser-sheet-backdrop"
          @keydown.esc="closeEraserSheet"
        >
          <section class="transform-sheet" role="dialog" aria-modal="false" :aria-label="$t(eraserMode === 'restore' ? 'editor.repairBrush' : 'editor.eraserTools')"
            @pointerdown.stop @touchstart.stop @click.stop>
            <header>
              <strong>{{ $t(eraserMode === 'restore' ? 'editor.repairBrush' : 'editor.eraserTools') }}</strong>
              <button type="button" :aria-label="$t('common.close')" @click="closeEraserSheet">&times;</button>
            </header>
            <EraserTools
              :mobile="true"
              :enabled="eraserEnabled"
              :size="eraserSize"
              :mode="eraserMode"
              :disabled="sidebarIsLocked || isSelectionMode"
              @toggle="handleEraserToggle"
              @update-mode="handleEraserModeUpdate"
              @update-size="handleEraserSizeUpdate"
            />
          </section>
        </div>
      </Teleport>

      <!-- Mobile Bottom Sheet для поворота -->
      <Teleport to="body">
        <div v-if="showRotationSheet && isMobile" class="sheet-backdrop" @click="closeRotationSheet" @touchend.prevent="closeRotationSheet"></div>
        <RotationOpacitySheet
          v-if="showRotationSheet && isMobile"
          :title="$t('legacy.Поворот')"
          :value="currentRotationValue"
          :min="0"
          :max="360"
          :step="1"
          suffix="°"
          :is-percentage="false"
          @update="handleSheetRotationUpdate"
          @start="saveHistoryState"
          @close="closeRotationSheet"
        />
      </Teleport>


      <!-- Мобильная панель слоёв (Bottom Sheet) -->
      <Teleport to="body">
        <div v-if="showLayersPanel && isMobile" class="layers-bottom-sheet" :style="{ maxHeight: layersPanelMaxHeight }">
          <div class="layers-bottom-sheet-header">
            <div class="layers-bottom-sheet-title-row">
              <span class="layers-bottom-sheet-title">{{ $t('legacy.Слои') }}</span>
            </div>
            <button class="layers-bottom-sheet-close" @click="closeLayersPanel">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <!-- Кнопка калькулятора и цены убраны из мобильной шторки слоёв -->
          <button v-if="false && canUseCalculator" class="calculator-open-btn" @click="openCalculatorPanel">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" stroke-width="2"/>
              <line x1="8" y1="6" x2="16" y2="6" stroke="currentColor" stroke-width="2"/>
              <circle cx="8" cy="11" r="1" fill="currentColor"/>
              <circle cx="12" cy="11" r="1" fill="currentColor"/>
              <circle cx="16" cy="11" r="1" fill="currentColor"/>
              <circle cx="8" cy="15" r="1" fill="currentColor"/>
              <circle cx="12" cy="15" r="1" fill="currentColor"/>
              <circle cx="16" cy="15" r="1" fill="currentColor"/>
              <circle cx="8" cy="19" r="1" fill="currentColor"/>
              <circle cx="12" cy="19" r="1" fill="currentColor"/>
              <circle cx="16" cy="19" r="1" fill="currentColor"/>
            </svg>
            <span>{{ $t('legacy.Калькулятор') }}</span>
          </button>
          <div class="layers-bottom-sheet-list">
            <div v-if="groupedLayersList.length === 0" class="layers-empty">
              {{ $t('legacy.Нет элементов') }}
            </div>
            <template v-for="item in groupedLayersList" :key="item.id">
              <!-- Group item -->
              <div 
                v-if="item.isGroup"
                class="layers-bottom-sheet-group"
                :class="{ 
                  'is-active': activeGroup === item.id, 
                  'is-expanded': item.expanded,
                  'is-dragging': mobileDragLayerId === item.id,
                  'drag-over': mobileDragOverId === item.id && mobileDragLayerId !== item.id
                }"
                :data-group-id="item.id"
                draggable="true"
                @dragstart="handleMobileLayerDragStartById($event, item.id)"
                @dragend="handleMobileLayerDragEnd"
                @dragover.prevent="handleMobileLayerDragOverById(item.id)"
                @dragleave="mobileDragOverId = null"
                @drop.prevent="handleMobileLayerDropById(item.id)"
              >
                <div class="layers-bottom-sheet-group-header">
                  <div 
                    class="layer-drag-handle"
                    @touchstart.stop="handleMobileLayerTouchStartById($event, item.id)"
                  >
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor">
                      <circle cx="2" cy="2" r="1.5"/>
                      <circle cx="6" cy="2" r="1.5"/>
                      <circle cx="2" cy="7" r="1.5"/>
                      <circle cx="6" cy="7" r="1.5"/>
                      <circle cx="2" cy="12" r="1.5"/>
                      <circle cx="6" cy="12" r="1.5"/>
                    </svg>
                  </div>
                  <div class="group-header-content" @click="toggleGroupExpand(item.id)">
                    <svg class="group-expand-icon" :class="{ rotated: item.expanded }" width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
                      <path d="M2 3L5 6L8 3" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                    <svg class="group-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                      <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                      <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                      <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    <span class="layer-name">{{ item.name }}</span>
                    <svg v-if="item.locked" class="lock-icon-small" width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/>
                      <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </div>
                </div>
                <div v-if="item.expanded" class="layers-bottom-sheet-group-children" :data-group-id="item.id">
                  <div 
                    v-for="(child, childIndex) in item.elements" 
                    :key="child.id"
                    class="layers-bottom-sheet-item nested"
                    :data-child-id="child.id"
                    :class="{ 
                      'is-active': activeItemId === child.id,
                      'is-dragging': mobileGroupDragChildId === child.id && mobileGroupDragGroupId === item.id,
                      'drag-over': mobileGroupDragOverChildId === child.id && mobileGroupDragChildId !== child.id && mobileGroupDragGroupId === item.id
                    }"
                    @click="selectLayerItem(child.id)"
                  >
                    <div 
                      class="layer-drag-handle"
                      @touchstart.stop="handleMobileGroupChildTouchStart($event, item.id, child.id, childIndex)"
                    >
                      <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor">
                        <circle cx="2" cy="2" r="1.5"/>
                        <circle cx="6" cy="2" r="1.5"/>
                        <circle cx="2" cy="7" r="1.5"/>
                        <circle cx="6" cy="7" r="1.5"/>
                        <circle cx="2" cy="12" r="1.5"/>
                        <circle cx="6" cy="12" r="1.5"/>
                      </svg>
                    </div>
                    <div class="layer-icon">
                      <img v-if="child.type === 'text' || child.isText" :src="layersIcon" alt="text" class="layer-type-icon" />
                      <img v-else-if="child.src" :src="child.src" alt="" class="layer-thumb" />
                      <div v-else class="layer-placeholder"></div>
                    </div>
                    <span class="layer-name">{{ getLayerName(child) }}</span>
                  </div>
                </div>
              </div>
              <!-- Regular item (ungrouped only) -->
              <div 
                v-else
                class="layers-bottom-sheet-item"
                :class="{ 
                  'is-active': activeItemId === item.id,
                  'is-dragging': mobileDragLayerId === item.id,
                  'drag-over': mobileDragOverId === item.id && mobileDragLayerId !== item.id
                }"
                :data-item-id="item.id"
                draggable="true"
                @dragstart="handleMobileLayerDragStartById($event, item.id)"
                @dragend="handleMobileLayerDragEnd"
                @dragover.prevent="handleMobileLayerDragOverById(item.id)"
                @dragleave="mobileDragOverId = null"
                @drop.prevent="handleMobileLayerDropById(item.id)"
                @click="selectLayerItem(item.id)"
              >
                <div 
                  class="layer-drag-handle"
                  @touchstart.stop="handleMobileLayerTouchStartById($event, item.id)"
                >
                  <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor">
                    <circle cx="2" cy="2" r="1.5"/>
                    <circle cx="6" cy="2" r="1.5"/>
                    <circle cx="2" cy="7" r="1.5"/>
                    <circle cx="6" cy="7" r="1.5"/>
                    <circle cx="2" cy="12" r="1.5"/>
                    <circle cx="6" cy="12" r="1.5"/>
                  </svg>
                </div>
                <div class="layer-icon">
                  <img v-if="item.type === 'text' || item.isText" :src="layersIcon" alt="text" class="layer-type-icon" />
                  <img v-else-if="item.src" :src="item.src" alt="" class="layer-thumb" />
                  <div v-else class="layer-placeholder"></div>
                </div>
                <span class="layer-name">{{ getLayerName(item) }}</span>
              </div>
            </template>
          </div>
        </div>
      </Teleport>

      <!-- Мобильная панель калькулятора (Bottom Sheet) -->
      <Teleport to="body">
        <div v-if="showCalculatorPanel && isMobile" class="calculator-bottom-sheet" :style="{ maxHeight: layersPanelMaxHeight }">
          <CalculatorPanel
            :items="layersList"
            :can-see-prices="canSeePrices"
            @close="closeCalculatorPanel"
            @highlight-item="handleCalculatorHighlight"
            @delete-item="handleCalculatorDelete"
            @update-excluded="handleCalculatorExcludedUpdate"
            @refresh-prices="refreshAllPricesFromDB"
          />
        </div>
      </Teleport>
    </div>
  </div>
</template>

<script>
let saveInterval = null;
const SAVE_DELAY = 10000;
const REFERENCE_WIDTH = 1200;
const REFERENCE_HEIGHT = 900;

import { backgroundIcon, collapseRowIcon, glassIcon } from '@/assets/images/category';
import { copyIcon, deleteContent, deleteCONTENT, deleteElement, deleteImage, down, downFull, download, indexIcon, keyIcon, layersIcon, mirrorIcon, rotate, save, settingsIcon, shadowIcon, up, upFull } from '@/assets/images/content';
import { AppClockRotatePicker, AppColorPicker, AppContentSlides, AppGuide, AppHeader, AppSaveProjectModal, AppSaveSuccessModal, AppClearContentModal, AppSidebar, AppTextElement } from '@/components/index';
import BackgroundModal from '@/components/BackgroundModal.vue';
import ExportModal from '@/components/modals/ExportModal.vue';
import DesktopToolbarSidebar from '@/components/DesktopToolbarSidebar.vue';
import EraserTools from '@/components/EraserTools.vue';
import EraserToolsButton from '@/components/EraserToolsButton.vue';
import TransformTools from '@/components/TransformTools.vue';
import TransformToolsButton from '@/components/TransformToolsButton.vue';
import RotationOpacitySheet from '@/components/RotationOpacitySheet.vue';
import CalculatorPanel from '@/components/CalculatorPanel.vue';
import MobileKonvaEditor from '@/components/MobileKonvaEditor.vue';
import CanvasZoomControls from '@/components/CanvasZoomControls.vue';
import { fetchProjectById } from '@/api/projects';
import { getElementsInfo } from '@/api/category';
import axios from 'axios';
import { getFavoriteIds } from '@/api/favorites';
import { getUserFonts } from '@/api/userFonts';
import html2canvas from 'html2canvas';

import { mapActions, mapState, mapGetters } from 'vuex';
import { useDrag, useGroupDrag, useResize } from '../../lib';
import { useHistory } from '../../lib/useHistory';
import { deleteImageById as deleteImageUtil, rotateImage as rotateImageUtil } from '../../lib/image-utils';
import { hasEraser, normalizeEraser } from '@/utils/objectEraser';
import logger from '@/utils/logger';
import { useToast } from 'vue-toastification';
export default {
  components: {
    AppHeader,
    AppContentSlides,
    AppSaveProjectModal,
    AppSidebar,
    AppSaveSuccessModal,
    AppClearContentModal,
    AppGuide,
    AppTextElement,
    AppClockRotatePicker,
    AppColorPicker,
    BackgroundModal,
    ExportModal,
    DesktopToolbarSidebar,
    EraserTools,
    EraserToolsButton,
    TransformTools,
    TransformToolsButton,
    RotationOpacitySheet,
    CalculatorPanel,
    MobileKonvaEditor,
    CanvasZoomControls,
  },
  props: {
    projectId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      keyIcon,
      copyIcon,
      mirrorIcon,
      indexIcon,
      layersIcon,
      settingsIcon,
      shadowIcon,
      up,
      upFull,
      deleteCONTENT,
      down,
      downFull,
      deleteContent,
      deleteElement,
      save,
      download,
      deleteImage,
      rotate,
      backgroundIcon,
      glassIcon,
      collapseRowIcon,
      errorMessage: '',
      successMessage: '',
      activeIcon: null,
      history: null,
      canUndo: false,
      canRedo: false,
      dragHistorySaved: false,
      groupDragHistorySaved: false,
      resizeHistorySaved: false,
      rotationHistorySaved: false,
      opacityHistorySaved: false,
      filterHistorySaved: false,
      showOpacitySheet: false,
      showRotationSheet: false,
      showTransformSheet: false,
      showEraserSheet: false,
      eraserEnabled: false,
      eraserSize: 40,
      eraserMode: 'erase',
      transformMode: 'resize',
      lockAspect: true,
      positionHistorySaved: false,
      sizeHistorySaved: false,
      searchQuery: '',
      favorites: {},
      droppedImages: [],
      textElements: [],
      layerOrderTrigger: 0,
      activeImageId: null,
      idCounter: 0,
      isRangeDragging: false,
      isResizing: false,
      isZoneLoading: false,
      mobileEditMode: 'move', // 'move' или 'resize'
      showExportModal: false,
      exportStatus: 'rendering',
      exportRenderProgress: 0,
      exportUploadProgress: 0,
      exportDownloadUrl: '',
      exportErrorMessage: '',
      activeResizeHandle: null,
      // Konva Editor (Mobile & Desktop)
      useKonvaEditor: true, // Флаг для включения Konva редактора везде
      canvasZoom: 1,
      canvasPanMode: false,
      canvasBaseWidth: REFERENCE_WIDTH, // Базовая ширина canvas для расчётов (синхронизирована с десктопом)
      canvasBaseHeight: 300, // Базовая высота canvas для расчётов
      // Новая упрощённая система взаимодействий (без двойных тапов)
      // activeInteraction отслеживает текущее взаимодействие: move, resize, или null
      activeInteraction: null, // { type: 'move'|'resize', targetId, handle?, startX, startY }
      touchStartTime: 0, // Время начала касания (для определения tap vs drag)
      touchMoved: false, // Было ли движение при касании
      startDrag: null,
      startResize: null,
      guidePages: [
        {
          title: 'Помощь по интерфейсу',
          instructions: ['• Здесь вы можете открыть руководство', '• Ответы на часто задаваемые вопросы', '• Быстрая справка по работе с конструктором'],
          target: '.faq-icon',
          highlight: '.faq-container',
        },
        {
          title: 'Личный кабинет',
          instructions: ['• Мои объекты', '• ИИ обработки', '• Подписка', '• Аккаунт', '• Безопасность'],
          target: '.avatar-icon',
          highlight: '.avatar-container',
        },
        {
          title: 'Выберите другую зону декорирования',
          instructions: ['• В этом поле вы можете сменить зону оформления.', '• После создания первой зоны вы можете создать все остальные либо сохранить только одну.'],
          target: '.slides-container',
          highlight: '.slides-container',
        },
        {
          title: 'Поиск элементов декора',
          instructions: [
            '• Введите в поиске название элемента (например, синяя ваза)',
            '• Выберите нужный элемент из результатов',
            '• В поиске отображаются все элементы без разделения на категории',
            "• Плейсхолдер поиска: 'Поиск элемента'",
          ],
          target: '.search-input',
          highlight: '.search-bar',
        },
        {
          title: 'Меню зоны',
          instructions: [
            '• Нажмите на три точки для открытия меню',
            '• Выделение — режим выделения элементов',
            '• Фон — выбор фона зоны',
            '• Слои — управление слоями элементов',
            '• Сохранить — сохранение проекта',
          ],
          target: '.mobile-menu-dots',
          highlight: '.mobile-menu-dots',
        },
        {
          title: 'Выберите категорию декора',
          instructions: [
            '• Выбирайте категорию для начала оформления',
            '• Внутри каждой категории есть подкатегории элементов',
            '• Элементы разделены по видам, формам и материалам',
            '• Нажмите на иконку категории для выбора',
          ],
          target: '.sidebar-icons',
          highlight: '.sidebar-icons',
        },
        {
          title: 'Выберите подкатегорию элементов декора',
          instructions: [
            '• Нажмите на нужную группу элементов',
            '• Раскроется полный список элементов категории',
            '• Выбирайте элементы по видам, формам или материалам',
            '• Используйте двойной клик для быстрого добавления',
          ],
          target: '.categories',
          highlight: '.sidebar-content',
        },
        {
          title: 'Просмотр добавленных в проект элементов',
          instructions: [
            '• Все выбранные элементы в каждой категории будут видны первыми',
            '• В блоке «В проекте» отображаются добавленные элементы',
            '• Вы можете быстро найти и изменить ранее добавленные элементы',
          ],
          target: '.categories',
          highlight: '.sidebar-content',
        },
        {
          title: 'Измените выбранный элемент',
          instructions: [
            '• Чтобы передвинуть - зажмите элемент и двигайте по рабочему полю',
            '• Для поворота - зажмите круглую стрелку справа вверху от элемента',
            '• Чтобы изменить слои - нажмите на элемент и выберите «слои» в меню',
            '• В меню можно заблокировать, скопировать или отзеркалить элемент',
            '• Для удаления нажмите на корзину',
          ],
          target: '.content-section',
          highlight: '.content-section',
        },
        {
          title: 'Сохраните проект',
          instructions: [
            '• Чтобы сохранить проект нажмите на эту кнопку',
            '• Во всплывающем окне дайте название проекту',
            '• Нажмите «Сохранить» для завершения',
            '• Посмотреть сохранённые проекты можно в «Мои проекты»',
          ],
          target: '.save',
          highlight: '.save',
          arrowDirection: 'down',
        },
        {
          title: 'Сохраните проект на устройство',
          instructions: ['• Чтобы сохранить изображение на ваше устройство', '• Нажмите на эту кнопку', '• Выберите место сохранения', '• Нажмите «Сохранить»'],
          target: '.downloadImage',
          highlight: '.downloadImage',
          arrowDirection: 'down',
        },
        {
          title: 'Удаление',
          instructions: ['• Чтобы удалить все добавленные объекты', '• Нажмите на корзину', '• Все элементы будут удалены с рабочего поля', '• Вы сможете начать создание композиции заново'],
          target: '.deleteContent',
          highlight: '.deleteContent',
          arrowDirection: 'down',
        },
        {
          title: 'Мои проекты',
          instructions: ['• Здесь сохраняются все созданные композиции', '• Если вы создали одну зону - остальные будут пустыми', '• Можно просматривать и редактировать сохраненные проекты'],
          target: '.my-project',
          highlight: '.my-project',
          arrowDirection: 'down',
        },
      ],

      sliderRefs: {
        exposure: null,
        contrast: null,
        saturation: null,
        temperature: null,
        hue: null,
        highlights: null,
        shadows: null,
      },

      shaw: {
        content: true,
        sidebar: true,
      },

      fotozones: [],

      slidesId: null,
      showControls: false,
      contentRef: null,
      projects: [],
      filtersList: [
        { name: 'exposure', label: this.$t('legacy.Экспозиция'), min: -100, max: 100, step: 1 },
        { name: 'contrast', label: this.$t('legacy.Контраст'), min: -100, max: 100, step: 1 },
        { name: 'saturation', label: this.$t('legacy.Насыщенность'), min: -100, max: 100, step: 1 },
        { name: 'temperature', label: this.$t('legacy.Температура'), min: -100, max: 100, step: 1 },
        { name: 'hue', label: this.$t('legacy.Оттенок'), min: -100, max: 100, step: 1 },
        { name: 'highlights', label: this.$t('legacy.Света'), min: -100, max: 100, step: 1 },
        { name: 'shadows', label: this.$t('legacy.Тени'), min: -100, max: 100, step: 1 },
      ],
      colorPresets: [
        '#000000', '#FFFFFF', '#FF0000', '#00FF00', '#0000FF',
        '#FFFF00', '#FF00FF', '#00FFFF', '#FFA500', '#800080',
        '#008000', '#000080', '#808080', '#C0C0C0', '#A52A2A',
      ],
      showSaveModal: false,
      showSuccessModal: false,
      showClearModal: false,
      showBackgroundModal: false,
      showLayersPanel: false,
      showCalculatorPanel: false,
      highlightedCalculatorItemId: null,
      calculatorExcludedItems: [],
      calculatorTotal: 0,
      layersPanelMaxHeight: '60vh',
      mobileDragLayerIndex: null,
      mobileDragOverIndex: null,
      mobileDragLayerId: null,
      mobileDragOverId: null,
      mobileTouchDragId: null,
      mobileTouchStartY: null,
      mobileGroupDragGroupId: null,
      mobileGroupDragChildId: null,
      mobileGroupDragChildIndex: null,
      mobileGroupDragOverChildId: null,
      mobileGroupDragStartY: null,
      mobileGroupDragStarted: false,
      mobileTouchDragIndex: null,
      mobileDragStarted: false,
      showUtilsMenu: false,
      currentProject: null,
      showContentSlides: false,
      currentGuidePage: 0,
      currentSlideId: null,
      zoneContents: {},
      currentElements: [],
      currentBackground: null,
      zonesState: {},
      zonesData: {},
      loadedFonts: {},
      selectedItems: [],
      groups: [],
      expandedGroups: [],
      activeGroup: null,
      isSelecting: false,
      selectionStart: { x: 0, y: 0 },
      selectionEnd: { x: 0, y: 0 },
      showGroupBorder: false,
      showGroupButton: false,
      groupButtonPosition: { x: 0, y: 0 },
      startGroupDrag: null,
      lastSavedData: null,
      showRotateClock: false,
      selectedRotateItemId: null,
      hideActiveElement: false,
      activeItemId: null,
      selectedRotateGroupId: null,
      showGuide: false,
      isSelectionMode: false,
      selectionPoints: [], // Массив точек для лассо-выделения
      isDrawing: false, // Флаг рисования линии
      selectionPath: '', // SVG path для отрисовки линии
      tempSelectionRect: {
        // Временный прямоугольник после завершения рисования
        visible: false,
        x: 0,
        y: 0,
        width: 0,
        height: 0,
      },
      tempSelectionPolygon: {
        // Вместо прямоугольника храним полигон
        visible: false,
        points: [],
      },
      activeControlButton: null,
      isDownloadingContent: false,
      savedZoneTitle: null,
      isMobile: false,
      currentProjectData: null,
      savedProjectName: '',
      currentScale: 1,
      containerWidth: REFERENCE_WIDTH,
      containerHeight: REFERENCE_HEIGHT,
      resizeObserver: null,
      zoneBackground: null,
      toolbarPlacement: {},
      itemContainerRefs: {},
      groupContainerRefs: {},
      mobileFontPanelOpen: false,
      mobileFontSizePanelOpen: false,
      fontTouchStartY: null,
      showAiModal: false,
      showAiSuccessModal: false,
      showAiProgressModal: false,
      showBuyCreditsModal: false,
      aiCredits: 0,
      aiProcessing: false,
      aiProgress: 0,
      aiProgressStatus: 'preparing',
      aiPrompt: '',
      creditPackages: [],
      creditPackagesLoading: false,
      selectedCreditPackage: null,
      userFonts: [],
      googleFonts: [
        { family: 'Roboto', category: 'sans-serif' },
        { family: 'Open Sans', category: 'sans-serif' },
        { family: 'Lato', category: 'sans-serif' },
        { family: 'Montserrat', category: 'sans-serif' },
        { family: 'Oswald', category: 'sans-serif' },
        { family: 'Raleway', category: 'sans-serif' },
        { family: 'PT Sans', category: 'sans-serif' },
        { family: 'Roboto Condensed', category: 'sans-serif' },
        { family: 'Noto Sans', category: 'sans-serif' },
        { family: 'Ubuntu', category: 'sans-serif' },
        { family: 'Playfair Display', category: 'serif' },
        { family: 'Merriweather', category: 'serif' },
        { family: 'Lora', category: 'serif' },
        { family: 'PT Serif', category: 'serif' },
        { family: 'Noto Serif', category: 'serif' },
        { family: 'Libre Baskerville', category: 'serif' },
        { family: 'Cormorant Garamond', category: 'serif' },
        { family: 'EB Garamond', category: 'serif' },
        { family: 'Caveat', category: 'handwriting' },
        { family: 'Pacifico', category: 'handwriting' },
        { family: 'Dancing Script', category: 'handwriting' },
        { family: 'Satisfy', category: 'handwriting' },
        { family: 'Great Vibes', category: 'handwriting' },
        { family: 'Lobster', category: 'display' },
        { family: 'Bebas Neue', category: 'display' },
        { family: 'Comfortaa', category: 'display' },
        { family: 'Righteous', category: 'display' },
        { family: 'Russo One', category: 'sans-serif' },
        { family: 'Fira Sans', category: 'sans-serif' },
        { family: 'Nunito', category: 'sans-serif' },
        { family: 'Poppins', category: 'sans-serif' },
        { family: 'Inter', category: 'sans-serif' },
        { family: 'Rubik', category: 'sans-serif' },
        { family: 'Work Sans', category: 'sans-serif' },
        { family: 'Quicksand', category: 'sans-serif' },
        { family: 'Jost', category: 'sans-serif' },
        { family: 'Manrope', category: 'sans-serif' },
      ],
    };
  },
  computed: {
    ...mapState('category', ['categories', 'fetchCategoriesSuccess']),
    ...mapState('zones', ['zonesList', 'hasUnsavedChanges']),
    ...mapGetters('zones', ['activeZone', 'getZoneById', 'activeZoneId', 'totalProjectPrice']),
    
    allFonts() {
      const userFontsMapped = this.userFonts.map(f => ({
        family: f.font_name,
        category: 'custom',
        isUserFont: true,
        fontUrl: f.font_url
      }));
      return [...userFontsMapped, ...this.googleFonts];
    },
    isPremiumUser() {
      const sub = this.$store.state.subscription?.plan;
      return sub === 'premium';
    },
    canExportPdf() {
      const value = this.$store.getters['subscription/canExportPdf'];
      console.log('🔒 [Desktop] canExportPdf computed:', value);
      return value;
    },
    canExportExcel() {
      const value = this.$store.getters['subscription/canExportExcel'];
      console.log('🔒 [Desktop] canExportExcel computed:', value);
      return value;
    },
    canUseAi() {
      const isPaid = this.$store.getters['subscription/isPaid'];
      return isPaid && this.aiCredits > 0;
    },
    aiProgressStatusText() {
      const statusMap = {
        'preparing': this.$t('Подготовка изображения...'),
        'rendering': this.$t('Генерация изображения...'),
        'uploading': this.$t('Отправка на сервер...'),
        'processing': this.$t('Запуск обработки...')
      };
      return statusMap[this.aiProgressStatus] || this.$t('Обработка...');
    },
    localizedGuidePages() {
      const localize = (value) => {
        if (Array.isArray(value)) return value.map(localize);
        if (value && typeof value === 'object') {
          return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, localize(child)]));
        }
        return typeof value === 'string' && /[А-Яа-яЁё]/.test(value) ? this.$t(value) : value;
      };
      return localize(this.guidePages);
    },
    isPaidUser() {
      return this.$store.getters['subscription/isPaid'];
    },
    hasWatermark() {
      return this.$store.getters['subscription/hasWatermark'];
    },
    canSeePrices() {
      return this.$store.getters['subscription/canSeePrices'];
    },
    canUseCalculator() {
      return this.$store.getters['subscription/canUseCalculator'];
    },
    
    currentOpacityValue() {
      if (this.activeGroup && this.activeItemId === null) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        return group?.opacity ?? 1;
      }
      return this.activeItemData?.opacity ?? 1;
    },
    
    currentRotationValue() {
      if (this.activeGroup && this.activeItemId === null) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        return group?.rotate || 0;
      }
      return this.activeItemData?.rotate || 0;
    },
    
    currentProjectId() {
      return this.projectId || null;
    },
    
    totalPrice() {
      return this.droppedImages.reduce((total, image) => {
        return total + this.getEffectivePrice(image.elementId, image.price);
      }, 0);
    },
    currentZoneTotal() {
      return this.layersList.reduce((sum, item) => sum + (item.effectivePrice || 0), 0);
    },
    activeImage() {
      if (!this.activeImageId) return null;
      const img = this.droppedImages.find((img) => img.id === this.activeImageId);
      return img?.filters ? img : null;
    },
    hasBackground() {
      return this.droppedImages.some((img) => img.isBackground);
    },
    currentZoneTitle() {
      if (this.activeZone && this.activeZone.title) {
        return this.activeZone.title;
      }
      
      const zone = this.fotozones.find((zone) => zone.id === this.activeZoneId);
      return zone?.title || this.$t('editor.newProject');
    },
    showEmptyMessage() {
      return this.droppedImages.length === 0 && !this.hasBackground && !this.zoneBackground;
    },
    isAnyModalOpen() {
      return this.showSaveModal || this.showSuccessModal || this.showClearModal || this.showBackgroundModal || this.showAiModal || this.showAiSuccessModal || this.showExportModal;
    },
    emptyMessageText() {
      if (this.categories && this.categories.length > 0 && this.activeIcon === this.categories[0]?.name && !this.hasBackground) {
        return `${this.$t('legacy.Выберите фон для композиции')} ${this.currentZoneTitle}`;
      }
      if (this.isMobile) {
        return this.$t('editor.emptyMobile');
      }
      return this.$t('editor.emptyDesktop');
    },

    nonBackgroundImages() {
      return this.droppedImages.filter((item) => item && !item.isBackground && !item.isText);
    },
    sortedDroppedImages() {
      return [...this.droppedImages].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
    },
    visibleDroppedImages() {
      return this.sortedDroppedImages.filter(item => 
        !this.calculatorExcludedItems.includes(item.id)
      );
    },
    visibleGroups() {
      return this.groups.filter(group => {
        const visibleItems = group.items.filter(itemId => 
          !this.calculatorExcludedItems.includes(itemId)
        );
        return visibleItems.length > 0;
      });
    },
    sortedCanvasItems() {
      const trigger = this.layerOrderTrigger;
      const groupsSnapshot = this.groups;
      const imagesSnapshot = this.droppedImages;
      const items = [];
      
      for (let i = 0; i < groupsSnapshot.length; i++) {
        const group = groupsSnapshot[i];
        if (group.items.some(itemId => !this.calculatorExcludedItems.includes(itemId))) {
          items.push({ type: 'group', data: group, zIndex: group.zIndex || 0 });
        }
      }
      
      for (let i = 0; i < imagesSnapshot.length; i++) {
        const item = imagesSnapshot[i];
        if (item && !item.groupId && !item.isColor && !this.calculatorExcludedItems.includes(item.id)) {
          items.push({ type: 'element', data: item, zIndex: item.zIndex || 0 });
        }
      }
      
      items.sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
      console.log('🎨 sortedCanvasItems recalculated, trigger:', trigger, 'items:', items.map(i => ({ type: i.type, id: i.data.id, zIndex: i.zIndex })));
      return items;
    },
    konvaExcludedItems() {
      // Combine calculator excluded items with elements that are in groups
      const groupedIds = this.droppedImages
        .filter(item => item && item.groupId)
        .map(item => item.id);
      return [...new Set([...this.calculatorExcludedItems, ...groupedIds])];
    },
    activeItemData() {
      if (this.activeItemId === null) return null;
      // Use == for type coercion (number vs string) compatibility
      return this.droppedImages.find((i) => i && (i.id === this.activeItemId || String(i.id) === String(this.activeItemId))) || null;
    },
    layersList() {
      const filtered = this.droppedImages
        .filter(item => item && !item.isColor && !item.isBackground && !item._isBackground);
      
      // Create array with original indices for secondary sort
      const indexed = filtered.map((item, origIndex) => ({ item, origIndex }));
      
      // Sort by z-index descending, then by original index descending (later = on top visually)
      indexed.sort((a, b) => {
        const zDiff = (b.item.zIndex || 0) - (a.item.zIndex || 0);
        if (zDiff !== 0) return zDiff;
        // When z-index is equal, later elements in array are visually on top
        return b.origIndex - a.origIndex;
      });
      
      return indexed.map(({ item }) => ({
        ...item,
        effectivePrice: this.getEffectivePrice(item.elementId, item.price)
      }));
    },
    groupedLayersList() {
      const filtered = this.droppedImages
        .filter(item => item && !item.isColor && !item.isBackground && !item._isBackground);
      
      const result = [];
      const processedGroupIds = new Set();
      
      const indexed = filtered.map((item, origIndex) => ({ item, origIndex }));
      indexed.sort((a, b) => {
        const zDiff = (b.item.zIndex || 0) - (a.item.zIndex || 0);
        if (zDiff !== 0) return zDiff;
        return b.origIndex - a.origIndex;
      });
      
      for (const { item } of indexed) {
        if (item.groupId) {
          if (!processedGroupIds.has(item.groupId)) {
            processedGroupIds.add(item.groupId);
            const group = this.groups.find(g => g.id === item.groupId);
            const groupElements = indexed
              .filter(({ item: el }) => el.groupId === item.groupId)
              .map(({ item: el }) => ({
                ...el,
                effectivePrice: this.getEffectivePrice(el.elementId, el.price)
              }));
            result.push({
              id: item.groupId,
              isGroup: true,
              name: `${this.$t('legacy.Группа')} (${groupElements.length})`,
              elements: groupElements,
              expanded: this.expandedGroups.includes(item.groupId),
              locked: group?.locked || false,
              rotate: group?.rotate || 0,
            });
          }
        } else {
          result.push({ 
            ...item, 
            isGroup: false,
            effectivePrice: this.getEffectivePrice(item.elementId, item.price)
          });
        }
      }
      
      return result;
    },
    selectionBoxStyle() {
      if (!this.isSelecting) return { display: 'none' };

      const contentRect = this.$refs.contentRef.getBoundingClientRect();
      const startX = this.selectionStart.x + contentRect.left;
      const startY = this.selectionStart.y + contentRect.top;
      const endX = this.selectionEnd.x + contentRect.left;
      const endY = this.selectionEnd.y + contentRect.top;

      const left = Math.min(startX, endX);
      const top = Math.min(startY, endY);
      const width = Math.abs(endX - startX);
      const height = Math.abs(endY - startY);

      return {
        position: 'fixed',
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: 'rgba(66, 133, 244, 0.1)',
        border: '1px solid #bbcad8',
        borderRadius: '5px',
        pointerEvents: 'none',
        zIndex: 9999,
        display: this.isSelecting ? 'block' : 'none',
      };
    },
    groupBoundaryStyle() {
      if (this.selectedItems.length < 2) return { display: 'none' };

      const items = this.selectedItems.map((id) => this.droppedImages.find((item) => item?.id === id)).filter((item) => item && !item.isBackground);

      if (!items.length) return { display: 'none' };

      // Для лассо-выделения используем bounding box всех выбранных элементов
      const bounds = items.reduce(
        (acc, item) => ({
          left: Math.min(acc.left, item.x),
          top: Math.min(acc.top, item.y),
          right: Math.max(acc.right, item.x + item.width),
          bottom: Math.max(acc.bottom, item.y + item.height),
        }),
        {
          left: Infinity,
          top: Infinity,
          right: -Infinity,
          bottom: -Infinity,
        }
      );

      return {
        left: `${bounds.left}px`,
        top: `${bounds.top}px`,
        width: `${bounds.right - bounds.left}px`,
        height: `${bounds.bottom - bounds.top}px`,
        display: this.showGroupBorder ? 'block' : 'none',
        border: '2px dashed #007bff',
        borderRadius: '8px',
        backgroundColor: 'rgba(0, 123, 255, 0.05)',
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 9998,
      };
    },
    sidebarSelectionType() {
      if (this.activeGroup) {
        return 'group';
      }
      if (this.activeItemData) {
        return this.activeItemData.type === 'text' ? 'text' : 'image';
      }
      return null;
    },
    sidebarIsLocked() {
      if (this.activeGroup && Array.isArray(this.groups)) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        return group?.locked || false;
      }
      return this.activeItemData?.locked || false;
    },
    selectedHasPerspective() {
      const item = this.activeGroup
        ? this.groups.find(group => group.id === this.activeGroup)
        : this.activeItemData;
      return Boolean(item?.perspective);
    },
    selectedHasErasure() {
      const item = this.activeGroup
        ? this.groups.find(group => group.id === this.activeGroup)
        : this.activeItemData;
      return hasEraser(item?.eraser);
    },
    sidebarOpacity() {
      if (this.activeGroup && Array.isArray(this.groups)) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        return group?.opacity ?? 1;
      }
      return this.activeItemData?.opacity ?? 1;
    },
    sidebarFilters() {
      if (this.activeGroup && Array.isArray(this.groups)) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        return group?.filters || {};
      }
      return this.activeItemData?.filters || {};
    },
    sidebarRotation() {
      if (this.activeGroup && Array.isArray(this.groups)) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        return Math.round(group?.rotate || 0);
      }
      return Math.round(this.activeItemData?.rotate || 0);
    },
    sidebarTextColor() {
      return this.activeItemData?.color || '#000000';
    },
    sidebarTextShadow() {
      return this.activeItemData?.textShadow || false;
    },
    sidebarCurrentFont() {
      return this.activeItemData?.fontName || 'Arial';
    },
    sidebarFontSize() {
      return this.activeItemData?.fontSize || 32;
    },
    sidebarProjectColors() {
      const colors = new Set();
      this.droppedImages.forEach(item => {
        if (item.type === 'text' && item.color) {
          colors.add(item.color);
        }
      });
      return Array.from(colors).slice(0, 8);
    },
  },
  methods: {
    handleCanvasViewportChange(viewport) {
      if (Number.isFinite(viewport?.zoom)) this.canvasZoom = viewport.zoom;
    },
    zoomCanvasIn() {
      this.$refs.konvaEditor?.zoomBy(1.25);
    },
    zoomCanvasOut() {
      this.$refs.konvaEditor?.zoomBy(0.8);
    },
    fitCanvas() {
      this.canvasPanMode = false;
      this.$refs.konvaEditor?.resetViewport();
    },
    toggleCanvasPanMode() {
      this.canvasPanMode = !this.canvasPanMode;
      if (this.canvasPanMode) this.exitEraserMode();
    },
    openTransformSheet() {
      this.exitEraserMode();
      this.showRotationSheet = false;
      this.showOpacitySheet = false;
      this.activeControlButton = null;
      this.showTransformSheet = true;
    },
    chooseTransformMode(mode) {
      this.exitEraserMode();
      this.transformMode = mode;
      this.showTransformSheet = false;
    },
    openEraserSheet(mode = 'erase') {
      if (!['erase', 'restore'].includes(mode)) return;
      if (this.sidebarIsLocked || this.isSelectionMode || (!this.activeItemId && !this.activeGroup)) return;
      if (this.eraserEnabled && this.eraserMode === mode) {
        this.exitEraserMode();
        return;
      }
      this.showOpacitySheet = false;
      this.showRotationSheet = false;
      this.showTransformSheet = false;
      this.activeControlButton = null;
      this.handleEraserModeUpdate(mode);
      this.showEraserSheet = true;
    },
    closeEraserSheet() {
      this.exitEraserMode();
    },
    handleEraserToggle(enabled) {
      if (enabled && (this.sidebarIsLocked || this.isSelectionMode || (!this.activeItemId && !this.activeGroup))) return;
      this.eraserEnabled = Boolean(enabled);
      if (this.eraserEnabled) {
        this.canvasPanMode = false;
        this.isSelectionMode = false;
        this.showOpacitySheet = false;
        this.showRotationSheet = false;
        this.showTransformSheet = false;
        this.activeControlButton = null;
        this.mobileFontPanelOpen = false;
        this.mobileFontSizePanelOpen = false;
        this.transformMode = 'resize';
      }
    },
    handleEraserModeUpdate(mode) {
      if (!['erase', 'restore'].includes(mode)) return;
      this.$refs.konvaEditor?.cancelEraseStroke();
      this.eraserMode = mode;
      this.handleEraserToggle(true);
    },
    handleEraserSizeUpdate(size) {
      const nextSize = Number(size);
      if (Number.isFinite(nextSize)) this.eraserSize = Math.max(1, Math.min(80, nextSize));
    },
    exitEraserMode() {
      this.eraserEnabled = false;
      this.showEraserSheet = false;
    },
    async captureWithoutEditorControls(callback) {
      const editor = this.$refs.konvaEditor;
      try {
        await editor?.setExportMode(true);
        await new Promise((resolve) => requestAnimationFrame(() => resolve()));
        return await callback();
      } finally {
        await editor?.setExportMode(false);
      }
    },

    ...mapActions('category', ['fetchCategories']),
    ...mapActions('projects', ['loadProjects']),
    ...mapActions('zones', [
      'loadZonesList',
      'loadZone',
      'setActiveZone',
      'createZone',
      'updateZone',
      'deleteZone',
      'markDirty',
      'syncZoneElements',
    ]),
    
    openOpacitySheet() {
      this.showOpacitySheet = true;
      this.showRotationSheet = false;
      this.activeControlButton = null;
    },
    
    closeOpacitySheet() {
      this.showOpacitySheet = false;
    },
    
    openRotationSheet() {
      this.showRotationSheet = true;
      this.showOpacitySheet = false;
      this.activeControlButton = null;
    },
    
    // Mobile Konva Editor methods
    handleKonvaElementsUpdate(updatedElements) {
      this.saveHistoryState();
      this.droppedImages = updatedElements;
      this.markDirtyAndSync();
    },
    
    handleKonvaElementSelected(elementId) {
      if (elementId) {
        this.activeGroup = null;
        this.activeItemId = elementId;
        this.showControls = true;
      } else {
        this.activeItemId = null;
        this.activeGroup = null;
        this.showControls = false;
      }
    },
    
    handleKonvaElementDeleted(elementId) {
      this.saveHistoryState();
      this.droppedImages = this.droppedImages.filter(item => item.id !== elementId);
      this.activeItemId = null;
      this.showControls = false;
      this.markDirtyAndSync();
    },
    
    handleKonvaGroupsUpdate(updatedGroups) {
      this.saveHistoryState();
      this.groups = updatedGroups;
      this.markDirtyAndSync();
    },
    
    handleKonvaGroupSelected(groupId) {
      if (groupId) {
        this.activeGroup = groupId;
        this.activeItemId = null;
        this.showControls = true;
      } else {
        this.activeGroup = null;
        this.activeItemId = null;
        this.showControls = false;
      }
    },
    
    handleKonvaGroupDeleted(groupId) {
      this.saveHistoryState();
      this.droppedImages = this.droppedImages.filter(item => item.groupId !== groupId);
      this.groups = this.groups.filter(g => g.id !== groupId);
      this.activeGroup = null;
      this.showControls = false;
      this.markDirtyAndSync();
    },
    
    handleKonvaCreateGroup(selectedElements) {
      if (!selectedElements || selectedElements.length < 2) return;
      
      this.saveHistoryState();
      
      const selectedIds = selectedElements.map(el => el.id);
      const left = Math.min(...selectedElements.map(item => item.x));
      const top = Math.min(...selectedElements.map(item => item.y));
      const right = Math.max(...selectedElements.map(item => item.x + item.width));
      const bottom = Math.max(...selectedElements.map(item => item.y + item.height));
      
      const groupId = `group_${Date.now()}`;
      
      const elementsOriginalState = {};
      const items = [];
      
      this.droppedImages = this.droppedImages.map(item => {
        if (selectedIds.includes(item.id)) {
          items.push(item.id);
          elementsOriginalState[item.id] = {
            x: item.x,
            y: item.y,
            rotate: item.rotate || 0,
            filters: item.filters || this.getDefaultFilters()
          };
          return {
            ...item,
            groupId: groupId,
            relativeX: item.x - left,
            relativeY: item.y - top
          };
        }
        return item;
      });
      
      const newGroup = {
        id: groupId,
        x: left,
        y: top,
        width: right - left,
        height: bottom - top,
        rotate: 0,
        opacity: 1,
        flipX: false,
        flipY: false,
        filters: this.getDefaultFilters(),
        items: items,
        elementsOriginalState: elementsOriginalState,
        zIndex: Math.max(...this.droppedImages.map(i => i.zIndex || 0)) + 1
      };
      
      this.groups.push(newGroup);
      this.activeGroup = groupId;
      this.activeItemId = null;
      this.showControls = true;
      this.isSelectionMode = false;
      this.selectedItems = [];
      this.showGroupButton = false;
      if (this.$refs.konvaEditor && this.$refs.konvaEditor.clearSelection) {
        this.$refs.konvaEditor.clearSelection();
      }
      this.markDirtyAndSync();
    },
    
    handleKonvaSelectionComplete(selectedIds) {
      console.log('[CategoryList] Konva selection complete:', selectedIds);
      this.selectedItems = selectedIds || [];
      this.showGroupButton = this.selectedItems.length > 1;
      if (this.showGroupButton) {
        // Position button in center of canvas area
        const contentEl = this.$refs.content;
        if (contentEl) {
          const rect = contentEl.getBoundingClientRect();
          this.groupButtonPosition = {
            x: rect.width / 2 - 60,
            y: rect.height - 50
          };
        }
      }
    },
    
    closeRotationSheet() {
      this.showRotationSheet = false;
    },
    
    handleSheetOpacityUpdate(value) {
      if (this.activeGroup && this.activeItemId === null) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        if (group) {
          group.opacity = value;
          this.markDirtyAndSync();
        }
      } else if (this.activeItemData) {
        this.activeItemData.opacity = value;
        this.markDirtyAndSync();
      }
    },
    
    handleSheetRotationUpdate(value) {
      if (this.activeGroup && this.activeItemId === null) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        if (group) {
          this.setGroupRotationWithCenter(group.id, value);
        }
      } else if (this.activeItemData) {
        this.setItemRotationWithCenter(this.activeItemData.id, value);
      }
    },
    
    setItemRotationWithCenter(itemId, newAngle) {
      const item = this.droppedImages.find(img => img.id === itemId);
      if (!item) return;
      
      item.rotate = newAngle;
      this.markDirtyAndSync();
    },
    
    setGroupRotationWithCenter(groupId, newAngle) {
      const group = this.groups.find(g => g.id === groupId);
      if (!group) return;
      
      group.rotate = newAngle;
      this.markDirtyAndSync();
    },

    normalizePerspective(perspective) {
      if (!Array.isArray(perspective) || perspective.length !== 4) return undefined;
      const points = perspective.map(point => ({ x: Number(point?.x), y: Number(point?.y) }));
      return points.every(point => Number.isFinite(point.x) && Number.isFinite(point.y))
        ? points
        : undefined;
    },
    
    markDirtyAndSync() {
      this.markDirty();
      const elements = this.droppedImages.map((item) => ({
        id: item.id,
        type: item.isText || item.type === 'text' ? 'text' : 'image',
        name: item.name || '',
        content: item.isText || item.type === 'text' ? item.text : item.src,
        perspective: this.normalizePerspective(item.perspective ?? item.styles?.perspective),
        eraser: normalizeEraser(item.eraser),
        price: this.getEffectivePrice(item.elementId, item.price),
        position: { x: item.x, y: item.y },
        size: { width: item.width, height: item.height },
        styles: {
          zIndex: item.zIndex,
          rotation: item.rotate || 0,
          flipX: item.flipX || false,
          flipY: item.flipY || false,
          opacity: item.opacity ?? 1,
        },
        filters: {
          exposure: item.exposure || 0,
          contrast: item.contrast || 0,
          saturation: item.saturation || 0,
          temperature: item.temperature || 0,
          hue: item.hue || 0,
        },
        fontName: item.fontName,
        fontCategory: item.fontCategory,
        isGoogleFont: item.isGoogleFont,
        fontUrl: item.fontUrl,
        fontId: item.fontId,
        color: item.color,
        textShadow: item.textShadow,
        fontSize: item.fontSize,
        groupId: item.groupId || null,
        elementId: item.elementId || null,
        rootCategoryName: item.rootCategoryName || null,
      }));
      const groups = this.groups.map((g) => ({
        id: g.id,
        x: g.x,
        y: g.y,
        width: g.width,
        height: g.height,
        originalWidth: g.originalWidth || g.width,
        originalHeight: g.originalHeight || g.height,
        rotate: g.rotate || 0,
        locked: g.locked || false,
        opacity: g.opacity ?? 1,
        zIndex: g.zIndex || 0,
        filters: g.filters || {},
        perspective: this.normalizePerspective(g.perspective ?? g.styles?.perspective),
        eraser: normalizeEraser(g.eraser),
        elementsOriginalState: g.elementsOriginalState || {},
        elementIds: this.droppedImages.filter(el => el.groupId === g.id).map(el => el.id),
      }));
      this.syncZoneElements({ elements, background: this.zoneBackground, groups });
    },

    // History methods
    updateHistoryState() {
      if (!this.history) return;
      this.canUndo = this.history.getCanUndo();
      this.canRedo = this.history.getCanRedo();
    },
    saveHistoryState() {
      if (!this.history) {
        console.log('📜 History not initialized');
        return;
      }
      
      const state = {
        droppedImages: JSON.parse(JSON.stringify(this.droppedImages)),
        groups: JSON.parse(JSON.stringify(this.groups)),
        zoneBackground: this.zoneBackground
      };
      this.history.saveState(state);
      this.updateHistoryState();
      console.log('📜 History saved, canUndo:', this.canUndo, 'canRedo:', this.canRedo, 'historyLength:', this.history.getHistoryLength());
    },
    handleUndo() {
      if (!this.history || !this.history.getCanUndo()) return;
      const currentState = {
        droppedImages: JSON.parse(JSON.stringify(this.droppedImages)),
        groups: JSON.parse(JSON.stringify(this.groups)),
        zoneBackground: this.zoneBackground
      };
      const state = this.history.undo(currentState);
      if (state) {
        this.droppedImages = state.droppedImages;
        this.groups = state.groups || [];
        this.zoneBackground = state.zoneBackground;
        this.activeImageId = null;
        this.activeGroup = null;
        this.markDirtyAndSync();
      }
      this.updateHistoryState();
    },
    handleRedo() {
      if (!this.history || !this.history.getCanRedo()) return;
      const currentState = {
        droppedImages: JSON.parse(JSON.stringify(this.droppedImages)),
        groups: JSON.parse(JSON.stringify(this.groups)),
        zoneBackground: this.zoneBackground
      };
      const state = this.history.redo(currentState);
      if (state) {
        this.droppedImages = state.droppedImages;
        this.groups = state.groups || [];
        this.zoneBackground = state.zoneBackground;
        this.activeImageId = null;
        this.activeGroup = null;
        this.markDirtyAndSync();
      }
      this.updateHistoryState();
    },
    
    handleSidebarToggleLock() {
      if (this.activeGroup) {
        this.toggleGroupLock(this.activeGroup);
      } else if (this.activeItemId) {
        this.toggleLock(this.activeItemId);
      }
    },
    handleSidebarCopy() {
      if (this.activeGroup) {
        this.copyGroup(this.activeGroup);
      } else if (this.activeItemId) {
        this.copyItem(this.activeItemId);
      }
    },
    handleSidebarMirror() {
      if (this.activeGroup) {
        this.mirrorGroup(this.activeGroup);
      } else if (this.activeItemId) {
        this.mirrorFun(this.activeItemId);
      }
    },
    handleSidebarUpdateRotation(value) {
      if (!this.rotationHistorySaved) {
        this.saveHistoryState();
        this.rotationHistorySaved = true;
        setTimeout(() => { this.rotationHistorySaved = false; }, 500);
      }
      if (this.activeGroup) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        if (group) {
          console.log('🔄 ROTATION: Before', { 
            x: group.x, 
            y: group.y, 
            centerX: group.centerX, 
            centerY: group.centerY,
            width: group.width,
            height: group.height,
            rotate: group.rotate,
            newRotate: value
          });
          group.rotate = value;
          this.markDirtyAndSync();
        }
      } else if (this.activeItemId) {
        const item = this.droppedImages.find(i => i.id === this.activeItemId);
        if (item) {
          item.rotate = value;
          this.markDirtyAndSync();
        }
      }
    },
    handleSidebarUpdateOpacity(value) {
      if (!this.opacityHistorySaved) {
        this.saveHistoryState();
        this.opacityHistorySaved = true;
        setTimeout(() => { this.opacityHistorySaved = false; }, 500);
      }
      if (this.activeGroup) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        if (group) {
          group.opacity = value;
          this.applyGroupFiltersToDom(this.activeGroup);
          this.markDirtyAndSync();
        }
      } else if (this.activeItemId) {
        const item = this.droppedImages.find(i => i.id === this.activeItemId);
        if (item) {
          item.opacity = value;
          this.applyFiltersToDom(this.activeItemId);
          this.markDirtyAndSync();
        }
      }
    },
    handleSidebarMoveLayer(direction) {
      if (this.activeGroup) {
        this.changeGroupZIndex(direction, this.activeGroup);
      } else if (this.activeItemId) {
        this.changeZIndex(direction, this.activeItemId);
      }
    },
    handleSidebarUpdateFilter(filterName, value) {
      if (!this.filterHistorySaved) {
        this.saveHistoryState();
        this.filterHistorySaved = true;
        setTimeout(() => { this.filterHistorySaved = false; }, 500);
      }
      if (this.activeGroup) {
        const group = this.groups.find(g => g.id === this.activeGroup);
        if (group) {
          if (!group.filters) group.filters = {};
          group.filters[filterName] = value;
          this.applyGroupFiltersToDom(this.activeGroup);
          this.markDirtyAndSync();
        }
      } else if (this.activeItemId) {
        const item = this.droppedImages.find(i => i.id === this.activeItemId);
        if (item) {
          if (!item.filters) item.filters = {};
          item.filters[filterName] = value;
          this.applyFiltersToDom(this.activeItemId);
          this.markDirtyAndSync();
        }
      }
    },
    handleSidebarColorChange(color) {
      this.saveHistoryState();
      if (this.activeItemId && this.activeItemData?.type === 'text') {
        const idx = this.droppedImages.findIndex(i => i.id === this.activeItemId);
        if (idx !== -1) {
          this.droppedImages[idx] = { ...this.droppedImages[idx], color };
          this.markDirtyAndSync();
        }
      }
    },
    handleSidebarFontChange(fontFamily) {
      this.saveHistoryState();
      if (this.activeItemId && this.activeItemData?.type === 'text') {
        const font = this.allFonts.find(f => f.family === fontFamily);
        if (font) {
          if (font.isUserFont) {
            this.loadUserFontFace({ font_name: font.family, font_url: font.fontUrl });
          } else {
            this.loadFont(fontFamily, font.category);
          }
          const idx = this.droppedImages.findIndex(i => i.id === this.activeItemId);
          if (idx !== -1) {
            this.droppedImages[idx] = { 
              ...this.droppedImages[idx], 
              fontName: fontFamily,
              fontCategory: font.category,
              isUserFont: font.isUserFont || false,
              fontUrl: font.fontUrl || null
            };
            this.markDirtyAndSync();
          }
        }
      }
    },
    handleSidebarFontSizeChange(size) {
      this.saveHistoryState();
      if (this.activeItemId && this.activeItemData?.type === 'text') {
        const idx = this.droppedImages.findIndex(i => i.id === this.activeItemId);
        if (idx !== -1) {
          this.droppedImages[idx] = { ...this.droppedImages[idx], fontSize: size };
          this.markDirtyAndSync();
        }
      }
    },
    handleSidebarToggleShadow() {
      this.saveHistoryState();
      if (this.activeItemId && this.activeItemData?.type === 'text') {
        const item = this.droppedImages.find(i => i.id === this.activeItemId);
        if (item) {
          item.textShadow = !item.textShadow;
          this.markDirtyAndSync();
        }
      }
    },
    handleSidebarUngroup() {
      this.saveHistoryState();
      if (this.activeGroup) {
        this.ungroupElements(this.activeGroup);
      }
    },
    handleSidebarDelete() {
      if (this.activeGroup) {
        this.deleteGroupWithItems(this.activeGroup);
      } else if (this.activeItemId) {
        this.deleteItem(this.activeItemId);
      }
    },

    utf8ToBase64(str) {
      try {
        if (typeof TextEncoder !== 'undefined') {
          const encoder = new TextEncoder();
          const data = encoder.encode(str);
          const binary = String.fromCharCode(...data);
          return btoa(binary);
        }

        return btoa(unescape(encodeURIComponent(str)));
      } catch (error) {
        console.error('Base64 encoding error:', error);
        return '';
      }
    },
    base64ToUtf8(str) {
      try {
        if (typeof TextDecoder !== 'undefined') {
          const binary = atob(str);
          const bytes = new Uint8Array(binary.length);
          for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
          }
          const decoder = new TextDecoder('utf-8');
          return decoder.decode(bytes);
        }

        return decodeURIComponent(escape(atob(str)));
      } catch (error) {
        console.error('Base64 decoding error:', error);
        return '';
      }
    },
    setItemContainerRef(el, itemId) {
      if (el) {
        this.itemContainerRefs[itemId] = el;
        this.$nextTick(() => {
          this.updateToolbarPlacement('item', itemId);
        });
      } else {
        delete this.itemContainerRefs[itemId];
        delete this.toolbarPlacement[`item-${itemId}`];
      }
    },
    setGroupContainerRef(el, groupId) {
      if (el) {
        this.groupContainerRefs[groupId] = el;
        this.$nextTick(() => {
          this.updateToolbarPlacement('group', groupId);
        });
      } else {
        delete this.groupContainerRefs[groupId];
        delete this.toolbarPlacement[`group-${groupId}`];
      }
    },
    updateToolbarPlacement(type, id) {
      const containerEl = type === 'item' ? this.itemContainerRefs[id] : this.groupContainerRefs[id];
      if (!containerEl || !this.$refs.contentRef) return;

      const TOOLBAR_HEIGHT = 94;
      const containerRect = containerEl.getBoundingClientRect();
      const contentRect = this.$refs.contentRef.getBoundingClientRect();

      const showBelow = (containerRect.top - contentRect.top) < TOOLBAR_HEIGHT;
      this.toolbarPlacement[`${type}-${id}`] = showBelow;
    },
    updateAllToolbarPlacements() {
      this.$nextTick(() => {
        if (this.itemContainerRefs) {
          Object.keys(this.itemContainerRefs).forEach(id => {
            this.updateToolbarPlacement('item', id);
          });
        }
        if (this.groupContainerRefs) {
          Object.keys(this.groupContainerRefs).forEach(id => {
            this.updateToolbarPlacement('group', id);
          });
        }
      });
    },
    shouldShowToolbarBelow(item) {
      if (!item) return false;
      return this.toolbarPlacement[`item-${item.id}`] || false;
    },
    shouldShowGroupToolbarBelow(group) {
      if (!group) return false;
      return this.toolbarPlacement[`group-${group.id}`] || false;
    },
    handleControlButtonClick(buttonType) {
      if (this.activeControlButton === buttonType) {
        this.activeControlButton = null;
      } else {
        this.activeControlButton = buttonType;
      }
    },
    closeAllMenus() {
      this.activeControlButton = null;
    },
    handlePageChange(newPage) {
      this.currentGuidePage = newPage;
    },
    openGuide(page) {
      this.showGuide = true;
      this.currentGuidePage = page;
    },

    calculateScale() {
      if (!this.$refs.contentRef) return;
      
      const container = this.$refs.contentRef;
      this.containerWidth = container.offsetWidth;
      this.containerHeight = container.offsetHeight;
      
      const scaleX = this.containerWidth / REFERENCE_WIDTH;
      const scaleY = this.containerHeight / REFERENCE_HEIGHT;
      
      this.currentScale = Math.min(scaleX, scaleY);
      
      console.log('Content size:', { 
        width: this.containerWidth, 
        height: this.containerHeight,
        scale: this.currentScale,
        reference: { width: REFERENCE_WIDTH, height: REFERENCE_HEIGHT }
      });
    },

    closeGuide() {
      this.showGuide = false;
    },
    handleGroupFilterChange(event, groupId, filterName) {
      const value = parseFloat(event.target.value);
      const filter = this.filtersList.find((f) => f.name === filterName);

      const group = this.groups.find((g) => g.id === groupId);
      if (group) {
        if (!group.filters) group.filters = this.getDefaultFilters();
        group.filters[filterName] = value;

        const normalizedValue = ((value - filter.min) / (filter.max - filter.min)) * 100;
        event.target.style.setProperty('--fill-position', `${normalizedValue}%`);
      }
    },

    applyGroupFiltersToDom(groupId) {
      const group = this.groups.find((g) => g.id === groupId);
      if (group && group.filters) {
        if (this.useKonvaEditor && this.$refs.konvaEditor) {
          this.$refs.konvaEditor.loadGroups();
        } else {
          const groupElement = document.querySelector(`[data-group-id="${groupId}"]`);
          if (groupElement) {
            groupElement.style.filter = this.generateFilterString(group.filters);
          }
        }
        this.markDirtyAndSync();
      }
    },

    getAppliedGroupFilters(group) {
      if (!group.filters) return '';

      const filters = [];

      // Используем оригинальные CSS-фильтры
      if (group.filters.exposure !== undefined) {
        filters.push(`brightness(${group.filters.exposure + 100}%)`);
      }
      if (group.filters.contrast !== undefined) {
        filters.push(`contrast(${group.filters.contrast + 100}%)`);
      }
      if (group.filters.saturation !== undefined) {
        filters.push(`saturate(${group.filters.saturation + 100}%)`);
      }
      if (group.filters.temperature !== undefined) {
        // Temperature можно реализовать через sepia или hue-rotate
        // В зависимости от того, как это реализовано у отдельных элементов
        filters.push(`sepia(${Math.abs(group.filters.temperature)}%)`);
      }
      if (group.filters.hue !== undefined) {
        filters.push(`hue-rotate(${group.filters.hue}deg)`);
      }
      // if (group.filters.highlights !== undefined) {
      //   // Highlights обычно через brightness
      //   filters.push(`brightness(${100 + group.filters.highlights}%)`)
      // }
      if (group.filters.shadows !== undefined) {
        const intensity = Math.abs(group.filters.shadows) / 10;
        const opacity = 0.8;
        const color = group.filters.shadows > 0 ? `0,0,0,${opacity}` : `255,255,255,${opacity}`;
        filters.push(`drop-shadow(0 0 ${intensity}px rgba(${color}))`);
      }
      if (group.filters.blur !== undefined) {
        filters.push(`blur(${group.filters.blur}px)`);
      }
      if (group.filters.grayscale !== undefined) {
        filters.push(`grayscale(${group.filters.grayscale}%)`);
      }

      return filters.join(' ');
    },
    handleContentSectionClick(event) {
      this.closeAllMenus();

      if (this.isSelectionMode) return;
      const target = event.target;

      if (target.closest('.resize-handle') || target.closest('.item-controls') || target.closest('.group-controls') || target.closest('.group-button')) {
        return;
      }
      
      // В режиме Konva editor не обрабатываем клики на canvas - MobileKonvaEditor сам управляет выбором
      if (this.useKonvaEditor && (target.tagName === 'CANVAS' || target.closest('.konva-content'))) {
        return;
      }
      
      // На мобильном: не деактивируем элемент при тапе вне его - только через крестик
      if (this.isMobile && (this.activeItemId || this.activeGroup)) {
        return;
      }

      if (!target.closest('.dropped-image-container.active') && !target.closest('.group-container.active')) {
        this.activeItemId = null;
        this.activeGroup = null;
        this.activeResizeHandle = null;

        // Сбрасываем выделение при клике на пустую область
        this.selectedItems = [];
        this.showGroupBorder = false;
        this.showGroupButton = false;

        // Сбрасываем лассо-выделение
        this.isDrawing = false;
        this.isSelecting = false;
        this.selectionPoints = [];
        this.selectionPath = '';
        this.tempSelectionPolygon.visible = false;
        this.tempSelectionRect.visible = false;
      }
    },
    handleModalOpened(isOpen) {
      this.hideActiveElement = isOpen;
    },
    handlePriceModalOpened(isOpened) {
      this.hideActiveElement = isOpened;
    },
    isItemInActiveGroup(itemId) {
      if (!this.activeGroup) return false;
      const group = this.groups.find((g) => g.id === this.activeGroup);
      return group ? group.items.includes(itemId) : false;
    },
    isItemActive(item) {
      if (this.showSaveModal || this.showSuccessModal || this.isDownloadingContent) return false;
      // Элемент активен если:
      // 1. Это отдельный выделенный элемент
      // 2. Или он принадлежит активной группе
      return this.activeItemId === item?.id || this.selectedItems.includes(item?.id) || this.isItemInActiveGroup(item?.id);
    },
    updateItemPosition(id, x, y) {
      if (!this.positionHistorySaved) {
        this.saveHistoryState();
        this.positionHistorySaved = true;
        setTimeout(() => { this.positionHistorySaved = false; }, 300);
      }
      const item = this.droppedImages.find((i) => i.id === id);

      if (item) {
        item.x = x;
        item.y = y;
      }
    },
    toggleGroupLock(groupId) {
      this.closeAllMenus();
      const group = this.groups.find((g) => g.id === groupId);
      if (group) {
        group.locked = !group.locked;
      }
    },
    toggleGroupExpand(groupId) {
      const idx = this.expandedGroups.indexOf(groupId);
      if (idx === -1) {
        this.expandedGroups.push(groupId);
      } else {
        this.expandedGroups.splice(idx, 1);
      }
    },
    selectGroup(groupId) {
      // На мобильном: блокируем переключение на группу, если уже есть активный элемент
      if (this.isMobile && this.activeItemId) {
        return;
      }
      // На мобильном: блокируем переключение на другую группу
      if (this.isMobile && this.activeGroup && this.activeGroup !== groupId) {
        return;
      }
      
      this.activeGroup = groupId;
      this.showControls = true;
      const group = this.groups.find(g => g.id === groupId);
      if (group && group.items) {
        this.selectedItems = [...group.items];
      }
    },
    copyGroup(groupId) {
      this.saveHistoryState();
      const group = this.groups.find((g) => g.id === groupId);
      if (!group) return;

      const offset = 30;
      const newGroupId = Date.now() + Math.random();
      const elementIdMap = {};

      group.items.forEach((itemId) => {
        const original = this.droppedImages.find((el) => el.id === itemId);
        if (original) {
          const newId = Date.now() + Math.random();
          elementIdMap[itemId] = newId;
          
          const copy = JSON.parse(JSON.stringify(original));
          copy.id = newId;
          copy.groupId = newGroupId;
          
          this.droppedImages.push(copy);
        }
      });

      const newGroup = JSON.parse(JSON.stringify(group));
      newGroup.id = newGroupId;
      newGroup.x = (group.x || 0) + offset;
      newGroup.y = (group.y || 0) + offset;
      newGroup.items = Object.values(elementIdMap);

      if (newGroup.elementsOriginalState) {
        const newOriginalState = {};
        for (const [oldId, state] of Object.entries(newGroup.elementsOriginalState)) {
          const newId = elementIdMap[oldId] || elementIdMap[Number(oldId)];
          if (newId) {
            newOriginalState[newId] = state;
          }
        }
        newGroup.elementsOriginalState = newOriginalState;
      }

      this.groups.push(newGroup);
      this.activeGroup = newGroupId;
      this.setActiveGroup(newGroupId);
    },

    ungroupElements(groupId) {
      this.saveHistoryState();
      const group = this.groups.find((g) => g.id === groupId);
      if (group) {
        const groupRotation = group.rotate || 0;
        const angleRad = (groupRotation * Math.PI) / 180;
        const cos = Math.cos(angleRad);
        const sin = Math.sin(angleRad);
        
        // BACKWARD COMPATIBILITY: поддержка старого и нового формата
        let groupCenterX, groupCenterY;
        const deltaX = group.deltaX || 0;
        const deltaY = group.deltaY || 0;
        
        if (group.centerX !== undefined && group.centerY !== undefined) {
          // Приоритет: используем явно сохранённый центр
          groupCenterX = group.centerX;
          groupCenterY = group.centerY;
        } else if (group.x !== undefined && group.y !== undefined) {
          // Fallback для Konva-подхода без сохранённого центра
          groupCenterX = group.x + (group.width || 0) / 2;
          groupCenterY = group.y + (group.height || 0) / 2;
        } else {
          // Fallback: вычисляем из элементов
          const groupElements = this.droppedImages.filter(el => group.items.includes(el.id));
          let sumCenterX = 0, sumCenterY = 0;
          groupElements.forEach(el => {
            sumCenterX += el.x + deltaX + el.width / 2;
            sumCenterY += el.y + deltaY + el.height / 2;
          });
          groupCenterX = sumCenterX / groupElements.length;
          groupCenterY = sumCenterY / groupElements.length;
        }

        console.log('🔗 ungroupElements:', {
          groupId,
          hasNewFormat: group.x !== undefined,
          hasLegacyCenter: group.centerX !== undefined,
          groupCenterX, groupCenterY,
          groupRotation
        });

        group.items.forEach((itemId) => {
          const item = this.droppedImages.find((i) => i.id === itemId);
          if (item) {
            const mask = this.$refs.konvaEditor?.getUngroupErasure(group.id, item.id);
            if (mask) item.eraser = mask;
            const originalFilters = group.elementsOriginalState?.[itemId]?.filters || this.getDefaultFilters();
            item.filters = this.getCombinedFilters(originalFilters, group.filters);

            item.rotate = (item.rotate || 0) + groupRotation;

            if (group.flipX) item.flipX = !item.flipX;
            if (group.flipY) item.flipY = !item.flipY;

            item.opacity = (item.opacity || 1) * group.opacity;

            // Вычисляем абсолютные координаты
            let newX, newY;
            if (item.relativeX !== undefined && item.relativeY !== undefined && group.x !== undefined) {
              // Новый формат: relativeX/Y - это позиция ЦЕНТРА элемента относительно левого верхнего угла группы
              const elementCenterX = group.x + item.relativeX;
              const elementCenterY = group.y + item.relativeY;
              
              if (groupRotation !== 0) {
                // Поворачиваем центр элемента вокруг центра группы
                const dx = elementCenterX - groupCenterX;
                const dy = elementCenterY - groupCenterY;
                
                const rotatedCenterX = groupCenterX + dx * cos - dy * sin;
                const rotatedCenterY = groupCenterY + dx * sin + dy * cos;
                
                newX = rotatedCenterX - item.width / 2;
                newY = rotatedCenterY - item.height / 2;
              } else {
                // Без поворота группы - просто конвертируем из центра в левый верхний угол
                newX = elementCenterX - item.width / 2;
                newY = elementCenterY - item.height / 2;
              }
            } else {
              // Старый формат: используем абсолютные + deltaX/deltaY
              newX = item.x + deltaX;
              newY = item.y + deltaY;
              
              if (groupRotation !== 0) {
                const itemCenterX = newX + item.width / 2;
                const itemCenterY = newY + item.height / 2;
                
                const dx = itemCenterX - groupCenterX;
                const dy = itemCenterY - groupCenterY;
                
                const rotatedCenterX = groupCenterX + dx * cos - dy * sin;
                const rotatedCenterY = groupCenterY + dx * sin + dy * cos;
                
                newX = rotatedCenterX - item.width / 2;
                newY = rotatedCenterY - item.height / 2;
              }
            }

            item.x = newX;
            item.y = newY;
            
            delete item.relativeX;
            delete item.relativeY;
            delete item.groupId;
            
            console.log('🔗 Element ungrouped:', { id: item.id, newX, newY });
          }
        });
      }

      this.groups = this.groups.filter((g) => g.id !== groupId);
      if (this.activeGroup === groupId) {
        this.activeGroup = null;
      }
      this.selectedItems = [];
      this.showGroupButton = false;
      
      // Reload Konva editor to show ungrouped elements
      if (this.$refs.konvaEditor) {
        if (this.$refs.konvaEditor.clearSelection) {
          this.$refs.konvaEditor.clearSelection();
        }
        if (this.$refs.konvaEditor.loadImages) {
          this.$refs.konvaEditor.loadImages();
        }
        if (this.$refs.konvaEditor.loadTexts) {
          this.$refs.konvaEditor.loadTexts();
        }
        if (this.$refs.konvaEditor.loadGroups) {
          this.$refs.konvaEditor.loadGroups();
        }
      }
      this.markDirty();
    },

    deleteGroupWithItems(groupId) {
      this.saveHistoryState();
      const group = this.groups.find((g) => g.id === groupId);
      if (group) {
        const itemIdsToRemove = [...group.items];
        this.droppedImages = this.droppedImages.filter((i) => !itemIdsToRemove.includes(i.id));
      }

      this.groups = this.groups.filter((g) => g.id !== groupId);
      if (this.activeGroup === groupId) {
        this.activeGroup = null;
      }
      this.markDirty();
    },

    handleGroupOpacityInput(event, groupId) {
      const value = parseInt(event.target.value);
      const opacity = value / 100;

      const group = this.groups.find((g) => g.id === groupId);
      if (group) {
        group.opacity = opacity;

        // Обновляем CSS переменную
        event.target.style.setProperty('--fill-position', `${value}%`);
      }
    },

    changeGroupZIndex(direction, groupId) {
      const group = this.groups.find((g) => g.id === groupId);
      if (!group) return;

      // Получаем все zIndex'ы
      const allZIndices = [...this.groups.map((g) => g.zIndex || 0), ...this.droppedImages.filter((i) => !this.isItemInGroup(i.id)).map((i) => i.zIndex || 0)].filter((z) => z !== undefined);

      const maxZIndex = allZIndices.length > 0 ? Math.max(...allZIndices) : 0;
      const minZIndex = allZIndices.length > 0 ? Math.min(...allZIndices) : 0;

      switch (direction) {
        case 'front':
          group.zIndex = maxZIndex + 1;
          break;
        case 'back':
          group.zIndex = minZIndex - 1;
          break;
        case 'up':
          group.zIndex = (group.zIndex || 0) + 1;
          break;
        case 'down':
          group.zIndex = Math.max(minZIndex, (group.zIndex || 0) - 1);
          break;
      }

      // Сортируем группы по zIndex
      this.groups.sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
    },
    getGroupedItemStyle(item, group) {
      if (!item || !group) return {};

      const originalState = group.elementsOriginalState?.[item.id] || {};
      const scale = this.currentScale;
      
      const width = item.width * scale;
      const height = item.height * scale;
      
      // BACKWARD COMPATIBILITY: поддержка старого и нового формата
      const deltaX = group.deltaX || 0;
      const deltaY = group.deltaY || 0;
      let itemX, itemY, groupCenterX, groupCenterY;
      
      if (group.x !== undefined && group.y !== undefined) {
        // Новый Konva-подход: группа имеет x, y, width, height
        groupCenterX = group.x + (group.width || 0) / 2;
        groupCenterY = group.y + (group.height || 0) / 2;
        
        if (item.relativeX !== undefined && item.relativeY !== undefined) {
          itemX = group.x + item.relativeX;
          itemY = group.y + item.relativeY;
        } else {
          itemX = item.x + deltaX;
          itemY = item.y + deltaY;
        }
      } else if (group.centerX !== undefined && group.centerY !== undefined) {
        // Старый подход: используем сохранённый centerX/centerY
        groupCenterX = group.centerX + deltaX;
        groupCenterY = group.centerY + deltaY;
        itemX = item.x + deltaX;
        itemY = item.y + deltaY;
      } else {
        // Fallback: вычисляем центр из элементов
        const groupElements = this.droppedImages.filter(el => el.groupId === group.id);
        let sumCenterX = 0, sumCenterY = 0;
        groupElements.forEach(el => {
          sumCenterX += el.x + deltaX + el.width / 2;
          sumCenterY += el.y + deltaY + el.height / 2;
        });
        groupCenterX = sumCenterX / groupElements.length;
        groupCenterY = sumCenterY / groupElements.length;
        itemX = item.x + deltaX;
        itemY = item.y + deltaY;
      }
      
      // Если группа повёрнута, вращаем позицию элемента вокруг центра группы
      const groupRotate = group.rotate || 0;
      if (groupRotate !== 0) {
        const itemCenterX = itemX + item.width / 2;
        const itemCenterY = itemY + item.height / 2;
        
        const angle = groupRotate * Math.PI / 180;
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        
        const relX = itemCenterX - groupCenterX;
        const relY = itemCenterY - groupCenterY;
        
        const rotatedX = relX * cos - relY * sin;
        const rotatedY = relX * sin + relY * cos;
        
        const newCenterX = groupCenterX + rotatedX;
        const newCenterY = groupCenterY + rotatedY;
        
        itemX = newCenterX - item.width / 2;
        itemY = newCenterY - item.height / 2;
      }
      
      const left = itemX * scale;
      const top = itemY * scale;

      const groupOpacity = group.opacity ?? 1;
      const itemOpacity = originalState.opacity ?? item.opacity ?? 1;
      const combinedOpacity = groupOpacity * itemOpacity;

      let transforms = [];
      
      // Вращение элемента = собственное вращение + вращение группы
      const itemRotation = originalState.rotation ?? item.rotate ?? 0;
      const totalRotation = itemRotation + groupRotate;
      
      if (originalState.flipX || group.flipX) transforms.push('scaleX(-1)');
      if (originalState.flipY || group.flipY) transforms.push('scaleY(-1)');
      if (totalRotation) transforms.push(`rotate(${totalRotation}deg)`);

      return {
        position: 'absolute',
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
        opacity: combinedOpacity,
        transform: transforms.join(' ') || 'none',
        transformOrigin: 'center center',
        pointerEvents: group.locked ? 'none' : 'auto',
        zIndex: originalState.zIndex || item.zIndex || 0,
        transition: 'none',
        boxSizing: 'border-box',
      };
    },

    getGroupedImageStyle(item, group) {
      const combinedFilters = this.getCombinedFilters(item.filters, group.filters);
      return {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        filter: this.generateFilterCSS(combinedFilters),
      };
    },

    getCombinedFilters(itemFilters = {}, groupFilters = {}) {
      const combined = {};

      // Для каждого типа фильтра определяем стратегию комбинирования
      this.filtersList.forEach((filter) => {
        const itemValue = itemFilters[filter.name] || 0;
        const groupValue = groupFilters[filter.name] || 0;

        switch (filter.name) {
          // Аддитивные фильтры - складываем значения
          case 'exposure':
          case 'contrast':
          case 'saturation':
          case 'temperature':
          case 'hue':
            combined[filter.name] = itemValue + groupValue;
            break;

          // Мультипликативные фильтры - перемножаем коэффициенты
          case 'highlights':
          case 'shadows':
            // Преобразуем в коэффициенты (0 = 1.0, +100 = 2.0, -100 = 0.5)
            // eslint-disable-next-line no-case-declarations
            const itemMultiplier = 1 + itemValue / 100;
            // eslint-disable-next-line no-case-declarations
            const groupMultiplier = 1 + groupValue / 100;
            // eslint-disable-next-line no-case-declarations
            const totalMultiplier = itemMultiplier * groupMultiplier;
            combined[filter.name] = (totalMultiplier - 1) * 100;
            break;

          // Особые случаи
          case 'blur':
          case 'grayscale':
            // Берем максимальное значение
            combined[filter.name] = Math.max(itemValue, groupValue);
            break;

          default:
            combined[filter.name] = itemValue + groupValue;
        }
      });

      return combined;
    },

    generateFilterCSS(filters) {
      if (!filters) return 'none';

      const parts = [];

      // Яркость (с учетом что 0 = 100%, +100 = 200%, -100 = 0%)
      if (filters.exposure !== undefined) {
        const brightness = 100 + filters.exposure;
        parts.push(`brightness(${Math.max(0, brightness)}%)`);
      }

      // Контраст (аналогично яркости)
      if (filters.contrast !== undefined) {
        const contrast = 100 + filters.contrast;
        parts.push(`contrast(${Math.max(0, contrast)}%)`);
      }

      // Насыщенность
      if (filters.saturation !== undefined) {
        const saturation = 100 + filters.saturation;
        parts.push(`saturate(${Math.max(0, saturation)}%)`);
      }

      // Температура (сепия)
      if (filters.temperature !== undefined) {
        parts.push(`sepia(${Math.min(Math.abs(filters.temperature), 100)}%)`);
      }

      // Оттенок
      if (filters.hue !== undefined) {
        parts.push(`hue-rotate(${filters.hue}deg)`);
      }

      // Тени/подсветка через drop-shadow
      if (filters.shadows !== undefined && filters.shadows !== 0) {
        const intensity = Math.abs(filters.shadows) / 20; // Меньше интенсивность
        const opacity = 0.6;
        const color = filters.shadows > 0 ? `0,0,0,${opacity}` : `255,255,255,${opacity}`;
        parts.push(`drop-shadow(0 0 ${intensity}px rgba(${color}))`);
      }

      // Блюр
      if (filters.blur !== undefined) {
        parts.push(`blur(${filters.blur}px)`);
      }

      // ЧБ
      if (filters.grayscale !== undefined) {
        parts.push(`grayscale(${filters.grayscale}%)`);
      }

      return parts.join(' ') || 'none';
    },

    getAppliedFilters(filters) {
      if (!filters) return 'none';

      let filterStr = '';

      if (filters.exposure !== undefined) filterStr += `brightness(${1 + filters.exposure / 100}) `;
      if (filters.contrast !== undefined) filterStr += `contrast(${100 + filters.contrast}%) `;
      if (filters.saturation !== undefined) filterStr += `saturate(${1 + filters.saturation / 100}) `;
      if (filters.temperature !== undefined) filterStr += `sepia(${Math.abs(filters.temperature) / 100}) `;
      if (filters.hue !== undefined) filterStr += `hue-rotate(${filters.hue}deg) `;
      // if (filters.highlights !== undefined)
      //   filterStr += `brightness(${1 + filters.highlights / 200}) `
      if (filters.shadows !== undefined) {
        const intensity = Math.abs(filters.shadows) / 10;
        const opacity = 0.8;
        const color = filters.shadows > 0 ? `0,0,0,${opacity}` : `255,255,255,${opacity}`;
        filterStr += `drop-shadow(0 0 ${intensity}px rgba(${color}))`;
      }

      return filterStr.trim() || 'none';
    },
    isItemInGroup(itemId) {
      return this.groups.some((group) => group.items && group.items.includes(itemId));
    },
    handleContextMenu(e) {
      e.preventDefault();
      if (this.selectedItems.length > 1) {
        this.showGroupButton = true;
        this.groupButtonPosition = {
          x: e.clientX,
          y: e.clientY,
        };
      }
    },

    toggleSelectionMode() {
      this.isSelectionMode = !this.isSelectionMode;
      
      // Закрываем меню утилит
      this.showUtilsMenu = false;

      // При выключении режима выделения сбрасываем состояние
      if (!this.isSelectionMode) {
        this.isDrawing = false;
        this.isSelecting = false;
        this.selectionPoints = [];
        this.selectionPath = '';
        this.tempSelectionPolygon.visible = false;
        this.tempSelectionRect.visible = false;
      } else {
        // При включении режима выделения скрываем все панели управления
        this.selectedItems = [];
        this.showControls = false;
        this.activeItemId = null;
        this.activeGroup = null;
        this.closeAllMenus();
      }
    },

    closeGroupButton() {
      this.showGroupButton = false;
    },

    getRotatedBoundingBox(item) {
      const rotation = (item.rotate || 0) * Math.PI / 180;
      const cx = item.x + item.width / 2;
      const cy = item.y + item.height / 2;
      
      const corners = [
        { x: item.x, y: item.y },
        { x: item.x + item.width, y: item.y },
        { x: item.x + item.width, y: item.y + item.height },
        { x: item.x, y: item.y + item.height }
      ];
      
      const rotatedCorners = corners.map(corner => {
        const dx = corner.x - cx;
        const dy = corner.y - cy;
        return {
          x: cx + dx * Math.cos(rotation) - dy * Math.sin(rotation),
          y: cy + dx * Math.sin(rotation) + dy * Math.cos(rotation)
        };
      });
      
      return {
        left: Math.min(...rotatedCorners.map(c => c.x)),
        top: Math.min(...rotatedCorners.map(c => c.y)),
        right: Math.max(...rotatedCorners.map(c => c.x)),
        bottom: Math.max(...rotatedCorners.map(c => c.y))
      };
    },

    createGroup() {
      console.log('🔗 createGroup called', {
        selectedItems: this.selectedItems,
        droppedImagesIds: this.droppedImages.map(i => ({ id: i.id, type: typeof i.id })),
        selectedItemsTypes: this.selectedItems.map(id => ({ id, type: typeof id }))
      });
      
      this.saveHistoryState();
      // Исключаем заблокированные элементы из группировки
      const selectedElements = this.droppedImages.filter((item) => item && this.selectedItems.includes(item.id) && !item._isBackground && !item.locked);
      
      console.log('🔗 selectedElements after filter:', selectedElements.length, selectedElements.map(e => e.id));
      
      if (selectedElements.length < 2) {
        console.log('🔗 Not enough elements to group, returning');
        return;
      }

      const groupId = `group-${Date.now()}`;

      // KONVA-ПОДХОД: вычисляем bounding box группы С УЧЁТОМ ПОВОРОТА
      // Функция для вычисления повёрнутых углов элемента
      const getRotatedCorners = (item) => {
        const cx = item.x + item.width / 2;
        const cy = item.y + item.height / 2;
        const hw = item.width / 2;
        const hh = item.height / 2;
        const angle = (item.rotate || 0) * Math.PI / 180;
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        
        // Четыре угла относительно центра, затем поворачиваем
        const corners = [
          { x: -hw, y: -hh }, // top-left
          { x: hw, y: -hh },  // top-right
          { x: hw, y: hh },   // bottom-right
          { x: -hw, y: hh }   // bottom-left
        ];
        
        return corners.map(c => ({
          x: cx + c.x * cos - c.y * sin,
          y: cy + c.x * sin + c.y * cos
        }));
      };
      
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      selectedElements.forEach((item) => {
        const corners = getRotatedCorners(item);
        corners.forEach(c => {
          minX = Math.min(minX, c.x);
          minY = Math.min(minY, c.y);
          maxX = Math.max(maxX, c.x);
          maxY = Math.max(maxY, c.y);
        });
      });
      
      const groupX = minX;
      const groupY = minY;
      const groupWidth = maxX - minX;
      const groupHeight = maxY - minY;
      
      console.log('🔗 Group bounding box (rotated):', { groupX, groupY, groupWidth, groupHeight });

      const elementsOriginalState = {};
      const newItems = [];

      // KONVA-ПОДХОД: конвертируем абсолютные координаты в относительные (используем ЦЕНТР элемента)
      selectedElements.forEach((item) => {
        // Центр элемента в абсолютных координатах
        const elementCenterX = item.x + item.width / 2;
        const elementCenterY = item.y + item.height / 2;
        
        // Сохраняем оригинальное состояние (абсолютные координаты для разгруппировки)
        elementsOriginalState[item.id] = {
          color: item.color,
          absoluteX: item.x,
          absoluteY: item.y,
          absoluteCenterX: elementCenterX,
          absoluteCenterY: elementCenterY,
          width: item.width,
          height: item.height,
          rotation: item.rotate || 0,
          flipX: item.flipX || false,
          flipY: item.flipY || false,
          opacity: item.opacity !== undefined ? item.opacity : 1,
          filters: item.filters ? { ...item.filters } : this.getDefaultFilters(),
          zIndex: item.zIndex || 0,
        };

        // КОНВЕРТИРУЕМ в относительные координаты (позиция ЦЕНТРА элемента относительно левого верхнего угла группы)
        item.relativeX = elementCenterX - groupX;
        item.relativeY = elementCenterY - groupY;
        item.groupId = groupId;

        newItems.push(item.id);
        
        console.log('🔗 Element converted (center-based):', {
          id: item.id,
          absoluteX: item.x,
          absoluteY: item.y,
          elementCenterX,
          elementCenterY,
          relativeX: item.relativeX,
          relativeY: item.relativeY,
          rotation: item.rotate || 0
        });
      });

      // Вычисляем и сохраняем центр группы явно
      const groupCenterX = groupX + groupWidth / 2;
      const groupCenterY = groupY + groupHeight / 2;
      
      const group = {
        id: groupId,
        // KONVA-ПОДХОД: группа имеет свою позицию и размеры
        x: groupX,
        y: groupY,
        width: groupWidth,
        height: groupHeight,
        // Храним центр группы явно для корректной работы с поворотом
        centerX: groupCenterX,
        centerY: groupCenterY,
        items: newItems,
        locked: false,
        opacity: 1,
        rotate: 0,
        flipX: false,
        flipY: false,
        zIndex: Math.max(...this.groups.map((g) => g.zIndex || 0), 0) + 1,
        elementsOriginalState: elementsOriginalState,
        filters: this.getDefaultFilters(),
      };

      this.groups.push(group);
      this.activeGroup = group.id;
      this.showControls = true;

      console.log('🔗 Group created (Konva approach):', {
        groupId: group.id,
        x: group.x,
        y: group.y,
        width: group.width,
        height: group.height,
        items: group.items
      });

      // Mark as dirty to trigger auto-save
      this.markDirtyAndSync();

      // СБРОС ВЫДЕЛЕНИЯ
      this.selectedItems = [];
      this.showGroupBorder = false;
      this.showGroupButton = false;

      // Сбрасываем лассо-выделение
      this.isDrawing = false;
      this.isSelecting = false;
      this.selectionPoints = [];
      this.selectionPath = '';
      this.tempSelectionPolygon.visible = false;
      this.tempSelectionRect.visible = false;
      this.isSelectionMode = false;
      
      // Clear Konva selection and reload groups
      if (this.$refs.konvaEditor) {
        if (this.$refs.konvaEditor.clearSelection) {
          this.$refs.konvaEditor.clearSelection();
        }
        if (this.$refs.konvaEditor.loadGroups) {
          this.$refs.konvaEditor.loadGroups();
        }
      }
    },

    getGroupStyle(group) {
      if (!group) return {};
      const scale = this.currentScale;

      const transforms = [];
      if (group.flipX) transforms.push('scaleX(-1)');
      if (group.flipY) transforms.push('scaleY(-1)');
      transforms.push(`rotate(${group.rotate || 0}deg)`);

      return {
        position: 'absolute',
        left: `${group.x * scale}px`,
        top: `${group.y * scale}px`,
        width: `${group.width * scale}px`,
        height: `${group.height * scale}px`,
        zIndex: group.zIndex || 0,
        transformOrigin: 'center center',
        transform: transforms.join(' '),
      };
    },

    getGroupStyleWithoutRotate(group) {
      if (!group) return {};
      const zIndex = group.zIndex || 0;

      // НОВЫЙ ПОДХОД: контейнер группы занимает весь холст
      // Элементы внутри позиционируются абсолютно
      // Вращение группы применяется к каждому элементу индивидуально в getGroupedItemStyle
      
      return {
        position: 'absolute',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
        zIndex: zIndex,
        pointerEvents: 'none',
      };
    },

    getGroupControlsCounterStyle(group) {
      if (!group) return {};
      const counterTransforms = [];
      if (group.flipX) counterTransforms.push('scaleX(-1)');
      if (group.flipY) counterTransforms.push('scaleY(-1)');
      if (group.rotate) counterTransforms.push(`rotate(${-group.rotate}deg)`);
      
      return {
        transform: counterTransforms.length > 0 ? counterTransforms.join(' ') : 'none',
      };
    },

    startGroupResize(group, e, handle) {
      e.preventDefault();
      e.stopPropagation();

      const getEventCoords = (event) => {
        if (event.type.includes('touch') && event.touches && event.touches[0]) {
          return { clientX: event.touches[0].clientX, clientY: event.touches[0].clientY };
        }
        return { clientX: event.clientX, clientY: event.clientY };
      };

      const startCoords = getEventCoords(e);
      const startX = startCoords.clientX;
      const startY = startCoords.clientY;
      const startWidth = group.width;
      const startHeight = group.height;
      const startLeft = group.x;
      const startTop = group.y;
      const rotationRad = ((group.rotate || 0) * Math.PI) / 180;

      const contentRect = this.$refs.contentRef.getBoundingClientRect();
      const containerWidthNorm = contentRect.width / this.currentScale;
      const containerHeightNorm = contentRect.height / this.currentScale;

      const minWidth = 50;
      const minHeight = 50;
      const maxWidth = Math.max(0, containerWidthNorm - startLeft);
      const maxHeight = Math.max(0, containerHeightNorm - startTop);

      const originalItems = group.items.map((itemId) => {
        const item = this.droppedImages.find((i) => i.id === itemId);
        return {
          id: itemId,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
        };
      });

      const onMouseMove = (moveEvent) => {
        const coords = getEventCoords(moveEvent);
        const rawDx = (coords.clientX - startX) / this.currentScale;
        const rawDy = (coords.clientY - startY) / this.currentScale;

        // Преобразуем дельту движения мыши в локальную систему координат группы
        // с учётом угла поворота (обратное вращение)
        const cos = Math.cos(-rotationRad);
        const sin = Math.sin(-rotationRad);
        const dxNorm = rawDx * cos - rawDy * sin;
        const dyNorm = rawDx * sin + rawDy * cos;

        let newWidth = startWidth;
        let newHeight = startHeight;
        let newLeft = startLeft;
        let newTop = startTop;

        switch (handle) {
          case 'right':
            newWidth = startWidth + dxNorm;
            break;
          case 'left':
            newWidth = startWidth - dxNorm;
            newLeft = startLeft + dxNorm;
            break;
          case 'bottom':
            newHeight = startHeight + dyNorm;
            break;
          case 'top':
            newHeight = startHeight - dyNorm;
            newTop = startTop + dyNorm;
            break;
          case 'top-right':
            newHeight = startHeight - dyNorm;
            newTop = startTop + dyNorm;
            newWidth = startWidth + dxNorm;
            break;
          case 'top-left':
            newHeight = startHeight - dyNorm;
            newTop = startTop + dyNorm;
            newWidth = startWidth - dxNorm;
            newLeft = startLeft + dxNorm;
            break;
          case 'bottom-left':
            newHeight = startHeight + dyNorm;
            newWidth = startWidth - dxNorm;
            newLeft = startLeft + dxNorm;
            break;
          case 'bottom-right':
            newHeight = startHeight + dyNorm;
            newWidth = startWidth + dxNorm;
            break;
        }

        // ⚖️ Ограничения с учетом позиции
        if (handle.includes('left')) {
          const clampedLeft = Math.max(0, newLeft);
          newWidth = startWidth + (startLeft - clampedLeft);
          newLeft = clampedLeft;
        }
        if (handle.includes('top')) {
          const clampedTop = Math.max(0, newTop);
          newHeight = startHeight + (startTop - clampedTop);
          newTop = clampedTop;
        }

        newWidth = Math.min(Math.max(minWidth, newWidth), maxWidth);
        newHeight = Math.min(Math.max(minHeight, newHeight), maxHeight);

        group.width = newWidth;
        group.height = newHeight;
        group.x = newLeft;
        group.y = newTop;

        // 📐 Считаем коэффициенты масштабирования
        const scaleX = newWidth / startWidth;
        const scaleY = newHeight / startHeight;

        // 🔄 Обновляем элементы
        originalItems.forEach((originalItem) => {
          const item = this.droppedImages.find((i) => i.id === originalItem.id);
          if (item) {
            item.x = group.x + (originalItem.x - startLeft) * scaleX;
            item.y = group.y + (originalItem.y - startTop) * scaleY;
            item.width = originalItem.width * scaleX;
            item.height = originalItem.height * scaleY;
          }
        });
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('touchmove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('touchend', onMouseUp);
        this.activeResizeHandle = null;
        this.activeInteraction = null;
        this.markDirtyAndSync();
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('touchmove', onMouseMove, { passive: false });
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('touchend', onMouseUp);
    },

    handleGroupResizeHandleTap(group, event, handle) {
      // НОВАЯ УПРОЩЁННАЯ ЛОГИКА для групп
      event.preventDefault();
      event.stopPropagation();
      
      // Блокируем если уже идёт взаимодействие
      if (this.activeInteraction) {
        return;
      }
      
      const groupHandleKey = `group-${handle}`;
      const isTouchEvent = event.type.includes('touch');
      
      // Для мыши — сразу начинаем resize
      if (!isTouchEvent) {
        this.activeResizeHandle = groupHandleKey;
        this.activeInteraction = { type: 'resize', targetId: group.id, handle, isGroup: true };
        this.startGroupResize(group, event, handle);
        return;
      }
      
      // Touch: начинаем resize при движении
      const getEventCoords = (e) => {
        if (e.type?.includes('touch') && e.touches && e.touches[0]) {
          return { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
        if (e.type?.includes('touch') && e.changedTouches && e.changedTouches[0]) {
          return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
        }
        return { x: e.clientX, y: e.clientY };
      };
      
      const startCoords = getEventCoords(event);
      let resizeStarted = false;
      const moveThreshold = 10; // Увеличен порог чтобы тап не срабатывал как resize
      
      const cleanup = () => {
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
        document.removeEventListener('touchcancel', onTouchEnd);
      };
      
      const onTouchMove = (e) => {
        e.preventDefault();
        const coords = getEventCoords(e);
        const dx = Math.abs(coords.x - startCoords.x);
        const dy = Math.abs(coords.y - startCoords.y);
        
        if (!resizeStarted && (dx > moveThreshold || dy > moveThreshold)) {
          resizeStarted = true;
          this.activeResizeHandle = groupHandleKey;
          this.activeInteraction = { type: 'resize', targetId: group.id, handle, isGroup: true };
          cleanup();
          this.startGroupResize(group, e, handle);
        }
      };
      
      const onTouchEnd = () => {
        cleanup();
        if (!resizeStarted) {
          this.activeResizeHandle = null;
          this.activeInteraction = null;
        }
      };
      
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('touchend', onTouchEnd);
      document.addEventListener('touchcancel', onTouchEnd);
    },

    moveGroup(groupId, dx, dy) {
      const group = this.groups.find((g) => g.id === groupId);
      if (!group) return;

      group.x += dx;
      group.y += dy;

      group.items.forEach((itemId) => {
        const item = this.droppedImages.find((i) => i.id === itemId);
        if (item) {
          item.x += dx;
          item.y += dy;
        }
      });
    },

    startSelection(e) {
      if (!this.isSelectionMode) return;
      const event = e.type.includes('touch') ? e.touches[0] : e;
      
      // На touch-устройствах target может быть дочерним элементом
      const isTouch = e.type.includes('touch');
      const target = e.target;
      const isValidTarget = isTouch 
        ? (target === this.$refs.contentRef || this.$refs.contentRef?.contains(target))
        : (target === this.$refs.contentRef);
      if (!isValidTarget) return;

      this.isSelecting = true;
      this.isDrawing = true;

      const rect = this.$refs.contentRef.getBoundingClientRect();
      const startX = event.clientX - rect.left;
      const startY = event.clientY - rect.top;

      // Начинаем новую линию
      this.selectionPoints = [{ x: startX, y: startY }];
      this.selectionPath = `M ${startX} ${startY}`;

      this.selectionStart = this.selectionEnd = {
        x: startX,
        y: startY,
      };

      // Сбрасываем временный прямоугольник и полигон
      this.tempSelectionRect.visible = false;
      this.tempSelectionPolygon.visible = false;

      // Всегда снимаем выделение с групп при начале нового выделения
      if (!e.ctrlKey && !e.metaKey) {
        this.selectedItems = [];
        this.activeGroup = null;
        this.showGroupBorder = false;
        this.showGroupButton = false;
      }

      if (e.type.includes('touch')) {
        e.preventDefault();
      }
    },

    handleSelection(e) {
      if (!this.isSelectionMode) return;
      if (!this.isSelecting || !this.isDrawing) return;

      const event = e.type.includes('touch') ? e.touches[0] : e;
      const rect = this.$refs.contentRef.getBoundingClientRect();

      const currentX = event.clientX - rect.left;
      const currentY = event.clientY - rect.top;

      // Добавляем новую точку в путь
      this.selectionPoints.push({ x: currentX, y: currentY });
      this.selectionPath += ` L ${currentX} ${currentY}`;

      this.selectionEnd = {
        x: currentX,
        y: currentY,
      };

      e.preventDefault();
    },

    endSelection() {
      if (!this.isSelectionMode) return;
      if (!this.isSelecting || !this.isDrawing) return;
      this.isDrawing = false;

      // Сохраняем полигон для отображения
      if (this.selectionPoints.length > 2) {
        this.tempSelectionPolygon = {
          visible: true,
          points: [...this.selectionPoints],
        };
      }

      this.updateSelectedItems();
      this.showGroupBorder = this.selectedItems.length > 1;
      this.showGroupButton = this.selectedItems.length > 1;

      // Проверяем количество выделенных элементов
      if (this.selectedItems.length < 2) {
        // Если элементов меньше двух, отключаем режим выделения
        this.isSelectionMode = false;
        // Сбрасываем выделение
        this.selectedItems = [];
        this.showGroupBorder = false;
        this.showGroupButton = false;
        // Скрываем линию рисования и полигон
        this.selectionPath = '';
        this.tempSelectionPolygon.visible = false;
        this.tempSelectionRect.visible = false;
      }

      // Позиция кнопки группировки
      if (this.showGroupButton) {
        const center = this.calculateSelectionCenter();
        this.groupButtonPosition = {
          x: center.x,
          y: center.y + 20,
        };
      }

      // Скрываем линию рисования, но показываем заполненный полигон
      this.selectionPath = this.getClosedPath(this.selectionPoints);
      this.isSelecting = false;
    },

    // Закрываем путь для SVG
    getClosedPath(points) {
      if (points.length < 2) return '';

      let path = `M ${points[0].x} ${points[0].y}`;
      for (let i = 1; i < points.length; i++) {
        path += ` L ${points[i].x} ${points[i].y}`;
      }
      path += ' Z'; // Замыкаем путь
      return path;
    },

    // Вычисляем центр выделенной области
    calculateSelectionCenter() {
      if (this.selectionPoints.length === 0) return { x: 0, y: 0 };

      const xs = this.selectionPoints.map((p) => p.x);
      const ys = this.selectionPoints.map((p) => p.y);

      return {
        x: (Math.min(...xs) + Math.max(...xs)) / 2,
        y: (Math.min(...ys) + Math.max(...ys)) / 2,
      };
    },

    calculateSelectionBoundingBox() {
      if (this.selectionPoints.length < 2) return;

      // Находим min/max координаты для создания bounding box
      const xCoords = this.selectionPoints.map((p) => p.x);
      const yCoords = this.selectionPoints.map((p) => p.y);

      const minX = Math.min(...xCoords);
      const maxX = Math.max(...xCoords);
      const minY = Math.min(...yCoords);
      const maxY = Math.max(...yCoords);

      this.tempSelectionRect = {
        visible: true,
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY,
      };

      // Обновляем selectionStart и selectionEnd для корректного выделения
      this.selectionStart = { x: minX, y: minY };
      this.selectionEnd = { x: maxX, y: maxY };
    },

    calculateRectSelection() {
      const left = Math.min(this.selectionStart.x, this.selectionEnd.x);
      const top = Math.min(this.selectionStart.y, this.selectionEnd.y);
      const right = Math.max(this.selectionStart.x, this.selectionEnd.x);
      const bottom = Math.max(this.selectionStart.y, this.selectionEnd.y);

      this.tempSelectionRect = {
        visible: true,
        x: left,
        y: top,
        width: right - left,
        height: bottom - top,
      };
    },

    updateSelectedItems() {
      if (this.selectionPoints.length < 3) {
        // Если точек мало, используем прямоугольное выделение
        this.calculateRectSelection();
        return this.updateRectSelectedItems();
      }

      // Используем полигональное выделение для лассо
      this.updateLassoSelectedItems();
    },

    updateRectSelectedItems() {
      const left = this.tempSelectionRect.x;
      const top = this.tempSelectionRect.y;
      const right = left + this.tempSelectionRect.width;
      const bottom = top + this.tempSelectionRect.height;
      const scale = this.currentScale;

      this.selectedItems = this.droppedImages
        .filter((item) => {
          if (!item || item.isBackground || item.locked || item.groupId) {
            return false;
          }

          // Масштабируем координаты элементов к экранным пикселям
          const itemLeft = item.x * scale;
          const itemRight = (item.x + item.width) * scale;
          const itemTop = item.y * scale;
          const itemBottom = (item.y + item.height) * scale;

          return itemRight > left && itemLeft < right && itemBottom > top && itemTop < bottom;
        })
        .map((item) => item.id);
    },

    // Алгоритм проверки точки в полигоне (Ray Casting)
    isPointInPolygon(point, polygon) {
      const x = point.x,
        y = point.y;
      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].x,
          yi = polygon[i].y;
        const xj = polygon[j].x,
          yj = polygon[j].y;

        const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }
      return inside;
    },

    // Проверяем, попадает ли элемент в полигон
    isItemInPolygon(item, polygon) {
      const scale = this.currentScale;
      
      // Масштабируем углы элемента к экранным координатам
      const corners = [
        { x: item.x * scale, y: item.y * scale }, // левый верхний
        { x: (item.x + item.width) * scale, y: item.y * scale }, // правый верхний
        { x: (item.x + item.width) * scale, y: (item.y + item.height) * scale }, // правый нижний
        { x: item.x * scale, y: (item.y + item.height) * scale }, // левый нижний
      ];

      // Центр элемента (масштабированный)
      const center = {
        x: (item.x + item.width / 2) * scale,
        y: (item.y + item.height / 2) * scale,
      };

      // Элемент считается выбранным если:
      // 1. Его центр находится внутри полигона
      // 2. Или хотя бы один угол находится внутри полигона
      // 3. Или элемент пересекает границу полигона

      if (this.isPointInPolygon(center, polygon)) {
        return true;
      }

      // Проверяем углы
      for (const corner of corners) {
        if (this.isPointInPolygon(corner, polygon)) {
          return true;
        }
      }

      // Проверяем пересечение границ (упрощенная проверка)
      return this.doesRectangleIntersectPolygon(item, polygon);
    },

    // Упрощенная проверка пересечения прямоугольника и полигона
    doesRectangleIntersectPolygon(item, polygon) {
      const scale = this.currentScale;
      const rect = {
        left: item.x * scale,
        top: item.y * scale,
        right: (item.x + item.width) * scale,
        bottom: (item.y + item.height) * scale,
      };

      // Проверяем пересечение каждой стороны полигона с прямоугольником
      for (let i = 0; i < polygon.length; i++) {
        const p1 = polygon[i];
        const p2 = polygon[(i + 1) % polygon.length];

        if (this.lineIntersectsRect(p1, p2, rect)) {
          return true;
        }
      }

      return false;
    },

    // Проверка пересечения линии и прямоугольника
    lineIntersectsRect(p1, p2, rect) {
      // Упрощенная проверка - можно использовать более точные алгоритмы
      const lineLeft = Math.min(p1.x, p2.x);
      const lineRight = Math.max(p1.x, p2.x);
      const lineTop = Math.min(p1.y, p2.y);
      const lineBottom = Math.max(p1.y, p2.y);

      return !(lineRight < rect.left || lineLeft > rect.right || lineBottom < rect.top || lineTop > rect.bottom);
    },

    updateLassoSelectedItems() {
      const polygon = this.selectionPoints;

      this.selectedItems = this.droppedImages
        .filter((item) => {
          if (!item || item.isBackground || item.locked || item.groupId) {
            return false;
          }
          return this.isItemInPolygon(item, polygon);
        })
        .map((item) => item.id);

      if (this.selectedItems.length > 0) {
        this.activeGroup = null;
      }
    },

    handleItemClick(id, event) {
      const prevActiveId = this.activeItemId;
      const droppedCount = this.droppedImages.length;
      
      logger.debug('handleItemClick START', {
        context: {
          clickedId: id,
          prevActiveId,
          droppedImagesCount: droppedCount,
          showControls: this.showControls,
          isMobile: this.isMobile,
          eventType: event?.type
        }
      });
      
      // На мобильном: блокируем переключение на другой элемент, пока не нажат крестик
      if (this.isMobile && this.activeItemId && this.activeItemId !== id) {
        logger.debug('handleItemClick BLOCKED - mobile element locked', {
          context: { activeItemId: this.activeItemId, clickedId: id }
        });
        return;
      }
      
      this.activeResizeHandle = null;
      this.hideActiveElement = false;
      
      // Проверяем, принадлежит ли элемент к группе
      const item = this.droppedImages.find((item) => item.id === id);
      if (item && item.groupId) {
        // Если элемент в группе - выделяем всю группу
        const group = this.groups.find((g) => g.id === item.groupId);
        if (group) {
          if (event.ctrlKey || event.metaKey) {
            // При Ctrl+click переключаем выделение группы
            if (this.activeGroup === group.id) {
              this.activeGroup = null;
              this.selectedItems = [];
            } else {
              this.activeGroup = group.id;
              this.selectedItems = [];
            }
          } else {
            // Обычный click - выделяем только группу
            this.activeGroup = group.id;
            this.selectedItems = [];
          }
          this.showGroupBorder = false;
          this.showControls = true;
          return;
        }
      }

      // Если элемент не в группе или группа не найдена
      if (this.activeGroup) {
        this.activeGroup = null;
        this.selectedItems = [];
      }

      if (event.ctrlKey || event.metaKey) {
        if (this.selectedItems.includes(id)) {
          this.selectedItems = this.selectedItems.filter((itemId) => itemId !== id);
          if (this.activeItemId === id) {
            this.activeItemId = null;
          }
        } else {
          // Проверяем, что элемент не в группе
          if (!item || !item.groupId) {
            this.selectedItems.push(id);
            this.activeItemId = id;
            // Если выбран текстовый элемент через Ctrl+click, переключаем сайдбар на "Текст" (только на десктопе)
            if (item && item.type === 'text' && !this.isMobile) {
              this.$nextTick(() => {
                if (this.$refs.sidebarRef) {
                  this.$refs.sidebarRef.setActiveIcon('Текст');
                }
              });
            }
          }
        }
      } else {
        // Проверяем, что элемент не в группе
        if (!item || !item.groupId) {
          this.selectedItems = [id];
          this.activeItemId = id;
        }
      }

      this.showGroupBorder = this.selectedItems.length > 1;
      this.showControls = true;

      // Если выбран текстовый элемент, автоматически переключаем сайдбар на вкладку "Текст" (только на десктопе)
      if (item && item.type === 'text' && !this.isMobile) {
        this.$nextTick(() => {
          if (this.$refs.sidebarRef) {
            this.$refs.sidebarRef.setActiveIcon('Текст');
          }
        });
      }
      
      logger.debug('handleItemClick END', {
        context: {
          newActiveId: this.activeItemId,
          showControls: this.showControls,
          selectedItemsCount: this.selectedItems.length,
          activeGroup: this.activeGroup,
          activeItemData: this.activeItemData ? { id: this.activeItemData.id, type: this.activeItemData.type } : null
        }
      });
    },
    updateText(itemId, newText) {
      const item = this.droppedImages.find((i) => i.id === itemId);
      if (item) {
        if (item.type === 'text') {
          item.text = newText;
          this.saveCurrentZone();
        }
      }
    },
    handleFilterChange(event, itemId, filterName) {
      const value = parseFloat(event.target.value);
      const filter = this.filtersList.find((f) => f.name === filterName);

      const item = this.droppedImages.find((i) => i.id === itemId);
      if (item) {
        if (!item.filters) item.filters = this.getDefaultFilters();
        item.filters[filterName] = value;

        const normalizedValue = ((value - filter.min) / (filter.max - filter.min)) * 100;
        event.target.style.setProperty('--fill-position', `${normalizedValue}%`);
        this.markDirtyAndSync();
      }
    },
    mirrorGroup(groupId, axis = 'x') {
      this.closeAllMenus();
      const group = this.groups.find((g) => g.id === groupId);
      if (!group) return;

      if (axis === 'x') {
        group.flipX = !group.flipX;
      } else {
        group.flipY = !group.flipY;
      }

      // Обновляем отображение элементов группы
      this.$forceUpdate();
    },

    updateItemSize(id, { x, y, width, height, fontSize }) {
      if (!this.sizeHistorySaved) {
        this.saveHistoryState();
        this.sizeHistorySaved = true;
        setTimeout(() => { this.sizeHistorySaved = false; }, 300);
      }
      const item = this.droppedImages.find((i) => i.id === id);

      if (item) {
        if (x !== undefined) item.x = x;
        if (y !== undefined) item.y = y;
        item.width = width;
        item.height = height;
        if (fontSize !== undefined) item.fontSize = fontSize;
        this.markDirtyAndSync();
      }
    },

    handleRouteUpdate() {
      const zoneId = this.$route.query.zone;
      if (zoneId !== undefined) {
        this.currentSlideId = parseInt(zoneId, 10);
      }
    },

    setTextRef(id, el) {
      if (el) {
        this.textElements[id] = el;
      }
    },

    prepareSave() {
      this.currentProjectData = {
        zoneId: this.activeZoneId,
        images: JSON.parse(JSON.stringify(this.droppedImages)),
        preview: this.generatePreview(),
      };
      this.showSaveModal = true;
    },
    handleFotozoneChange(id) {
      if (id === this.currentSlideId) return;
      this.switchZone(id);
      this.$router
        .push({
          query: { ...this.$route.query, zone: id },
        })
        .catch(() => {});
    },
    setActiveIcon(id) {
      this.activeIcon = id;
      if (!this.isMobile && id) {
        this.showLayersPanel = false;
      }
    },

    initZoneState(zoneId) {
      if (!this.zonesState[zoneId]) {
        this.zonesState[zoneId] = {
          background: null,
          elements: [],
          settings: {},
        };
      }
    },

    async switchZone(newZoneId) {
      if (this.activeZoneId === newZoneId) return;

      this.isZoneLoading = true;
      
      try {
        await this.setActiveZone(newZoneId);
        this.syncZoneDataToLocal();
      } catch (error) {
        console.error('Error switching zone:', error);
      } finally {
        setTimeout(() => {
          this.isZoneLoading = false;
        }, 300);
      }
    },

    loadFontsForActiveZone() {
      this.droppedImages.filter((item) => item.type === 'text').forEach(this.loadFontForTextItem);
    },

    loadFontForTextItem(item) {
      if (!item.fontName || !item.fontUrl || this.isFontLoaded(item.fontName)) return;

      const fontFaceRule = `@font-face {
      font-family: '${item.fontName}';
      src: url('${item.fontUrl}') format('truetype');
    }`;

      const style = document.createElement('style');
      style.textContent = fontFaceRule;
      document.head.appendChild(style);

      this.loadedFonts[item.fontName] = true;
    },

    onSlideChange(newZoneId) {
      this.switchZone(newZoneId);

      this.slidesId = newZoneId;
      this.$emit('update:activeSlideId', newZoneId);
    },

    isFontLoaded(fontName) {
      return this.loadedFonts[fontName];
    },

    handleAddText(textData) {
      const fontData = {
        isGoogleFont: textData.isGoogleFont || false,
        isUserFont: textData.isUserFont || false,
        fontFamily: textData.fontName,
        fontName: textData.fontName,
        category: 'sans-serif',
      };
      this.addFontToContent(fontData);
    },

    addFontToContent(fontData) {
      let fontName, fontUrl;

      if (fontData.isGoogleFont) {
        fontName = fontData.fontFamily;
        fontUrl = null;
      } else if (fontData.isUserFont) {
        fontName = fontData.fontFamily || fontData.fontName;
        fontUrl = null;
      } else {
        if (!fontData?.url || typeof fontData.url !== 'string') {
          console.error('Invalid font URL:', fontData);
          return;
        }
        fontUrl = `${process.env.VUE_APP_API_URL}/${fontData.url}?v=${Date.now()}`;
        if (!fontUrl) {
          console.error('Failed to construct font URL for:', fontData);
          return;
        }
        fontName = `custom_font_${fontData.fontId}`;
      }

      // Check if there's an active text element - if so, change its font
      if (this.activeItemId !== null) {
        const activeItem = this.droppedImages.find(img => img.id === this.activeItemId);
        if (activeItem && activeItem.type === 'text') {
          // Update the font of the active text element
          activeItem.fontName = fontName;
          activeItem.fontUrl = fontUrl;
          activeItem.fontId = fontData.fontId || null;
          activeItem.isGoogleFont = fontData.isGoogleFont || false;
          activeItem.fontCategory = fontData.category || 'sans-serif';
          
          if (!fontData.isGoogleFont) {
            this.loadFontForTextItem(activeItem);
          }
          
          this.markDirtyAndSync();
          return;
        }
      }

      // No active text element, create a new one
      this.saveHistoryState();
      const maxNonBackgroundZIndex = Math.max(
        ...this.droppedImages.filter(img => !img._isBackground).map(img => img.zIndex || 0),
        0
      );

      const newTextItem = {
        id: Date.now(),
        draggable: true,
        resizable: true,
        type: 'text',
        text: this.$t('legacy.Введите текст'),
        fontName: fontName,
        fontUrl: fontUrl,
        fontId: fontData.fontId || null,
        isGoogleFont: fontData.isGoogleFont || false,
        isUserFont: fontData.isUserFont || false,
        fontCategory: fontData.category || 'sans-serif',
        x: fontData.x || 50,
        y: fontData.y || 50,
        width: 280,
        height: 65,
        fontSize: 32,
        rotate: 0,
        scale: 1,
        zIndex: maxNonBackgroundZIndex + 1,
        locked: false,
        opacity: 1,
        color: '#000000',
      };
      this.droppedImages.push(newTextItem);
      
      if (!fontData.isGoogleFont && !fontData.isUserFont) {
        this.loadFontForTextItem(newTextItem);
      }
      
      this.markDirtyAndSync();
    },

    saveCurrentZone() {
      if (this.activeZoneId === null) return;

      this.zonesData[this.activeZoneId] = {
        background: this.droppedImages.find((img) => img.isBackground) || null,
        elements: this.droppedImages
          .filter((img) => !img.isBackground)
          .map((item) => {
            if (item.type === 'text') {
              return {
                ...item,
                text: item.text,
              };
            }
            return item;
          }),
      };
    },

    setActiveItem(id) {
      this.activeItemId = id;
      this.showControls = true;
    },

    getItemKey(item, index) {
      return item?.id ? `item-${item.id}` : `item-${index}`;
    },

    getItemStyle(item) {
      if (!item) return {};
      const scale = this.currentScale;
      const zIndex = item.zIndex ?? 1;
      console.log(`🎯 getItemStyle for item ${item.id}: zIndex=${zIndex}`);
      const baseStyle = {
        top: `${item.y * scale}px`,
        left: `${item.x * scale}px`,
        width: `${item.width * scale}px`,
        height: `${item.height * scale}px`,
        zIndex: zIndex,
        position: 'absolute',
        boxSizing: 'border-box',
        transform: `${item.flipX ? 'scaleX(-1) ' : ''}rotate(${item.rotate || 0}deg)`,
        transformOrigin: 'center center',
      };

      if (item.type === 'text') {
        baseStyle.opacity = item.opacity ?? 1;
        baseStyle.pointerEvents = 'auto';
      }

      return baseStyle;
    },

    toggleCategory(id) {
      this.categories.forEach((category) => {
        const subcategory = category.subcategories.find((sub) => sub.id === id);
        if (subcategory) subcategory.open = !subcategory.open;
      });
    },

    applyFontToInput(itemId) {
      this.$nextTick(() => {
        const item = this.droppedImages.find((img) => img.id === itemId);
        if (!item) return;

        const inputEl = document.querySelector(`[data-text-id="${itemId}"] input`);
        if (inputEl) {
          const fontName = `custom_font_${item.fontId}`;
          inputEl.style.fontFamily = fontName;
        }
      });
    },

    updateTextContent(id, event) {
      const item = this.droppedImages.find((img) => img.id === id);
      if (item && event?.target) {
        item.text = event.target.textContent;
        item.x = event.target.offsetLeft;
      }
    },

    handleTextColorChange(id, color) {
      const item = this.droppedImages.find((img) => img.id === id);
      if (item) {
        item.color = color;
        this.markDirtyAndSync();
      }
    },

    handleTextShadowChange(id, hasShadow) {
      const item = this.droppedImages.find((img) => img.id === id);
      if (item) {
        item.textShadow = hasShadow;
        this.markDirtyAndSync();
      }
    },

    handleMobileTextColorChange(event, id) {
      const item = this.droppedImages.find((img) => img.id === id);
      if (item) {
        item.color = event.target.value;
        this.markDirtyAndSync();
      }
    },

    toggleMobileTextShadow(id) {
      const item = this.droppedImages.find((img) => img.id === id);
      if (item) {
        item.textShadow = !item.textShadow;
        this.markDirtyAndSync();
      }
    },

    setTextColor(id, color) {
      const item = this.droppedImages.find((img) => img.id === id);
      if (item) {
        item.color = color;
        this.markDirtyAndSync();
      }
    },

    handleMobileFontSizeChange(e, id) {
      const size = parseInt(e.target.value);
      const item = this.droppedImages.find((img) => img.id === id);
      if (item) {
        item.fontSize = size;
        this.saveHistoryState();
        this.markDirtyAndSync();
      }
    },

    getFontSizeSliderStyle(value) {
      const min = 12;
      const max = 360;
      const percent = ((value - min) / (max - min)) * 100;
      return {
        background: `linear-gradient(to right, #4A90D9 0%, #4A90D9 ${percent}%, #e5e7eb ${percent}%, #e5e7eb 100%)`
      };
    },

    handleFontTouchStart(e) {
      if (e.touches && e.touches.length > 0) {
        this.fontTouchStartY = e.touches[0].clientY;
      }
    },

    handleFontTouchEnd(e, id, font) {
      if (this.fontTouchStartY === null) {
        this.applyFontToText(id, font);
        return;
      }

      const touchEndY = e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0].clientY : this.fontTouchStartY;
      const deltaY = Math.abs(touchEndY - this.fontTouchStartY);

      this.fontTouchStartY = null;

      if (deltaY < 10) {
        this.applyFontToText(id, font);
      }
    },

    applyFontToText(id, font) {
      const item = this.droppedImages.find((img) => img.id === id);
      if (item && item.type === 'text') {
        item.fontName = font.family;
        item.fontCategory = font.category;
        this.mobileFontPanelOpen = false;
        this.markDirtyAndSync();
      }
    },

    displayText(item) {
      return item.text || this.$t('legacy.Введите текст');
    },

    getTextElementStyle(item) {
      const scale = this.currentScale;
      return {
        top: `${item.y * scale}px`,
        left: `${item.x * scale}px`,
        width: `${item.width * scale}px`,
        height: `${item.height * scale}px`,
        zIndex: item.zIndex || 1,
        transform: `rotate(${item.rotate || 0}deg) scale(${item.scale || 1})`,
        opacity: item.opacity ?? 1,
      };
    },

    getTextContentStyle(item) {
      return {
        maxWidth: '100%',
        maxHeight: '100%',
        transform: `scale(${1 / (item.scale || 1)})`,
      };
    },

    activateItem(itemId) {
      this.droppedImages.forEach((img) => {
        if (img.id !== itemId) {
          img.zIndex = img.zIndex || 0;
        }
      });

      const activeItem = this.droppedImages.find((img) => img.id === itemId);
      if (activeItem) {
        activeItem.zIndex = 9999;
      }

      this.activeItemId = itemId;
      this.showControls = true;
    },

    handleItemMouseDown(item, event) {
      // НОВАЯ УПРОЩЁННАЯ ЛОГИКА (без двойных тапов)
      // Тап = выделение + показ точек resize
      // Перетаскивание элемента = перемещение
      // Перетаскивание точки = resize (обрабатывается в handleResizeHandleTap)
      
      // Блокируем если идёт изменение размера
      if (this.isResizing || this.activeInteraction) {
        return;
      }
      
      // На мобильном: блокируем переключение на другой элемент, пока не нажат крестик
      if (this.isMobile && this.activeItemId && this.activeItemId !== item.id) {
        return;
      }

      this.hideActiveElement = false;

      // Не обрабатываем фоновые элементы
      if (item.isBackground) {
        return;
      }

      const nativeEvent = event.originalEvent || event;
      nativeEvent?.preventDefault();
      nativeEvent?.stopPropagation();
      
      const wasAlreadyActive = this.activeItemId === item.id;

      // Получаем координаты
      const getCoords = (e) => {
        if (e.type?.includes('touch') && e.touches && e.touches[0]) {
          return { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
        if (e.type?.includes('touch') && e.changedTouches && e.changedTouches[0]) {
          return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
        }
        return { x: e.clientX, y: e.clientY };
      };

      if (!wasAlreadyActive) {
        // Элемент не был активен - только активируем его, без перетаскивания
        this.activeItemId = item.id;
        this.showControls = true;
        this.activeResizeHandle = null;
        return;
      }

      // Заблокированные элементы нельзя перетаскивать
      if (item.locked) {
        return;
      }
      
      // В режиме resize на мобильном блокируем перетаскивание
      if (this.isMobile && this.mobileEditMode === 'resize') {
        return;
      }

      // Элемент уже был активен - настраиваем потенциальное перетаскивание
      const startCoords = getCoords(nativeEvent);
      let hasMoved = false;
      const moveThreshold = 5; // пикселей для начала drag
      
      const cleanup = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onUp);
        document.removeEventListener('touchcancel', onUp);
        this.activeInteraction = null;
      };

      const onMove = (e) => {
        e.preventDefault();
        const coords = getCoords(e);
        const dx = Math.abs(coords.x - startCoords.x);
        const dy = Math.abs(coords.y - startCoords.y);
        
        if (!hasMoved && (dx > moveThreshold || dy > moveThreshold)) {
          hasMoved = true;
          // Начинаем перетаскивание - вызываем startDrag ОДИН РАЗ
          // startDrag сам настроит обработчики для продолжения перетаскивания
          cleanup(); // Убираем наши обработчики, startDrag установит свои
          this.activeInteraction = { type: 'move', targetId: item.id };
          this.dragHistorySaved = false;
          this.saveHistoryState();
          this.dragHistorySaved = true;
          this.startDrag(item, e); // Передаём текущий event
        }
      };

      const onUp = () => {
        cleanup();
      };

      document.addEventListener('mousemove', onMove, { passive: false });
      document.addEventListener('mouseup', onUp);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onUp);
      document.addEventListener('touchcancel', onUp);
    },

    addImageToContent(element) {
      this.saveHistoryState();
      const prevDroppedCount = this.droppedImages.length;
      const prevActiveId = this.activeItemId;
      
      logger.debug('addImageToContent START', {
        context: {
          elementId: element.id,
          elementType: element.type,
          prevDroppedCount,
          prevActiveId,
          isMobile: this.isMobile,
          isUserElement: element.isUserElement
        }
      });
      
      if (element.type === 'text') {
        console.warn('Отменено добавление текстового элемента через addImageToContent');
        return;
      }

      const isColorBackground = !!element.color;
      // Элемент считается фоном только если:
      // 1. Он явно помечен как фон (isBackground: true)
      // 2. ИЛИ это загруженный фон из раздела "Фоны" (проверяем по пути изображения)
      // 3. НЕ является элементом с элементным ID (element.id из каталога элементов)
      // Элементы из подкатегорий ВСЕГДА являются обычными элементами, не фонами!
      const isExplicitBackground = element.isBackground === true;
      const isFromBackgroundsPath = element.image?.includes('/uploads/backgrounds/');
      const isImageBackground = !isColorBackground && (isExplicitBackground || isFromBackgroundsPath);
      const isBackground = isImageBackground || isColorBackground;
      
      console.log('🎯 addImageToContent - background detection:', {
        elementName: element.name,
        isColorBackground,
        isExplicitBackground,
        isFromBackgroundsPath,
        isImageBackground,
        isBackground,
        imagePath: element.image?.substring(0, 60),
        activeIcon: this.activeIcon,
        firstCategoryName: this.categories[0]?.name
      });

      const contentWidth = this.$refs.contentRef?.offsetWidth || 0;
      const contentHeight = this.$refs.contentRef?.offsetHeight || 0;

      let zIndex;
      if (isBackground) {
        zIndex = -1000;
      } else {
        const maxNonBackgroundZIndex = Math.max(
          ...this.droppedImages.filter(img => !img._isBackground).map(img => img.zIndex || 0),
          0
        );
        zIndex = maxNonBackgroundZIndex + 1;
      }

      const imageContent = isColorBackground ? this.createColorImage(element.color) : element.image;
      
      const effectivePrice = this.getEffectivePrice(element.id, element.price);
      
      const addImageWithSize = (width, height) => {
        const newImage = {
          id: Date.now() + Math.random(),
          elementId: element.id,
          name: element.name || element.title || this.$t('editor.element'),
          src: imageContent,
          content: imageContent,
          width: width,
          height: height,
          x: element.x || 0,
          y: element.y || 0,
          rotate: 0,
          flip: false,
          opacity: 1,
          zoneId: this.currentSlideId,
          zIndex: zIndex,
          isColor: isColorBackground,
          _isBackground: isBackground,
          color: element.color,
          locked: false,
          price: effectivePrice,
          originalPrice: element.price || 0,
          type: 'image',
          filters: this.getDefaultFilters(),
          distorted: false,
          rootCategoryName: element.rootCategoryName || element.root_category_name || null,
          isUserElement: Boolean(element.isUserElement),
          userElementId: element.userElementId || null,
        };

        this.droppedImages = [...this.droppedImages, newImage];
        this.$store.commit('category/UPDATE_TOTAL_PRICE', this.totalPrice);
        
        if (!isBackground) {
          this.hideActiveElement = false;
          this.activeItemId = newImage.id;
          this.showControls = true;
        }
        
        logger.debug('addImageToContent END', {
          context: {
            newImageId: newImage.id,
            newDroppedCount: this.droppedImages.length,
            newActiveId: this.activeItemId,
            showControls: this.showControls,
            isBackground,
            width,
            height,
            activeItemData: this.activeItemData ? { id: this.activeItemData.id } : null
          }
        });
        
        this.markDirtyAndSync();
      };

      if (isBackground) {
        addImageWithSize(contentWidth, contentHeight);
      } else {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const maxSize = 200;
          let width, height;
          
          const nw = img.naturalWidth || img.width;
          const nh = img.naturalHeight || img.height;
          
          if (nw > 0 && nh > 0) {
            if (nw >= nh) {
              width = maxSize;
              height = (nh / nw) * maxSize;
            } else {
              height = maxSize;
              width = (nw / nh) * maxSize;
            }
          } else {
            width = maxSize;
            height = maxSize;
          }
          
          addImageWithSize(Math.round(width), Math.round(height));
        };
        img.onerror = () => {
          addImageWithSize(200, 200);
        };
        img.src = imageContent;
      }
    },

    createColorImage(color) {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 10;
        canvas.height = 10;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = color || '#ffffff';
        ctx.fillRect(0, 0, 10, 10);
        return canvas.toDataURL();
      } catch (e) {
        console.error('Error creating color image:', e);
        return '';
      }
    },
    bringToFront(id) {
      const maxZ = Math.max(...this.droppedImages.map((i) => i.zIndex));
      this.droppedImages = this.droppedImages.map((item) => (item.id === id ? { ...item, zIndex: maxZ + 1 } : item));
      this.markDirtyAndSync();
    },

    deleteItem(id) {
      const index = this.droppedImages.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.droppedImages.splice(index, 1);

        const total = this.droppedImages.reduce((sum, item) => {
          return sum + (item.price || 0);
        }, 0);

        this.$store.commit('category/UPDATE_TOTAL_PRICE', total);
        
        if (this.activeItemId === id) {
          this.activeItemId = null;
          this.showControls = false;
        }
        
        this.markDirtyAndSync();
      }
    },

    getGroupRotation(groupId) {
      const group = this.groups.find((g) => g.id === groupId);
      return group?.rotate || 0;
    },

    // Устанавливает новый угол поворота для группы
    rotateGroup(groupId) {
      this.selectedRotateGroupId = groupId;
      this.showRotateClock = true;
    },

    setGroupRotation(angle) {
      const group = this.groups.find((g) => g.id === this.selectedRotateGroupId);
      if (group) {
        group.rotate = angle;

        const groupElement = this.$refs.contentRef.querySelector(`[data-group-id="${this.selectedRotateGroupId}"]`);
        if (groupElement) {
          groupElement.style.transition = 'transform 0.2s ease';
          setTimeout(() => {
            groupElement.style.transition = '';
          }, 200);
        }
        this.markDirtyAndSync();
      }
    },

    // Закрывает интерфейс вращения
    closeRotatePicker() {
      this.showRotateClock = false;
      this.selectedRotateGroupId = null;
      this.selectedRotateItemId = null;
    },

    rotateItem(id) {
      this.selectedRotateItemId = id;
      this.showRotateClock = true;

      // Инициализация начального угла
      const item = this.droppedImages.find((img) => img.id === id);
      if (item) {
        this.currentRotationAngle = item.rotate || 0;
      }
    },

    getItemRotation(id) {
      const item = this.droppedImages.find((img) => img.id === id);
      return item?.rotate || 0;
    },

    setItemRotation(angle) {
      this.droppedImages = this.droppedImages.map((img) => {
        if (img.id === this.selectedRotateItemId) {
          return {
            ...img,
            rotate: angle,
          };
        }
        return img;
      });
      this.markDirtyAndSync();
    },
    clearContent() {
      this.droppedImages = [];
      this.activeImageId = null;
      this.showControls = false;
      this.$store.commit('category/UPDATE_TOTAL_PRICE', 0);
      this.showClearModal = false;
    },

    async applyFiltersToCanvas(imgElement, filters) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth || img.width;
          canvas.height = img.naturalHeight || img.height;
          const ctx = canvas.getContext('2d');
          
          ctx.filter = this.generateFilterCSS(filters);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = imgElement.src;
      });
    },

    async prepareImagesWithFilters(contentElement) {
      const originalSrcs = new Map();
      const originalFilters = new Map();
      
      const imgElements = contentElement.querySelectorAll('.dropped-image-container img, .grouped-item img');
      
      for (const img of imgElements) {
        if (img.classList.contains('watermark-overlay')) continue;
        
        const itemContainer = img.closest('.dropped-image-container') || img.closest('.grouped-item');
        if (!itemContainer) continue;
        
        const itemId = itemContainer.dataset?.itemId || itemContainer.getAttribute('data-item-id') || img.dataset?.imageId || img.getAttribute('data-image-id');
        if (!itemId) continue;
        
        const item = this.droppedImages.find(i => String(i.id) === String(itemId));
        if (!item || !item.filters) continue;
        
        const hasActiveFilters = Object.values(item.filters).some(v => v !== 0);
        if (!hasActiveFilters) continue;
        
        try {
          originalSrcs.set(img, img.src);
          originalFilters.set(img, img.style.filter);
          const filteredDataUrl = await this.applyFiltersToCanvas(img, item.filters);
          img.src = filteredDataUrl;
          img.style.filter = 'none';
        } catch (err) {
          console.warn('Failed to apply filter to image:', err);
        }
      }
      
      originalSrcs._originalFilters = originalFilters;
      return originalSrcs;
    },

    restoreOriginalImages(originalSrcs) {
      const originalFilters = originalSrcs._originalFilters || new Map();
      for (const [img, originalSrc] of originalSrcs) {
        if (typeof originalSrc !== 'string') continue;
        img.src = originalSrc;
        img.style.filter = originalFilters.get(img) || '';
      }
    },

    async downloadContentWithFilters() {
      console.log('📥 downloadContentWithFilters called, hasWatermark:', this.hasWatermark);
      let watermarkElement = null;
      let originalSrcs = new Map();
      let backgroundImgElement = null;
      let originalBackgroundStyle = null;
      
      try {
        this.isDownloadingContent = true;
        this.showControls = false;
        this.activeGroup = null;
        this.activeItemId = null;
        await this.$nextTick();
        
        await new Promise(resolve => setTimeout(resolve, 300));

        const contentElement = this.$refs.contentRef;
        const currentWidth = contentElement.offsetWidth;
        
        if (this.hasWatermark) {
          const logoSrc = '/landing/logo-white.svg';
          
          const originalOverflow = contentElement.style.overflow;
          contentElement.style.overflow = 'hidden';
          
          watermarkElement = document.createElement('div');
          watermarkElement.className = 'watermark-overlay';
          watermarkElement.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
            pointer-events: none;
            overflow: hidden;
          `;
          
          const canvasWidth = contentElement.offsetWidth;
          const canvasHeight = contentElement.offsetHeight;
          const logoWidth = Math.floor(canvasWidth / 5);
          const logoHeight = Math.floor(logoWidth * 0.36);
          const cellW = Math.floor(canvasWidth / 3);
          const cellH = Math.floor(cellW * 0.9);
          const cols = Math.ceil(canvasWidth / cellW) + 2;
          const rows = Math.ceil(canvasHeight / cellH) + 2;
          
          let loadPromises = [];
          for (let row = 0; row < rows; row++) {
            for (let col = 0; col < cols; col++) {
              const offsetX = (row % 2 === 1) ? Math.floor(cellW / 2) : 0;
              const x = col * cellW + offsetX - cellW;
              const y = row * cellH - cellH;
              const img = document.createElement('img');
              img.src = logoSrc;
              img.style.cssText = `
                position: absolute;
                left: ${x + Math.floor((cellW - logoWidth) / 2)}px;
                top: ${y + Math.floor((cellH - logoHeight) / 2)}px;
                width: ${logoWidth}px;
                height: ${logoHeight}px;
                opacity: 0.5;
              `;
              watermarkElement.appendChild(img);
              loadPromises.push(new Promise((resolve) => {
                if (img.complete) resolve();
                else { img.onload = resolve; img.onerror = resolve; }
              }));
            }
          }
          
          watermarkElement._originalOverflow = originalOverflow;
          contentElement.appendChild(watermarkElement);
          
          await Promise.all(loadPromises);
          
          await this.$nextTick();
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        console.log('🎨 Preparing images with baked-in filters...');
        originalSrcs = await this.prepareImagesWithFilters(contentElement);
        console.log('🎨 Prepared', originalSrcs.size, 'images with filters');
        await this.$nextTick();
        
        // Обработка фонового изображения для высокого качества экспорта
        const computedStyle = window.getComputedStyle(contentElement);
        const bgImage = computedStyle.backgroundImage;
        
        if (bgImage && bgImage !== 'none') {
          // Извлекаем URL из background-image
          const urlMatch = bgImage.match(/url\(["']?([^"')]+)["']?\)/);
          if (urlMatch && urlMatch[1]) {
            const bgUrl = urlMatch[1];
            console.log('🖼️ Converting background-image to img element for high quality export:', bgUrl);
            
            // Сохраняем оригинальный стиль
            originalBackgroundStyle = {
              backgroundImage: contentElement.style.backgroundImage,
              backgroundColor: contentElement.style.backgroundColor,
              backgroundSize: contentElement.style.backgroundSize,
              backgroundPosition: contentElement.style.backgroundPosition,
              backgroundRepeat: contentElement.style.backgroundRepeat
            };
            
            // Создаем img элемент для фона
            backgroundImgElement = document.createElement('img');
            backgroundImgElement.src = bgUrl;
            backgroundImgElement.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              z-index: -1;
              pointer-events: none;
            `;
            
            // Убираем CSS background
            contentElement.style.backgroundImage = 'none';
            
            // Вставляем img в начало
            contentElement.insertBefore(backgroundImgElement, contentElement.firstChild);
            
            // Ждем загрузки изображения
            await new Promise((resolve) => {
              if (backgroundImgElement.complete) {
                resolve();
              } else {
                backgroundImgElement.onload = resolve;
                backgroundImgElement.onerror = resolve;
              }
            });
            
            await this.$nextTick();
          }
        }
        
        // Логируем droppedImages для отладки пропадания элементов
        console.log('📊 Export debug - droppedImages:', this.droppedImages.map(item => ({
          id: item.id,
          name: item.name,
          type: item.type,
          hasSrc: !!item.src,
          srcStart: item.src?.substring(0, 80),
          elementId: item.elementId,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          zIndex: item.zIndex,
          opacity: item.opacity,
          _isBackground: item._isBackground
        })));
        
        // Проверяем DOM стили для каждого элемента
        const containers = contentElement.querySelectorAll('.dropped-image-container');
        console.log('📊 DOM containers positions:');
        containers.forEach(container => {
          const itemId = container.dataset.itemId;
          const style = getComputedStyle(container);
          console.log(`  Container ${itemId}: left=${style.left}, top=${style.top}, zIndex=${style.zIndex}, opacity=${style.opacity}, visibility=${style.visibility}, display=${style.display}, width=${style.width}, height=${style.height}`);
        });
        
        // Ждём загрузки всех изображений элементов
        const allImages = contentElement.querySelectorAll('img');
        console.log('🖼️ Waiting for', allImages.length, 'images to load...');
        await Promise.all(Array.from(allImages).map(img => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = () => {
              console.warn('⚠️ Image failed to load:', img.src?.substring(0, 100));
              resolve();
            };
            setTimeout(resolve, 5000);
          });
        }));
        console.log('🖼️ All images loaded, verifying DOM elements...');
        
        // Проверяем какие img есть в DOM
        const imgElements = contentElement.querySelectorAll('.dropped-image-container img, .grouped-item img');
        console.log('📊 DOM img elements count:', imgElements.length);
        imgElements.forEach((img, i) => {
          const container = img.closest('.dropped-image-container') || img.closest('.grouped-item');
          const itemId = container?.dataset?.itemId || 'unknown';
          console.log(`  [${i}] id:${itemId} src:`, img.src?.substring(0, 100), 'complete:', img.complete, 'size:', img.naturalWidth, 'x', img.naturalHeight);
        });
        
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Целевое разрешение для экспорта (фиксированное, независимо от устройства)
        const TARGET_EXPORT_WIDTH = 3000;
        // Рассчитываем scale для достижения целевого разрешения
        const dynamicScale = Math.max(3, Math.ceil(TARGET_EXPORT_WIDTH / currentWidth));

        console.log('🖼️ Starting html2canvas with scale:', dynamicScale, 'contentElement size:', contentElement.offsetWidth, 'x', contentElement.offsetHeight);
        const canvas = await this.captureWithoutEditorControls(() => html2canvas(contentElement, {
          useCORS: true,
          allowTaint: false,
          scale: dynamicScale,
          logging: true,
          backgroundColor: '#ffffff',
          foreignObjectRendering: false,
          imageTimeout: 15000,
          ignoreElements: (element) => {
            if (!element || !element.classList) {
              return false;
            }
            return (
              element.classList.contains('utils-block') ||
              element.classList.contains('images-buttons') ||
              element.classList.contains('images-utils') ||
              element.classList.contains('images-utils-group') ||
              element.classList.contains('resize-handle') ||
              element.classList.contains('group-controls') ||
              element.classList.contains('item-controls') ||
              element.classList.contains('selection-lasso-drawing') ||
              element.classList.contains('selection-lasso-filled') ||
              element.classList.contains('group-button')
            );
          },
        }));

        const dataUrl = canvas.toDataURL('image/png', 1.0);
        
        const link = document.createElement('a');
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
        link.download = `composition-${timestamp}.png`;
        link.href = dataUrl;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);
      } catch (error) {
        console.error('Ошибка при создании изображения:', error);
        alert(error.message || this.$t('editor.imageDownloadError'));
      } finally {
        if (originalSrcs.size > 0) {
          this.restoreOriginalImages(originalSrcs);
          console.log('🎨 Restored original images');
        }
        if (watermarkElement && watermarkElement.parentNode) {
          const contentEl = watermarkElement.parentNode;
          if (watermarkElement._originalOverflow !== undefined) {
            contentEl.style.overflow = watermarkElement._originalOverflow;
          }
          contentEl.removeChild(watermarkElement);
          console.log('🏷️ Watermark element removed from DOM');
        }
        // Восстанавливаем фоновое изображение
        if (backgroundImgElement && backgroundImgElement.parentNode) {
          backgroundImgElement.parentNode.removeChild(backgroundImgElement);
          console.log('🖼️ Background image element removed');
        }
        if (originalBackgroundStyle) {
          const contentElement = this.$refs.contentRef;
          if (contentElement) {
            contentElement.style.backgroundImage = originalBackgroundStyle.backgroundImage;
            contentElement.style.backgroundColor = originalBackgroundStyle.backgroundColor;
            contentElement.style.backgroundSize = originalBackgroundStyle.backgroundSize;
            contentElement.style.backgroundPosition = originalBackgroundStyle.backgroundPosition;
            contentElement.style.backgroundRepeat = originalBackgroundStyle.backgroundRepeat;
            console.log('🖼️ Background styles restored');
          }
        }
        this.isDownloadingContent = false;
      }
    },

    async downloadContent() {
      try {
        const prevShowControls = this.showControls;
        this.showControls = await this.$nextTick();

        const contentElement = this.$refs.contentRef;
        const currentWidth = contentElement.offsetWidth;
        
        // Ждём загрузки всех изображений
        const allImages = contentElement.querySelectorAll('img');
        await Promise.all(Array.from(allImages).map(img => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
            setTimeout(resolve, 5000);
          });
        }));
        await this.$nextTick();
        
        // Целевое разрешение для экспорта (фиксированное, независимо от устройства)
        const TARGET_EXPORT_WIDTH = 3000;
        const dynamicScale = Math.max(3, Math.ceil(TARGET_EXPORT_WIDTH / currentWidth));

        const canvas = await this.captureWithoutEditorControls(() => html2canvas(contentElement, {
          backgroundColor: null,
          scale: dynamicScale,
          logging: false,
          useCORS: true,
          allowTaint: true,
          ignoreElements: (element) => {
            return (
              element.classList &&
              (element.classList.contains('utils-block') || element.classList.contains('images-buttons') || element.classList.contains('images-utils') || element.classList.contains('resize-handle'))
            );
          },
        }));

        const link = document.createElement('a');
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        link.download = `${this.$t('estimate.project')}-${this.currentZoneTitle}-${timestamp}.png`;
        link.href = canvas.toDataURL('image/png', 1.0);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.showControls = prevShowControls;
      } catch (error) {
        console.error('Ошибка при создании изображения:', error);
        alert(this.$t('errors.creationImageError'));
        this.showControls = true;
      }
    },

    deleteImageById(id) {
      this.saveHistoryState();
      this.droppedImages = deleteImageUtil(this.droppedImages, id);
      if (this.activeImageId === id) {
        this.activeImageId = null;
        this.showControls = false;
      }
      this.$store.commit('category/UPDATE_TOTAL_PRICE', this.totalPrice);
      this.markDirtyAndSync();
    },

    rotateImage(id) {
      this.saveHistoryState();
      this.droppedImages = rotateImageUtil(this.droppedImages, id);
      this.markDirtyAndSync();
    },

    copyItem(id) {
      this.saveHistoryState();
      this.closeAllMenus();
      const original = this.droppedImages.find((item) => item.id === id);
      if (!original) return;

      const copy = {
        ...original,
        perspective: this.normalizePerspective(original.perspective)
          ? this.normalizePerspective(original.perspective).map(point => ({ ...point }))
          : undefined,
        eraser: normalizeEraser(original.eraser),
        id: Date.now() + Math.random(),
        x: original.x + 20,
        y: original.y + 20,
        zIndex: Math.max(...this.droppedImages.map((i) => i.zIndex || 0)) + 1,
        // если это текст, то обеспечим текстовые свойства
        ...(original.type === 'text' && {
          text: original.text || '',
          color: original.color || '#000000',
          fontName: original.fontName || 'Arial',
          width: original.width || 200,
          height: original.height || 100,
          rotate: original.rotate || 0,
          opacity: original.opacity || 1,
          locked: original.locked || false,
        }),
      };

      this.droppedImages.push(copy);
      this.markDirtyAndSync();
    },

    handleCopyItem(newItem) {
      this.droppedImages.push({
        ...newItem,
        eraser: normalizeEraser(newItem.eraser),
        type: 'text', // если у тебя есть поле type для различия текст и изображений
      });
    },

    mirrorFun(id) {
      this.saveHistoryState();
      this.closeAllMenus();
      this.droppedImages = this.droppedImages.map((img) =>
        img.id === id ? { ...img, flipX: !img.flipX } : img
      );
      this.markDirtyAndSync();
    },

    onChangeOpacity(e, id) {
      const opacityValue = parseInt(e.target.value) / 100;
      this.droppedImages = this.droppedImages.map((img) => (img.id === id ? { ...img, opacity: opacityValue } : img));
      this.markDirtyAndSync();
    },

    toggleLock(id) {
      this.saveHistoryState();
      this.closeAllMenus();
      this.droppedImages = this.droppedImages.map((img) => (img.id === id ? { ...img, locked: !img.locked } : img));
      this.markDirtyAndSync();
    },
    
    toggleMobileEditMode() {
      this.mobileEditMode = this.mobileEditMode === 'move' ? 'resize' : 'move';
    },

    changeZIndex(action, imageId) {
      this.saveHistoryState();
      const images = [...this.droppedImages];
      const index = images.findIndex((img) => img.id === imageId);
      if (index === -1) return;

      const current = images[index];
      
      if (current._isBackground) {
        return;
      }

      const currentZ = current.zIndex || 0;
      const nonBackgroundImages = images.filter(img => !img._isBackground);
      const minNonBackgroundZIndex = Math.min(
        ...nonBackgroundImages.map(img => img.zIndex || 0),
        1
      );

      switch (action) {
        case 'front': {
          const maxZIndex = Math.max(...nonBackgroundImages.map((img) => img.zIndex || 0), 0);
          current.zIndex = maxZIndex + 1;
          break;
        }
        case 'up': {
          current.zIndex = currentZ + 1;
          break;
        }
        case 'down': {
          const newZIndex = currentZ - 1;
          if (newZIndex >= minNonBackgroundZIndex) {
            current.zIndex = newZIndex;
          }
          break;
        }
        case 'back': {
          current.zIndex = minNonBackgroundZIndex;
          break;
        }
      }

      this.droppedImages = images;
      this.activeItemId = imageId;
      this.markDirtyAndSync();
    },

    initDragResize() {
      const { startDrag: dragFn } = useDrag();
      const { startResize: resizeFn } = useResize();
      const { startGroupDrag: groupDragFn } = useGroupDrag();

      this.startDrag = (image, event) => {
        // Блокируем перетаскивание если идёт изменение размера
        if (this.isResizing) return;
        
        // Блокируем если идёт resize взаимодействие
        if (this.activeInteraction?.type === 'resize') return;
        
        if (!image.locked) {
          // History is now saved in handleItemMouseDown before startDrag is called
          dragFn(this.droppedImages, image, event, this.$refs.contentRef, this.currentScale, () => {
            this.dragHistorySaved = false;
            this.activeResizeHandle = null;
            this.activeInteraction = null;
            this.markDirtyAndSync();
            this.$nextTick(() => {
              if (this.activeItemId === image.id) {
                this.updateToolbarPlacement('item', image.id);
              }
            });
          });
        }
      };

      this.startGroupDrag = (group, event, container) => {
        // Блокируем перетаскивание если активен resize handle
        if (this.activeResizeHandle) return;
        
        if (!group.locked) {
          // Save history state before group drag starts
          if (!this.groupDragHistorySaved) {
            this.saveHistoryState();
            this.groupDragHistorySaved = true;
          }
          groupDragFn(group, event, container, this.currentScale, () => {
            this.groupDragHistorySaved = false;
            this.activeResizeHandle = null;
            this.activeInteraction = null;
            this.markDirtyAndSync();
            this.$nextTick(() => {
              if (this.activeGroup === group.id) {
                this.updateToolbarPlacement('group', group.id);
              }
            });
          });
        }
      };

      this.startResize = (image, event, direction) => {
        if (!image.locked) {
          // Save history state before resize starts
          if (!this.resizeHistorySaved) {
            this.saveHistoryState();
            this.resizeHistorySaved = true;
          }
          this.isResizing = true;
          
          const contentRect = this.$refs.contentRef.getBoundingClientRect();
          const maxWidth = (contentRect.width / this.currentScale) - image.x;
          const maxHeight = (contentRect.height / this.currentScale) - image.y;

          resizeFn(this.droppedImages, image, event, direction, {
            minWidth: 50,
            minHeight: 50,
            maxWidth,
            maxHeight,
            aspectRatio: image.type === 'text' ? null : image.width / image.height,
            scale: this.currentScale,
          }, () => {
            this.resizeHistorySaved = false;
            this.isResizing = false;
            this.activeResizeHandle = null;
            this.activeInteraction = null;
            this.markDirtyAndSync();
            this.$nextTick(() => {
              if (this.activeItemId === image.id) {
                this.updateToolbarPlacement('item', image.id);
              }
            });
          });
        }
      };

      this.handleResizeHandleTap = (image, event, handle) => {
        // НОВАЯ УПРОЩЁННАЯ ЛОГИКА
        // Перетаскивание точки сразу начинает resize — никаких двойных тапов
        event.preventDefault();
        event.stopPropagation();
        
        // Блокируем если уже идёт взаимодействие
        if (this.activeInteraction) {
          return;
        }
        
        const isTouchEvent = event.type.includes('touch');
        
        // Для мыши — сразу начинаем resize при mousedown
        if (!isTouchEvent) {
          this.activeResizeHandle = handle;
          this.activeInteraction = { type: 'resize', targetId: image.id, handle };
          this.startResize(image, event, handle);
          return;
        }
        
        // Touch: начинаем resize при движении (порог 3px для предотвращения случайных срабатываний)
        const getEventCoords = (e) => {
          if (e.type?.includes('touch') && e.touches && e.touches[0]) {
            return { x: e.touches[0].clientX, y: e.touches[0].clientY };
          }
          if (e.type?.includes('touch') && e.changedTouches && e.changedTouches[0]) {
            return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
          }
          return { x: e.clientX, y: e.clientY };
        };
        
        const startCoords = getEventCoords(event);
        let resizeStarted = false;
        const moveThreshold = 10; // Увеличен порог чтобы тап не срабатывал как resize
        
        const cleanup = () => {
          document.removeEventListener('touchmove', onTouchMove);
          document.removeEventListener('touchend', onTouchEnd);
          document.removeEventListener('touchcancel', onTouchEnd);
        };
        
        const onTouchMove = (e) => {
          e.preventDefault();
          const coords = getEventCoords(e);
          const dx = Math.abs(coords.x - startCoords.x);
          const dy = Math.abs(coords.y - startCoords.y);
          
          if (!resizeStarted && (dx > moveThreshold || dy > moveThreshold)) {
            resizeStarted = true;
            this.activeResizeHandle = handle;
            this.activeInteraction = { type: 'resize', targetId: image.id, handle };
            cleanup();
            this.startResize(image, e, handle);
          }
        };
        
        const onTouchEnd = () => {
          cleanup();
          if (!resizeStarted) {
            this.activeResizeHandle = null;
            this.activeInteraction = null;
          }
        };
        
        document.addEventListener('touchmove', onTouchMove, { passive: false });
        document.addEventListener('touchend', onTouchEnd);
        document.addEventListener('touchcancel', onTouchEnd);
      };
    },

    applyFiltersToDom(imageId) {
      const item = this.droppedImages.find((img) => img.id === imageId);
      if (!item || !item.filters) return;

      const currentFilters = { ...item.filters };

      this.droppedImages = this.droppedImages.map((img) => {
        if (img.id === imageId) {
          return {
            ...img,
            filters: currentFilters,
          };
        }
        return img;
      });

      if (this.useKonvaEditor && this.$refs.konvaEditor) {
        this.$refs.konvaEditor.loadImages();
      } else {
        const element = document.querySelector(`[data-item-id="${imageId}"]`);
        if (element) {
          element.style.filter = this.generateFilterString(currentFilters);
        }
      }
      
      this.markDirtyAndSync();
    },
    generateFilterString(filters) {
      if (!filters) return '';

      const filterParts = [];

      // Яркость (brightness) - exposure
      if (filters.exposure !== undefined) {
        filterParts.push(`brightness(${100 + filters.exposure}%)`);
      }

      // Контраст (contrast)
      if (filters.contrast !== undefined) {
        filterParts.push(`contrast(${100 + filters.contrast}%)`);
      }

      // Насыщенность (saturation)
      if (filters.saturation !== undefined) {
        filterParts.push(`saturate(${100 + filters.saturation}%)`);
      }

      // Сепия (temperature)
      if (filters.temperature !== undefined) {
        filterParts.push(`sepia(${Math.min(filters.temperature, 100) / 100})`);
      }

      // Оттенок (hue)
      if (filters.hue !== undefined) {
        filterParts.push(`hue-rotate(${filters.hue}deg)`);
      }

      // Тени (shadows)
      if (filters.shadows !== undefined && filters.shadows !== 0) {
        const intensity = Math.abs(filters.shadows) / 10;
        const opacity = 0.8;
        const color = filters.shadows > 0 ? `0,0,0,${opacity}` : `255,255,255,${opacity}`;
        filterParts.push(`drop-shadow(0 0 ${intensity}px rgba(${color}))`);
      }

      return filterParts.join(' ');
    },

    getCurrentFilterValue(filterName) {
      const item = this.droppedImages.find((img) => img.id === this.activeItemId);
      return item?.filters?.[filterName] ?? 0;
    },
    handleOpacityInput(event, itemId) {
      const value = parseInt(event.target.value);
      const opacity = value / 100;

      const item = this.droppedImages.find((i) => i.id === itemId);
      if (item) {
        item.opacity = opacity;

        // Обновляем CSS переменную
        event.target.style.setProperty('--fill-position', `${value}%`);
        this.markDirtyAndSync();
      }
    },

    getSliderStyle(item) {
      const percentage = Math.round((item.opacity ?? 1) * 100);
      return {
        '--fill-position': `${percentage}%`,
      };
    },

    getSliderStyleForGroup(group) {
      const percentage = Math.round(group.opacity * 100);
      return {
        '--fill-position': `${percentage}%`,
      };
    },

    getFilterSliderStyle(value, min, max) {
      const actualValue = value === undefined || value === null ? 0 : value;
      const normalizedValue = ((actualValue - min) / (max - min)) * 100;
      return {
        '--fill-position': `${normalizedValue}%`,
      };
    },

    getDefaultFilters() {
      const filters = {};
      this.filtersList.forEach((filter) => {
        filters[filter.name] = filter.defaultValue !== undefined ? filter.defaultValue : 0;
      });
      return filters;
    },

    updateFilter(filterName, value) {
      const numericValue = parseInt(value);
      this.droppedImages = this.droppedImages.map((img) => {
        if (img.id === this.activeItemId) {
          return {
            ...img,
            filters: {
              ...img.filters,
              [filterName]: numericValue,
            },
          };
        }
        return img;
      });
      this.applyFiltersToDom(this.activeItemId);
    },

    generateShadowEffect(shadowValue) {
      if (shadowValue === undefined || shadowValue === 0) return '';

      const intensity = Math.abs(shadowValue) / 10;
      const spread = intensity * 3;
      const opacity = 0.8;

      if (shadowValue > 0) {
        return `drop-shadow(0 0 ${spread}px rgba(0,0,0,${opacity}))`;
      } else {
        return `drop-shadow(0 0 ${spread}px rgba(255,255,255,${opacity}))`;
      }
    },

    applyComplexEffects(element, filters) {
      const { highlights } = filters;
      let overlay = element.querySelector('.image-effects-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'image-effects-overlay';
        element.appendChild(overlay);
      }
      const highlightOpacity = Math.max(0, highlights / 100);
      overlay.style.background = `
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, ${highlightOpacity}) 0%,
      transparent 50%
    )
  `;
    },

    updateSliderValues(filters) {
      if (!filters) return;
      this.$nextTick(() => {
        Object.keys(filters).forEach((name) => {
          const input = this.sliderRefs[name];
          if (input) {
            input.value = filters[name];
            const nextSpan = input.nextElementSibling;
            if (nextSpan && nextSpan.classList.contains('settings-number')) {
              nextSpan.textContent = filters[name];
            }
            this.updateRangeFill({ target: input });
          }
        });
      });
    },

    getFilterLabel(name) {
      const labels = {
        exposure: this.$t('legacy.Экспозиция'),
        contrast: this.$t('legacy.Контраст'),
        saturation: this.$t('legacy.Насыщенность'),
        temperature: this.$t('legacy.Температура'),
        hue: this.$t('legacy.Оттенок'),
        highlights: this.$t('legacy.Света'),
        shadows: this.$t('legacy.Тени'),
      };
      return labels[name] || name;
    },

    updateRangeFill(event, itemId, filterName) {
      if (!event?.target) return;
      const input = event.target;
      const value = parseFloat(input.value) || 0;
      const min = parseFloat(input.min);
      const max = parseFloat(input.max);

      // Рассчитываем позицию для фонового градиента
      const percentage = ((value - min) / (max - min)) * 100;
      input.style.backgroundPosition = `${100 - percentage}% 0`;

      // Обновляем значение фильтра
      this.updateFilter(filterName, value, itemId);

      // Обновляем отображаемое число
      const numberElement = input.nextElementSibling;
      if (numberElement && numberElement.classList.contains('settings-number')) {
        numberElement.textContent = value;
      }
    },
    getContainerStyle(item) {
      return {
        top: item.y + 'px',
        left: item.x + 'px',
        width: item.width + 'px',
        height: item.height + 'px',
        cursor: this.isItemActive(item) ? 'move' : 'grab',
        zIndex: this.isItemActive(item) ? 9999 : 2,
        position: 'absolute',
        // transform: rotate - НЕ ставим сюда!
      };
    },

    getImageStyle(item) {
      const isActive = this.isItemActive(item);
      const combinedFilters = this.getCombinedFilters(item.filters, {});

      const style = {
        width: '100%',
        height: '100%',
        objectFit: item.distorted ? 'fill' : 'contain',
        transform: item.flipY ? 'scaleY(-1)' : 'none',
        opacity: item.opacity ?? 1,
        // border: isActive ? '1px solid #bbcad8' : 'none',
        borderRadius: isActive ? '5px' : '0',
        transition: 'opacity 0.3s ease, border 0.2s ease',
      };

      if (item.filters) {
        style.filter = this.generateFilterCSS(combinedFilters);
        style.transition += ', filter 0.3s ease';
      }

      return style;
    },

    setSliderRef(name, el) {
      if (el) {
        this.sliderRefs[name] = el;
        this.$nextTick(() => {
          const value = this.getCurrentFilterValue(name);
          el.value = value;
          this.updateRangeFill({ target: el });

          const nextSpan = el.nextElementSibling;
          if (nextSpan && nextSpan.classList.contains('settings-number')) {
            nextSpan.textContent = value;
          }
        });
      }
    },
    setBackgroundColor(color) {
      this.saveHistoryState();
      if (this.activeZoneId !== null) {
        if (!this.zonesData[this.activeZoneId]) {
          this.zonesData[this.activeZoneId] = {
            background: null,
            elements: [],
          };
        }

        this.zonesData[this.activeZoneId].background = {
          id: `bg-${this.activeZoneId}`,
          isBackground: true,
          isColor: true,
          color: color,
          src: this.createColorImage(color),
          zIndex: -1000,
        };

        this.updateDroppedImagesForCurrentZone();

        const contentSection = this.$refs.contentRef;
        if (contentSection) {
          contentSection.style.backgroundColor = color;
        }
      }
    },

    updateDroppedImagesForCurrentZone() {
      if (this.activeZoneId !== null && this.zonesData[this.activeZoneId]) {
        const nonBackgroundElements = this.droppedImages.filter((img) => !img.isBackground);

        if (this.zonesData[this.activeZoneId].background) {
          this.droppedImages = [this.zonesData[this.activeZoneId].background, ...nonBackgroundElements];
        } else {
          this.droppedImages = nonBackgroundElements;
        }
      }
    },
    updateBackgroundInDroppedImages(color) {
      const bgItem = this.droppedImages.find((img) => img.isBackground);
      if (bgItem) {
        bgItem.color = color;
        bgItem.src = this.createColorImage(color);
      } else {
        this.droppedImages.push({
          id: Date.now(),
          isBackground: true,
          color: color,
          width: '100%',
          height: '100%',
          src: this.createColorImage(color),
          zIndex: -1000,
        });
      }
    },

    toggleShaw(id) {
      this.shaw.content = true;
      this.shaw.sidebar = true;
      this.slidesId = id;

      if (this.currentProject && this.currentProject.zoneId === id) {
        this.droppedImages = JSON.parse(JSON.stringify(this.currentProject.images));
      } else {
        this.droppedImages = [];
        const slide = this.fotozones.find((el) => el.id === id);
        if (slide) {
          this.droppedImages = [...slide.images];
        }
      }

      this.activeImageId = null;
      this.showControls = false;
      this.showContentSlides = true;
    },

    handleContentClick(e) {
      // На мобильных не сбрасываем выбор при клике по canvas - только через крестик
      if (this.isMobile && this.activeImageId !== null && this.showControls) {
        return;
      }
      if (!e.target.closest('.dropped-image-container') && !e.target.closest('.images-buttons')) {
        this.activeImageId = null;
        this.showControls = false;
      }
    },

    handleImageClick(id) {
      const image = this.droppedImages.find((img) => img.id === id);
      if (image) {
        this.activeImageId = id;
        this.showControls = true;

        if (!image.filters) {
          const imageIndex = this.droppedImages.findIndex((img) => img.id === id);
          this.droppedImages[imageIndex].filters = {
            exposure: 0,
            contrast: 0,
            saturation: 0,
            temperature: 0,
            hue: 0,
            highlights: 0,
            shadows: 0,
          };
        }

        this.$nextTick(() => {
          this.updateSliderValues(image.filters || {});
        });
      }
    },

    handleImageMouseDown(image, event) {
      if (!image.locked) {
        // На мобильных: если уже есть выбранный элемент, работаем только с ним
        if (this.isMobile && this.activeImageId !== null && this.activeImageId !== image.id && this.showControls) {
          // Блокируем переключение на другой элемент - продолжаем работать с текущим
          const nativeEvent = event.originalEvent || event;
          if (nativeEvent) {
            nativeEvent.preventDefault();
            nativeEvent.stopPropagation();
          }
          return;
        }
        
        image.zIndex = 1001;

        if (this.activeImageId !== image.id) {
          this.activeImageId = image.id;
          this.showControls = true;
        }

        const nativeEvent = event.originalEvent || event;
        if (nativeEvent) {
          nativeEvent.preventDefault();
          nativeEvent.stopPropagation();
        }

        this.startDrag(image, nativeEvent);

        const upHandler = () => {
          image.zIndex = this.activeImageId === image.id ? 1000 : 2;
          document.removeEventListener('mouseup', upHandler);
        };

        document.addEventListener('mouseup', upHandler);
      }
    },
    
    deselectMobileElement() {
      this.activeItemId = null;
      this.activeGroup = null;
      this.selectedItems = [];
      this.showControls = false;
      this.activeControlButton = null;
      // Очищаем все состояния взаимодействия
      this.activeResizeHandle = null;
      this.activeInteraction = null;
      this.isResizing = false;
      // Сбрасываем режим редактирования на мобильном
      this.mobileEditMode = 'move';
      // Закрываем bottom sheets
      this.showOpacitySheet = false;
      this.showRotationSheet = false;
    },

    toggleControls(id) {
      const image = this.droppedImages.find((img) => img.id === id);
      if (image) {
        if (this.activeImageId === id) {
          this.showControls = !this.showControls;
        } else {
          this.activeImageId = id;
          this.showControls = true;
        }
      }
    },

    openSaveModal() {
      // Save directly without showing popup
      this.handleProjectSave();
    },

    openClearModal() {
      this.showClearModal = true;
    },
    openBackgroundModal() {
      this.showBackgroundModal = true;
    },
    openLayersPanel() {
      this.showLayersPanel = !this.showLayersPanel;
      if (this.showLayersPanel && this.isMobile) {
        this.updateLayersPanelHeight();
      }
      if (!this.showLayersPanel) {
        this.highlightedCalculatorItemId = null;
      }
    },
    updateLayersPanelHeight() {
      this.$nextTick(() => {
        const contentEl = this.$refs.contentRef;
        if (contentEl) {
          const rect = contentEl.getBoundingClientRect();
          const gap = 8;
          const availableHeight = window.innerHeight - rect.bottom - gap;
          this.layersPanelMaxHeight = `${Math.max(150, availableHeight)}px`;
        }
      });
    },
    startDownload() {
      this.downloadContentWithFilters();
    },
    openAIProcessing() {
      if (this.canUseAi) {
        this.showAiModal = true;
      } else {
        this.$router.push('/profile/subscription');
      }
    },
    deleteCurrentZone() {
      this.handleDeleteCurrentZone();
    },
    closeLayersPanel() {
      this.showLayersPanel = false;
      this.highlightedCalculatorItemId = null;
    },
    openCalculatorPanel() {
      if (!this.canUseCalculator) {
        return;
      }
      this.showLayersPanel = false;
      this.showCalculatorPanel = true;
    },
    closeCalculatorPanel() {
      this.showCalculatorPanel = false;
      this.highlightedCalculatorItemId = null;
    },
    handleCalculatorHighlight(itemId) {
      this.highlightedCalculatorItemId = itemId;
      // Также выбираем элемент на канвасе при клике в калькуляторе
      if (itemId) {
        const item = this.droppedImages.find(i => i.id === itemId);
        if (item && !item.groupId) {
          // Если элемент не в группе - выбираем его
          this.activeItemId = itemId;
          this.activeGroup = null;
          this.showControls = true;
        } else if (item && item.groupId) {
          // Если элемент в группе - выбираем группу
          this.activeGroup = item.groupId;
          this.activeItemId = null;
          this.showControls = true;
        }
      }
    },
    handleCalculatorDelete(itemId) {
      this.deleteImageById(itemId);
    },
    handleCalculatorExcludedUpdate({ excludedItems, calculatedTotal }) {
      this.calculatorExcludedItems = excludedItems;
      this.calculatorTotal = calculatedTotal;
    },
    toggleUtilsMenu() {
      this.showUtilsMenu = !this.showUtilsMenu;
    },
    closeUtilsMenu() {
      this.showUtilsMenu = false;
    },
    handleMenuBackground() {
      this.showUtilsMenu = false;
      this.showBackgroundModal = true;
    },
    handleMenuLayers() {
      this.showUtilsMenu = false;
      this.openLayersPanel();
    },
    handleMenuSave() {
      this.showUtilsMenu = false;
      this.openSaveModal();
    },
    handleMenuDownload() {
      this.showUtilsMenu = false;
      this.downloadContentWithFilters();
    },
    async handleExportPDF() {
      this.showUtilsMenu = false;
      if (!this.canExportPdf) {
        this.$router.push('/subscription/plans');
        return;
      }
      try {
        const projectName = this.$store.state.projects.currentProject?.name || this.$t('estimate.project');
        const { exportToPDF } = await import('@/utils/estimateExport.js');
        await exportToPDF(this.$store, projectName);
      } catch (error) {
        console.error('Ошибка экспорта PDF:', error);
        alert(this.$t('Не удалось экспортировать смету в PDF'));
      }
    },
    async handleExportExcel() {
      this.showUtilsMenu = false;
      if (!this.canExportExcel) {
        this.$router.push('/subscription/plans');
        return;
      }
      try {
        const projectName = this.$store.state.projects.currentProject?.name || this.$t('estimate.project');
        const { exportToExcel } = await import('@/utils/estimateExport.js');
        exportToExcel(this.$store, projectName);
      } catch (error) {
        console.error('Ошибка экспорта Excel:', error);
        alert(this.$t('Не удалось экспортировать смету в Excel'));
      }
    },
    handleSubscriptionRequired(data) {
      const message = data?.message || this.$t('Для этой функции необходима активная подписка');
      this.toast.warning(message, {
        timeout: 5000,
        onClick: () => {
          this.$router.push('/subscription/plans');
        }
      });
    },
    async handleOpenAiModal() {
      this.showUtilsMenu = false;
      
      const isPaid = this.$store.getters['subscription/isPaid'];
      if (!isPaid) {
        this.$router.push('/subscription/plans');
        return;
      }
      
      await this.loadAiCredits();
      
      if (this.aiCredits < 1) {
        alert(this.$t('editor.insufficientCredits'));
        return;
      }
      
      this.showAiModal = true;
    },
    async loadAiCredits() {
      try {
        const { getCredits } = await import('@/api/credits.js');
        const result = await getCredits();
        this.aiCredits = result.credits || 0;
      } catch (error) {
        console.error('Error loading AI credits:', error);
        this.aiCredits = 0;
      }
    },
    async loadUserFonts() {
      try {
        const response = await getUserFonts();
        if (response.success && response.fonts) {
          this.userFonts = response.fonts;
          for (const font of this.userFonts) {
            await this.loadUserFontFace(font);
          }
        }
      } catch (error) {
        console.error('Error loading user fonts:', error);
        this.userFonts = [];
      }
    },
    async loadUserFontFace(font) {
      try {
        const fontFace = new FontFace(font.font_name, `url(${font.font_url})`);
        await fontFace.load();
        document.fonts.add(fontFace);
      } catch (error) {
        console.error(`Error loading font face for ${font.font_name}:`, error);
      }
    },
    async handleAiProcess() {
      let originalSrcs = null;
      let backgroundImgElement = null;
      let originalBackgroundStyle = null;
      
      try {
        this.aiProcessing = true;
        this.showAiModal = false;
        this.showAiProgressModal = true;
        this.aiProgress = 0;
        this.aiProgressStatus = 'preparing';
        
        this.showControls = false;
        this.activeGroup = null;
        this.activeItemId = null;
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 400));
        
        this.aiProgress = 10;
        
        const contentElement = this.$refs.contentRef;
        
        const contentWidth = contentElement.offsetWidth;
        const contentHeight = contentElement.offsetHeight;
        const TARGET_MAX_SIZE = 1920;
        const maxDimension = Math.max(contentWidth, contentHeight);
        const dynamicScale = Math.min(6, TARGET_MAX_SIZE / maxDimension);
        
        this.aiProgress = 20;
        this.aiProgressStatus = 'rendering';
        
        originalSrcs = await this.prepareImagesWithFilters(contentElement);
        await this.$nextTick();
        
        this.aiProgress = 30;
        
        const computedStyle = window.getComputedStyle(contentElement);
        const bgImage = computedStyle.backgroundImage;
        
        if (bgImage && bgImage !== 'none') {
          const urlMatch = bgImage.match(/url\(["']?([^"')]+)["']?\)/);
          if (urlMatch && urlMatch[1]) {
            const bgUrl = urlMatch[1];
            originalBackgroundStyle = {
              backgroundImage: contentElement.style.backgroundImage,
              backgroundColor: contentElement.style.backgroundColor,
              backgroundSize: contentElement.style.backgroundSize,
              backgroundPosition: contentElement.style.backgroundPosition,
              backgroundRepeat: contentElement.style.backgroundRepeat
            };
            backgroundImgElement = document.createElement('img');
            backgroundImgElement.src = bgUrl;
            backgroundImgElement.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              z-index: -1;
              pointer-events: none;
            `;
            contentElement.style.backgroundImage = 'none';
            contentElement.insertBefore(backgroundImgElement, contentElement.firstChild);
            await new Promise((resolve, reject) => {
              if (backgroundImgElement.complete) resolve();
              else {
                backgroundImgElement.onload = resolve;
                backgroundImgElement.onerror = reject;
              }
            });
            await this.$nextTick();
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        }
        
        this.aiProgress = 35;
        
        // Ждём загрузки всех изображений элементов
        const allImages = contentElement.querySelectorAll('img');
        console.log('🖼️ AI: Waiting for', allImages.length, 'images to load...');
        await Promise.all(Array.from(allImages).map(img => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = () => {
              console.warn('⚠️ AI: Image failed to load:', img.src?.substring(0, 100));
              resolve();
            };
            setTimeout(resolve, 5000);
          });
        }));
        console.log('🖼️ AI: All images loaded');
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 100));
        
        this.aiProgress = 40;
        
        const canvas = await this.captureWithoutEditorControls(() => html2canvas(contentElement, {
          useCORS: true,
          allowTaint: false,
          scale: dynamicScale,
          logging: false,
          backgroundColor: null,
          foreignObjectRendering: false,
          imageTimeout: 15000,
          ignoreElements: (element) => {
            if (!element || !element.classList) return false;
            return (
              element.classList.contains('utils-block') ||
              element.classList.contains('images-buttons') ||
              element.classList.contains('images-utils') ||
              element.classList.contains('images-utils-group') ||
              element.classList.contains('resize-handle') ||
              element.classList.contains('group-controls') ||
              element.classList.contains('item-controls') ||
              element.classList.contains('selection-lasso-drawing') ||
              element.classList.contains('selection-lasso-filled') ||
              element.classList.contains('group-button') ||
              element.classList.contains('ai-modal-overlay') ||
              element.classList.contains('ai-modal') ||
              element.classList.contains('ai-progress-modal')
            );
          },
        }));
        
        this.aiProgress = 60;
        
        console.log(`AI capture: content ${contentWidth}x${contentHeight}, scale ${dynamicScale}, output ${canvas.width}x${canvas.height}`);
        
        const imageBase64 = canvas.toDataURL('image/png', 1.0);
        console.log('AI: Image base64 length:', imageBase64.length);
        
        this.aiProgress = 70;
        this.aiProgressStatus = 'uploading';
        
        const activeZoneId = this.$store.state.zones.activeZoneId;
        const zonesList = this.$store.state.zones.zonesList || [];
        const activeZone = zonesList.find(z => z.id === activeZoneId);
        const zoneTitle = activeZone?.title || this.$t('legacy.Зона');
        const projectId = this.$route.params.projectId;
        
        this.aiProgress = 80;
        this.aiProgressStatus = 'processing';
        
        const elementIds = [...new Set(
          (this.droppedImages || [])
            .filter(el => !el.isUserElement && el.elementId)
            .map(el => Number(el.elementId))
            .filter(id => id > 0)
        )];
        console.log('AI: Collected elementIds for prompt:', elementIds);

        console.log('AI: Sending request to server...');
        const { processImageWithAi } = await import('@/api/credits.js');
        const result = await processImageWithAi(imageBase64, activeZoneId, projectId, zoneTitle, elementIds);
        console.log('AI: Server response:', result);
        
        this.aiProgress = 100;
        this.showAiProgressModal = false;
        
        if (result.success) {
          this.aiCredits = Math.max(0, this.aiCredits - 1);
          this.showAiSuccessModal = true;
        } else {
          alert(result.error || this.$t('Ошибка запуска обработки'));
        }
      } catch (error) {
        console.error('AI processing error:', error);
        console.error('AI error details:', error.response?.data, error.message);
        this.showAiProgressModal = false;
        alert(error.response?.data?.error || `${this.$t('Ошибка запуска обработки')}: ${error.message}`);
      } finally {
        const contentElement = this.$refs.contentRef;
        
        if (backgroundImgElement && contentElement) {
          try {
            contentElement.removeChild(backgroundImgElement);
          } catch (e) {
            console.warn('Could not remove background element:', e);
          }
        }
        
        if (originalBackgroundStyle && contentElement) {
          Object.assign(contentElement.style, originalBackgroundStyle);
        }
        
        if (originalSrcs) {
          this.restoreOriginalImages(originalSrcs);
        }
        
        this.aiProcessing = false;
      }
    },
    closeAiModal() {
      this.showAiModal = false;
    },
    closeAiSuccessModal() {
      this.showAiSuccessModal = false;
    },
    goToMyProcessings() {
      this.showAiSuccessModal = false;
      this.$router.push('/my-processings');
    },
    async openBuyCreditsModal() {
      this.showBuyCreditsModal = true;
      this.selectedCreditPackage = null;
      this.creditPackagesLoading = true;
      try {
        const { getCreditPackages } = await import('@/api/credits.js');
        this.creditPackages = await getCreditPackages();
      } catch (error) {
        console.error('Error loading credit packages:', error);
        this.creditPackages = [];
      } finally {
        this.creditPackagesLoading = false;
      }
    },
    closeBuyCreditsModal() {
      this.showBuyCreditsModal = false;
      this.selectedCreditPackage = null;
    },
    proceedToCreditsPurchase() {
      if (!this.selectedCreditPackage) return;
      const pkg = this.creditPackages.find(p => p.id === this.selectedCreditPackage);
      if (!pkg) return;
      this.showBuyCreditsModal = false;
      this.$router.push({
        path: '/credits/payment',
        query: {
          packageId: pkg.id
        }
      });
    },
    handleMenuClear() {
      this.showUtilsMenu = false;
      this.openClearModal();
    },
    handleMenuDeleteZone() {
      this.showUtilsMenu = false;
      this.handleDeleteCurrentZone();
    },
    async handleDeleteCurrentZone() {
      const activeZoneId = this.$store.state.zones.activeZoneId;
      const zonesList = this.$store.state.zones.zonesList || [];
      
      if (!activeZoneId) {
        alert(this.$t('editor.noActiveZoneDelete'));
        return;
      }
      
      if (zonesList.length <= 1) {
        alert(this.$t('Нельзя удалить последнюю зону проекта'));
        return;
      }
      
      const activeZone = zonesList.find(z => z.id === activeZoneId);
      const zoneName = activeZone?.title || this.$t('editor.currentZone');
      
      if (!confirm(this.$t('legacy.dynamic.zoneDelete', { zoneName }))) {
        return;
      }
      
      try {
        await this.$store.dispatch('zones/deleteZone', activeZoneId);
        
        const remainingZones = this.$store.state.zones.zonesList || [];
        if (remainingZones.length > 0) {
          await this.$store.dispatch('zones/setActiveZone', remainingZones[0].id);
        }
      } catch (error) {
        console.error('Ошибка удаления зоны:', error);
        alert(this.$t('errors.deleteZone'));
      }
    },
    handleMobileOpenBackground() {
      this.showBackgroundModal = true;
    },
    handleMobileOpenLayers() {
      this.openLayersPanel();
    },
    handleToggleLayers() {
      this.showLayersPanel = !this.showLayersPanel;
      if (this.showLayersPanel && this.isMobile) {
        this.updateLayersPanelHeight();
      }
    },
    handleMobileOpenSave() {
      this.openSaveModal();
    },
    handleMobileDownload() {
      if (this.isMobile) {
        this.startMobileExport();
      } else {
        this.downloadContentWithFilters();
      }
    },
    async startMobileExport() {
      this.exportStatus = 'rendering';
      this.exportRenderProgress = 0;
      this.exportUploadProgress = 0;
      this.exportDownloadUrl = '';
      this.exportErrorMessage = '';
      
      let watermarkElement = null;
      let originalSrcs = new Map();
      let backgroundImgElement = null;
      let originalBackgroundStyle = null;
      
      try {
        this.isDownloadingContent = true;
        this.showControls = false;
        this.activeGroup = null;
        this.activeItemId = null;
        this.showExportModal = false;
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 300));
        
        this.exportRenderProgress = 10;
        
        const contentElement = this.$refs.contentRef;
        const currentWidth = contentElement.offsetWidth;
        const currentHeight = contentElement.offsetHeight;
        
        if (this.hasWatermark) {
          const logoSrc = require('@/assets/images/delper-logo.png');
          
          const originalOverflow = contentElement.style.overflow;
          contentElement.style.overflow = 'hidden';
          
          watermarkElement = document.createElement('div');
          watermarkElement.className = 'watermark-overlay';
          watermarkElement.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
            pointer-events: none;
            overflow: hidden;
          `;
          
          const innerWrapper = document.createElement('div');
          innerWrapper.style.cssText = `
            position: absolute;
            top: -150%;
            left: -100%;
            width: 300%;
            height: 400%;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            transform: rotate(-25deg);
            transform-origin: center center;
          `;
          
          const rows = 12;
          const cols = 6;
          const logoWidth = Math.floor(currentWidth / 4 * 0.4);
          const margin = Math.floor(currentWidth / 4 * 0.25);
          
          let loadPromises = [];
          for (let i = 0; i < rows * cols; i++) {
            const img = document.createElement('img');
            img.src = logoSrc;
            img.style.cssText = `
              width: ${logoWidth}px;
              height: auto;
              opacity: 0.3;
              margin: ${margin}px;
              flex-shrink: 0;
            `;
            innerWrapper.appendChild(img);
            loadPromises.push(new Promise((resolve, reject) => {
              if (img.complete) resolve();
              else {
                img.onload = resolve;
                img.onerror = reject;
              }
            }));
          }
          
          watermarkElement.appendChild(innerWrapper);
          watermarkElement._originalOverflow = originalOverflow;
          contentElement.appendChild(watermarkElement);
          await Promise.all(loadPromises);
          await this.$nextTick();
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        this.exportRenderProgress = 20;
        
        originalSrcs = await this.prepareImagesWithFilters(contentElement);
        await this.$nextTick();
        
        this.exportRenderProgress = 30;
        
        const computedStyle = window.getComputedStyle(contentElement);
        const bgImage = computedStyle.backgroundImage;
        
        if (bgImage && bgImage !== 'none') {
          const urlMatch = bgImage.match(/url\(["']?([^"')]+)["']?\)/);
          if (urlMatch && urlMatch[1]) {
            const bgUrl = urlMatch[1];
            originalBackgroundStyle = {
              backgroundImage: contentElement.style.backgroundImage,
              backgroundColor: contentElement.style.backgroundColor,
              backgroundSize: contentElement.style.backgroundSize,
              backgroundPosition: contentElement.style.backgroundPosition,
              backgroundRepeat: contentElement.style.backgroundRepeat
            };
            backgroundImgElement = document.createElement('img');
            backgroundImgElement.src = bgUrl;
            backgroundImgElement.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              z-index: -1;
              pointer-events: none;
            `;
            contentElement.style.backgroundImage = 'none';
            contentElement.insertBefore(backgroundImgElement, contentElement.firstChild);
            await new Promise((resolve, reject) => {
              if (backgroundImgElement.complete) resolve();
              else {
                backgroundImgElement.onload = resolve;
                backgroundImgElement.onerror = reject;
              }
            });
            await this.$nextTick();
          }
        }
        
        this.exportRenderProgress = 35;
        
        // Ждём загрузки всех изображений
        const allImages = contentElement.querySelectorAll('img');
        await Promise.all(Array.from(allImages).map(img => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
            setTimeout(resolve, 5000);
          });
        }));
        await this.$nextTick();
        
        this.exportRenderProgress = 40;
        
        const targetWidth = 3000;
        const scaleFactor = Math.max(3, Math.ceil(targetWidth / currentWidth));
        
        this.exportRenderProgress = 50;
        
        const canvas = await this.captureWithoutEditorControls(() => html2canvas(contentElement, {
          scale: scaleFactor,
          useCORS: true,
          allowTaint: true,
          logging: false,
          backgroundColor: null,
          width: currentWidth,
          height: currentHeight,
          ignoreElements: (element) => {
            return (
              element.classList &&
              (element.classList.contains('export-modal') ||
                element.classList.contains('modal-overlay') ||
                element.classList.contains('controls') ||
                element.classList.contains('transform-controls') ||
                element.classList.contains('resize-handle') ||
                element.classList.contains('element-toolbar') ||
                element.classList.contains('utils-block'))
            );
          },
          onclone: (clonedDoc) => {
            const clonedContent = clonedDoc.querySelector('.content-section');
            if (clonedContent) {
              clonedContent.style.overflow = 'hidden';
              const controls = clonedContent.querySelectorAll('.controls, .transform-controls, .resize-handle, .lasso-selection, .selection-area, .utils-block, .element-toolbar');
              controls.forEach((el) => el.remove());
            }
          }
        }));
        
        this.exportRenderProgress = 80;
        
        const imageData = canvas.toDataURL('image/png');
        
        this.exportRenderProgress = 100;
        
        this.showExportModal = true;
        this.exportStatus = 'uploading';
        this.exportUploadProgress = 0;
        await this.$nextTick();
        
        const token = localStorage.getItem('userToken');
        const response = await axios.post('/api/exports/generate', {
          imageData,
          projectId: this.currentProjectId,
          zoneId: this.activeZoneId,
          zoneTitle: this.currentZoneTitle
        }, {
          headers: { Authorization: `Bearer ${token}` },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.exportUploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          }
        });
        
        if (response.data.success) {
          this.exportDownloadUrl = response.data.downloadUrl;
          this.exportStatus = 'ready';
        } else {
          throw new Error(response.data.error || 'Ошибка сохранения');
        }
        
      } catch (error) {
        console.error('Mobile export error:', error);
        this.exportStatus = 'error';
        this.exportErrorMessage = error.message || this.$t('errors.creationImageError');
      } finally {
        this.isDownloadingContent = false;
        
        if (watermarkElement && watermarkElement.parentNode) {
          const contentEl = watermarkElement.parentNode;
          if (watermarkElement._originalOverflow !== undefined) {
            contentEl.style.overflow = watermarkElement._originalOverflow;
          }
          contentEl.removeChild(watermarkElement);
        }
        
        if (backgroundImgElement && backgroundImgElement.parentNode) {
          backgroundImgElement.parentNode.removeChild(backgroundImgElement);
          const contentElement = this.$refs.contentRef;
          if (contentElement && originalBackgroundStyle) {
            Object.assign(contentElement.style, originalBackgroundStyle);
          }
        }
        
        if (originalSrcs.size > 0) {
          this.restoreOriginalImages(originalSrcs);
        }
      }
    },
    closeExportModal() {
      this.showExportModal = false;
      this.exportStatus = 'rendering';
      this.exportRenderProgress = 0;
      this.exportUploadProgress = 0;
      this.exportDownloadUrl = '';
      this.exportErrorMessage = '';
    },
    retryExport() {
      this.startMobileExport();
    },
    handleMobileClearAll() {
      this.openClearModal();
    },
    handleMobileToggleSelection() {
      this.toggleSelectionMode();
    },
    getLayerName(item) {
      if (item.isText || item.type === 'text') {
        return item.text ? (item.text.length > 20 ? item.text.substring(0, 20) + '...' : item.text) : this.$t('legacy.Текст');
      }
      if (item.name) {
        return item.name;
      }
      if (item._isBackground || item.isBackground) {
        return this.$t('legacy.Фон');
      }
      return `${this.$t('editor.element')} ${item.id}`;
    },
    selectLayerItem(itemId) {
      this.highlightedCalculatorItemId = itemId;
      const item = this.droppedImages.find(i => i.id === itemId);
      if (item && item.groupId) {
        this.activeGroup = item.groupId;
        this.activeItemId = null;
        this.showControls = true;
      } else {
        this.activeItemId = itemId;
        this.activeImageId = itemId;
        this.activeGroup = null;
        this.showControls = true;
      }
    },
    handleReorderLayers(orderedIds) {
      if (!orderedIds || orderedIds.length === 0) return;
      const maxZIndex = orderedIds.length * 10; // Multiply for headroom
      
      console.log('🔄 handleReorderLayers called with orderedIds:', orderedIds);
      
      // Build a map of id -> zIndex for all items (groups and elements)
      const zIndexMap = {};
      orderedIds.forEach((id, index) => {
        zIndexMap[id] = maxZIndex - (index * 10);
      });
      
      console.log('🔄 zIndexMap:', zIndexMap);
      
      // Update zIndex for groups themselves
      this.groups = this.groups.map(group => {
        if (zIndexMap[group.id] !== undefined) {
          console.log(`🔄 Updating group ${group.id} zIndex from ${group.zIndex} to ${zIndexMap[group.id]}`);
          return { ...group, zIndex: zIndexMap[group.id] };
        }
        return group;
      });
      
      this.droppedImages = this.droppedImages.map(img => {
        // Check if element belongs to a group - use group's zIndex
        if (img.groupId && zIndexMap[img.groupId] !== undefined) {
          console.log(`🔄 Updating grouped element ${img.id} zIndex to ${zIndexMap[img.groupId]} (group: ${img.groupId})`);
          return { ...img, zIndex: zIndexMap[img.groupId] };
        }
        // For ungrouped elements, find by element id
        if (zIndexMap[img.id] !== undefined) {
          console.log(`🔄 Updating element ${img.id} zIndex from ${img.zIndex} to ${zIndexMap[img.id]}`);
          return { ...img, zIndex: zIndexMap[img.id] };
        }
        return img;
      });
      
      console.log('🔄 After reorder - groups:', this.groups.map(g => ({ id: g.id, zIndex: g.zIndex })));
      console.log('🔄 After reorder - droppedImages:', this.droppedImages.map(img => ({ id: img.id, zIndex: img.zIndex, groupId: img.groupId })));
      
      this.layerOrderTrigger++;
      this.$forceUpdate();
      this.markDirtyAndSync();
    },
    handleReorderGroupChildren(groupId, fromIndex, toIndex) {
      const group = this.groups.find(g => g.id === groupId);
      if (!group || !group.items || fromIndex === toIndex) return;
      
      const newItems = [...group.items];
      const [movedItem] = newItems.splice(fromIndex, 1);
      newItems.splice(toIndex, 0, movedItem);
      
      group.items = newItems;
      
      const itemsInGroup = this.droppedImages.filter(img => img.groupId === groupId);
      const maxZIndex = Math.max(...itemsInGroup.map(i => i.zIndex || 0), 0);
      
      this.droppedImages = this.droppedImages.map(img => {
        if (img.groupId === groupId) {
          const orderIndex = newItems.indexOf(img.id);
          if (orderIndex !== -1) {
            return { ...img, zIndex: maxZIndex - orderIndex };
          }
        }
        return img;
      });
      
      this.markDirtyAndSync();
    },
    handleMobileGroupChildTouchStart(event, groupId, childId, childIndex) {
      const touch = event.touches[0];
      this.mobileGroupDragStartY = touch.clientY;
      this.mobileGroupDragGroupId = groupId;
      this.mobileGroupDragChildId = childId;
      this.mobileGroupDragChildIndex = childIndex;
      this.mobileGroupDragStarted = false;
      
      document.addEventListener('touchmove', this.handleMobileGroupChildTouchMove, { passive: false });
      document.addEventListener('touchend', this.handleMobileGroupChildTouchEnd);
    },
    handleMobileGroupChildTouchMove(event) {
      if (this.mobileGroupDragGroupId === null || this.mobileGroupDragChildId === null) return;
      
      const touch = event.touches[0];
      const DRAG_THRESHOLD = 10;
      
      if (!this.mobileGroupDragStarted && this.mobileGroupDragStartY !== null) {
        const deltaY = Math.abs(touch.clientY - this.mobileGroupDragStartY);
        if (deltaY > DRAG_THRESHOLD) {
          this.mobileGroupDragStarted = true;
        }
      }
      
      if (this.mobileGroupDragStarted) {
        event.preventDefault();
        
        const groupContainer = document.querySelector(`.layers-bottom-sheet-group-children[data-group-id="${this.mobileGroupDragGroupId}"]`);
        if (!groupContainer) return;
        
        const elements = groupContainer.querySelectorAll('.layers-bottom-sheet-item.nested');
        for (let i = 0; i < elements.length; i++) {
          const rect = elements[i].getBoundingClientRect();
          if (touch.clientY >= rect.top && touch.clientY <= rect.bottom) {
            const childId = elements[i].dataset.childId;
            if (childId) {
              this.mobileGroupDragOverChildId = childId;
            }
            break;
          }
        }
      }
    },
    handleMobileGroupChildTouchEnd() {
      document.removeEventListener('touchmove', this.handleMobileGroupChildTouchMove);
      document.removeEventListener('touchend', this.handleMobileGroupChildTouchEnd);
      
      if (this.mobileGroupDragStarted && this.mobileGroupDragOverChildId && 
          String(this.mobileGroupDragChildId) !== String(this.mobileGroupDragOverChildId)) {
        const groupItem = this.groupedLayersList.find(g => g.isGroup && g.id === this.mobileGroupDragGroupId);
        if (groupItem && groupItem.elements) {
          const targetIndex = groupItem.elements.findIndex(el => String(el.id) === String(this.mobileGroupDragOverChildId));
          if (targetIndex !== -1) {
            this.handleReorderGroupChildren(this.mobileGroupDragGroupId, this.mobileGroupDragChildIndex, targetIndex);
          }
        }
      }
      
      this.mobileGroupDragGroupId = null;
      this.mobileGroupDragChildId = null;
      this.mobileGroupDragChildIndex = null;
      this.mobileGroupDragOverChildId = null;
      this.mobileGroupDragStartY = null;
      this.mobileGroupDragStarted = false;
    },
    handleMobileLayerDragStart(event, index) {
      this.mobileDragLayerIndex = index;
      event.dataTransfer.effectAllowed = 'move';
    },
    handleMobileLayerDragEnd() {
      this.mobileDragLayerIndex = null;
      this.mobileDragOverIndex = null;
      this.mobileDragLayerId = null;
      this.mobileDragOverId = null;
    },
    handleMobileLayerDragOver(index) {
      if (this.mobileDragLayerIndex === null) return;
      this.mobileDragOverIndex = index;
    },
    handleMobileLayerDrop(targetIndex) {
      if (this.mobileDragLayerIndex === null || this.mobileDragLayerIndex === targetIndex) {
        this.handleMobileLayerDragEnd();
        return;
      }
      const newOrder = [...this.groupedLayersList];
      const [movedItem] = newOrder.splice(this.mobileDragLayerIndex, 1);
      newOrder.splice(targetIndex, 0, movedItem);
      this.handleReorderLayers(newOrder.map(item => item.id));
      this.handleMobileLayerDragEnd();
    },
    handleMobileLayerTouchStart(event, index) {
      const touch = event.touches[0];
      this.mobileTouchStartY = touch.clientY;
      this.mobileTouchDragIndex = index;
    },
    handleMobileLayerTouchMove(event) {
      if (this.mobileTouchDragIndex === null && this.mobileTouchDragId === null) return;
      
      const touch = event.touches[0];
      const DRAG_THRESHOLD = 10;
      
      if (!this.mobileDragStarted && this.mobileTouchStartY !== null) {
        const deltaY = Math.abs(touch.clientY - this.mobileTouchStartY);
        if (deltaY < DRAG_THRESHOLD) return;
        this.mobileDragStarted = true;
        // Set visual drag indicator
        this.mobileDragLayerId = this.mobileTouchDragId;
      }
      
      // Only prevent default when drag is active
      if (this.mobileDragStarted) {
        event.preventDefault();
      }
      
      // Find list via document query since event comes from document
      const listEl = document.querySelector('.layers-bottom-sheet-list');
      if (!listEl) return;
      
      // Find both regular items and groups
      const items = listEl.querySelectorAll('.layers-bottom-sheet-item:not(.nested), .layers-bottom-sheet-group');
      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (touch.clientY >= rect.top && touch.clientY <= rect.bottom) {
          // Check for group first, then regular item
          const groupId = item.dataset.groupId;
          const itemId = item.dataset.itemId;
          if (groupId) {
            // Group ID is a string like "group-123456"
            this.mobileDragOverId = groupId;
          } else if (itemId) {
            // Convert to number for regular element ids
            this.mobileDragOverId = Number(itemId);
          }
        }
      });
      
      if (this.mobileTouchDragId) {
        this.mobileDragLayerId = this.mobileTouchDragId;
      } else if (this.mobileTouchDragIndex !== null) {
        this.mobileDragLayerIndex = this.mobileTouchDragIndex;
      }
    },
    handleMobileLayerTouchEnd() {
      if (this.mobileTouchDragIndex !== null && this.mobileDragOverIndex !== null && 
          this.mobileTouchDragIndex !== this.mobileDragOverIndex) {
        const newOrder = [...this.groupedLayersList];
        const [movedItem] = newOrder.splice(this.mobileTouchDragIndex, 1);
        newOrder.splice(this.mobileDragOverIndex, 0, movedItem);
        this.handleReorderLayers(newOrder.map(item => item.id));
      }
      this.mobileTouchDragIndex = null;
      this.mobileDragLayerIndex = null;
      this.mobileDragOverIndex = null;
      this.mobileTouchStartY = null;
    },
    findLayerIndexById(itemId) {
      // Search in groupedLayersList to find both groups and individual items
      return this.groupedLayersList.findIndex(item => item.id === itemId);
    },
    handleMobileLayerDragStartById(event, itemId) {
      this.mobileDragLayerId = itemId;
      event.dataTransfer.effectAllowed = 'move';
    },
    handleMobileLayerDragEndById() {
      this.mobileDragLayerId = null;
      this.mobileDragOverId = null;
    },
    handleMobileLayerDragOverById(itemId) {
      if (this.mobileDragLayerId === null) return;
      this.mobileDragOverId = itemId;
    },
    handleMobileLayerDropById(targetId) {
      if (this.mobileDragLayerId === null || this.mobileDragLayerId === targetId) {
        this.handleMobileLayerDragEndById();
        return;
      }
      const fromIndex = this.findLayerIndexById(this.mobileDragLayerId);
      const toIndex = this.findLayerIndexById(targetId);
      if (fromIndex === -1 || toIndex === -1) {
        this.handleMobileLayerDragEndById();
        return;
      }
      // Use groupedLayersList to include both groups and individual items
      const newOrder = [...this.groupedLayersList];
      const [movedItem] = newOrder.splice(fromIndex, 1);
      newOrder.splice(toIndex, 0, movedItem);
      this.handleReorderLayers(newOrder.map(item => item.id));
      this.handleMobileLayerDragEndById();
    },
    handleMobileLayerTouchStartById(event, itemId) {
      const touch = event.touches[0];
      this.mobileTouchStartY = touch.clientY;
      this.mobileTouchDragId = itemId;
      this.mobileDragStarted = false;
      
      // Add document-level listeners for drag
      document.addEventListener('touchmove', this.handleMobileLayerTouchMove, { passive: false });
      document.addEventListener('touchend', this.handleMobileLayerTouchEndById);
    },
    handleMobileLayerTouchEndById() {
      // Remove document-level listeners
      document.removeEventListener('touchmove', this.handleMobileLayerTouchMove);
      document.removeEventListener('touchend', this.handleMobileLayerTouchEndById);
      if (this.mobileDragStarted && this.mobileTouchDragId !== null && this.mobileDragOverId !== null && 
          this.mobileTouchDragId !== this.mobileDragOverId) {
        const fromIndex = this.findLayerIndexById(this.mobileTouchDragId);
        const toIndex = this.findLayerIndexById(this.mobileDragOverId);
        if (fromIndex !== -1 && toIndex !== -1) {
          this.saveHistoryState();
          // Use groupedLayersList to include both groups and individual items
          const newOrder = [...this.groupedLayersList];
          const [movedItem] = newOrder.splice(fromIndex, 1);
          newOrder.splice(toIndex, 0, movedItem);
          this.handleReorderLayers(newOrder.map(item => item.id));
        }
      }
      this.mobileTouchDragId = null;
      this.mobileDragLayerId = null;
      this.mobileDragOverId = null;
      this.mobileTouchStartY = null;
      this.mobileDragStarted = false;
    },

    applyBackground(backgroundData) {
      const contentSection = this.$refs.contentRef;
      if (!contentSection) return;

      if (backgroundData.type === 'color') {
        contentSection.style.backgroundColor = backgroundData.value;
        contentSection.style.backgroundImage = 'none';
      } else if (backgroundData.type === 'custom' || backgroundData.type === 'library') {
        contentSection.style.backgroundImage = `url(${backgroundData.value})`;
        contentSection.style.backgroundColor = 'transparent';
        contentSection.style.backgroundSize = 'cover';
        contentSection.style.backgroundPosition = 'center';
        contentSection.style.backgroundRepeat = 'no-repeat';
      }

      // Save background to zone metadata
      if (this.activeZone) {
        this.zoneBackground = backgroundData;
        this.markDirtyAndSync();
      }
    },

    async handleProjectSave() {
      try {
        this.showControls = false;
        this.isSaving = true;

        const activeZoneId = this.$store.state.zones.activeZoneId;
        if (!activeZoneId) {
          throw new Error(this.$t('Нет активной зоны для сохранения'));
        }

        if (!Array.isArray(this.droppedImages) || this.droppedImages.length === 0) {
          throw new Error(this.$t('legacy.Добавьте элементы для сохранения'));
        }

        const images = this.droppedImages.map((element) => {
          const baseElement = {
            type: element.type || 'image',
            id: element.id || Date.now(),
            content: element.type === 'text' ? (element.text || element.content || '') : (element.content || element.src || ''),
            perspective: this.normalizePerspective(element.perspective ?? element.styles?.perspective),
            eraser: normalizeEraser(element.eraser),
            position: {
              x: Number(element.x ?? element.position?.x ?? 0),
              y: Number(element.y ?? element.position?.y ?? 0),
            },
            size: {
              width: Number(element.width ?? element.size?.width ?? 100),
              height: Number(element.height ?? element.size?.height ?? 100),
            },
            styles: {
              ...(element.styles || {}),
              font: element.styles?.font || element.fontName || 'Arial',
              color: element.color || element.styles?.color || '#000000',
              opacity: Number(element.opacity ?? element.styles?.opacity ?? 1),
              rotation: Number(element.rotate ?? element.styles?.rotation ?? 0),
              zIndex: Number(element.zIndex ?? element.styles?.zIndex ?? 1),
              flip: Boolean(element.flip ?? element.styles?.flip ?? false),
              flipX: Boolean(element.flipX ?? element.styles?.flipX ?? false),
              flipY: Boolean(element.flipY ?? element.styles?.flipY ?? false),
            },
            filters: element.filters ? { ...element.filters } : {},
            isBackground: Boolean(element.isBackground),
            isColor: Boolean(element.isColor),
            locked: Boolean(element.locked),
            createdAt: element.createdAt || new Date().toISOString(),
            // Save price for cost calculation
            price: Number(element.price) || 0,
            // Save font-specific properties for text elements
            fontName: element.fontName || null,
            fontCategory: element.fontCategory || 'sans-serif',
            isGoogleFont: Boolean(element.isGoogleFont),
            fontUrl: element.fontUrl || null,
            fontId: element.fontId || null,
            textShadow: Boolean(element.textShadow),
            color: element.color || '#000000',
            fontSize: element.fontSize || null,
            groupId: element.groupId || null,
            elementId: element.elementId || null,
            rootCategoryName: element.rootCategoryName || null,
            isUserElement: Boolean(element.isUserElement),
            userElementId: element.userElementId || null,
          };

          if (element.type === 'image' && !baseElement.content && element.src) {
            baseElement.content = element.src;
          }

          return baseElement;
        });

        // Serialize groups for saving - use group.items directly (more reliable)
        const savedGroups = this.groups.map((g) => {
          const elementIds = g.items || [];
          return {
            id: g.id,
            name: g.name || this.$t('editor.group'),
            items: [...elementIds],
            elementIds: [...elementIds],
            x: g.x,
            y: g.y,
            centerX: g.centerX,
            centerY: g.centerY,
            width: g.width,
            height: g.height,
            originalWidth: g.originalWidth || g.width,
            originalHeight: g.originalHeight || g.height,
            rotate: g.rotate || 0,
            zIndex: g.zIndex || 1,
            locked: g.locked || false,
            flipX: g.flipX || false,
            flipY: g.flipY || false,
            opacity: g.opacity ?? 1,
            filters: g.filters || {},
            perspective: this.normalizePerspective(g.perspective ?? g.styles?.perspective),
            eraser: normalizeEraser(g.eraser),
            elementsOriginalState: g.elementsOriginalState || {},
          };
        });

        // Save with background info and groups
        const zoneData = {
          elements: images,
          background: this.zoneBackground,
          groups: savedGroups,
        };

        await this.$store.dispatch('zones/updateZone', {
          zoneId: activeZoneId,
          data: zoneData,
        });

        this.showSaveModal = false;
        this.showSuccessModal = true;
        this.savedProjectName = this.currentZoneTitle || this.$t('Зона сохранена');

        this.$store.dispatch('zones/markDirty', false);
      } catch (error) {
        console.error('Ошибка сохранения:', error);
        alert(`${this.$t('errors.save')}: ${error.message}`);
      } finally {
        this.isSaving = false;
        this.showControls = true;
      }
    },

    goToProjectsPage() {
      this.$router.push('/projects');
    },

    loadProject() {
      const projectId = this.projectId;
      if (!projectId) return;

      try {
        const savedProjects = JSON.parse(localStorage.getItem('savedProjects')) || [];
        const projectToLoad = savedProjects.find((p) => p.id === Number(projectId));

        if (projectToLoad) {
          this.currentProject = projectToLoad;
          this.slidesId = projectToLoad.zoneId;
          this.droppedImages = JSON.parse(JSON.stringify(projectToLoad.images));
          this.shaw.content = true;
          this.shaw.sidebar = true;

          const slide = this.fotozones.find((f) => f.id === projectToLoad.zoneId);
          if (slide) {
            slide.images = [...this.droppedImages];
          }
        } else {
          console.error('Проект не найден');
        }
      } catch (error) {
        console.error('Ошибка загрузки проекта:', error);
      }
    },
    clearCurrentProject() {
      this.currentProject = null;
    },

    setHighlight(shouldHighlight) {
      this.highlightSlides = shouldHighlight;
      if (shouldHighlight) {
        this.$nextTick(() => {
          const slides = document.querySelector('.slides-track');
          if (slides) slides.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    },
    handleSlideChange(newId) {
      this.slidesId = newId;
    },

    loadZoneContent(zoneId) {
      if (this.zoneContents[zoneId]) {
        this.droppedImages = this.zoneContents[zoneId];
      } else {
        this.droppedImages = [];
        this.zoneContents[zoneId] = this.droppedImages;
      }

      this.activeItemId = null;
      this.showControls = false;
    },
    async loadProjectFromQuery() {
      const projectId = this.projectId;
      
      if (!projectId) {
        return;
      }
      
      this.isZoneLoading = true;
      
      try {
        const projectData = await fetchProjectById(projectId);
        if (projectData && projectData.project) {
          this.$store.commit('projects/SET_CURRENT_PROJECT', projectData.project);
        }
        
        await this.loadZonesList(projectId);
        
        if (!this.zonesList || this.zonesList.length === 0) {
          return;
        }

        const activeZoneInfo = this.zonesList.find(z => z.is_active) || this.zonesList[0];
        
        await this.setActiveZone(activeZoneInfo.id);
        
        this.syncZoneDataToLocal();
        
        this.fotozones = this.zonesList.map(z => ({
          id: z.id,
          title: z.title,
          zoneId: z.zone_id,
        }));
      } catch (error) {
        console.error('Ошибка загрузки проекта:', error);
      } finally {
        // Скрываем прелоадер после загрузки
        setTimeout(() => {
          this.isZoneLoading = false;
        }, 300);
      }
    },

    async enrichElementsWithCategories() {
      // Find elements without rootCategoryName
      const elementsToEnrich = this.droppedImages.filter(
        el => !el.rootCategoryName && !el.isText && el.type !== 'text' && !el._isBackground && !el.isBackground
      );
      
      if (elementsToEnrich.length === 0) return;
      
      // Separate regular elements and user elements
      const regularElements = elementsToEnrich.filter(el => !el.isUserElement);
      const userElements = elementsToEnrich.filter(el => el.isUserElement && el.userElementId);
      
      // Separate elements with and without elementId
      const withElementId = regularElements.filter(el => el.elementId);
      const withoutElementId = regularElements.filter(el => !el.elementId && el.name);
      
      const elementIds = withElementId.map(el => el.elementId);
      const elementNames = [...new Set(withoutElementId.map(el => el.name))];
      const userElementIds = userElements.map(el => el.userElementId);
      
      try {
        // Fetch regular elements info
        if (elementIds.length > 0 || elementNames.length > 0) {
          const response = await getElementsInfo(elementIds, elementNames);
          if (response.success) {
            this.droppedImages = this.droppedImages.map(el => {
              if (el.isUserElement) return el;
              // Try to match by elementId first
              if (el.elementId && response.elementsById && response.elementsById[el.elementId]) {
                return {
                  ...el,
                  rootCategoryName: response.elementsById[el.elementId].rootCategoryName || el.rootCategoryName
                };
              }
              // Fallback to matching by name
              if (!el.rootCategoryName && el.name && response.elementsByName && response.elementsByName[el.name]) {
                return {
                  ...el,
                  rootCategoryName: response.elementsByName[el.name].rootCategoryName || el.rootCategoryName,
                  elementId: response.elementsByName[el.name].id || el.elementId
                };
              }
              return el;
            });
          }
        }
        
        // Fetch user elements info
        if (userElementIds.length > 0) {
          const { getUserElementsInfo } = await import('@/api/user-elements.js');
          const userResponse = await getUserElementsInfo(userElementIds);
          if (userResponse.success && userResponse.elements) {
            this.droppedImages = this.droppedImages.map(el => {
              if (el.isUserElement && el.userElementId && userResponse.elements[el.userElementId]) {
                return {
                  ...el,
                  rootCategoryName: userResponse.elements[el.userElementId].rootCategoryName || el.rootCategoryName
                };
              }
              return el;
            });
          }
        }
      } catch (error) {
        console.warn('Failed to enrich elements with categories:', error);
      }
    },

    syncZoneDataToLocal() {
      if (!this.activeZone || !this.activeZone.data) {
        this.droppedImages = [];
        this.textElements = [];
        return;
      }

      // Handle new data format with background and elements
      let elementsData = [];
      let backgroundData = null;

      let groupsData = [];

      if (Array.isArray(this.activeZone.data)) {
        // Old format: array of elements
        elementsData = this.activeZone.data;
      } else if (this.activeZone.data && typeof this.activeZone.data === 'object') {
        // New format: object with elements, background and groups
        elementsData = this.activeZone.data.elements || [];
        backgroundData = this.activeZone.data.background || null;
        groupsData = this.activeZone.data.groups || [];
      }
      
      // Логируем что приходит с сервера для отладки
      console.log('📥 syncZoneDataToLocal - received elements:', elementsData.map(el => ({
        id: el.id,
        name: el.name,
        type: el.type,
        hasContent: !!el.content,
        contentStart: el.content?.substring(0, 80)
      })));
      
      this.droppedImages = elementsData.map((item, index) => ({
        ...item,
        perspective: this.normalizePerspective(item.perspective ?? item.styles?.perspective),
        eraser: normalizeEraser(item.eraser),
        src: ['image', 'background'].includes(item.type) ? item.content : null,
        // Restore text content for text elements
        text: item.type === 'text' ? (item.content || item.text || '') : null,
        // Restore font properties - fontName takes precedence over styles.font
        fontName: item.fontName || item.styles?.font || 'Arial',
        fontCategory: item.fontCategory || 'sans-serif',
        isGoogleFont: item.isGoogleFont || false,
        fontUrl: item.fontUrl || null,
        fontId: item.fontId || null,
        // Color: prioritize direct color property, then styles.color, fallback to black
        color: item.color || item.styles?.color || '#000000',
        textShadow: item.textShadow || false,
        // Restore fontSize with legacy fallback (calculate from height if not stored)
        fontSize: item.fontSize || Math.max(16, Number(item.size?.height ?? item.height ?? 40) * 0.7),
        x: Number(item.position?.x ?? item.styles?.x ?? 0),
        y: Number(item.position?.y ?? item.styles?.y ?? 0),
        width: Number(item.size?.width ?? item.styles?.width ?? 100),
        height: Number(item.size?.height ?? item.styles?.height ?? 100),
        exposure: Number(item.filters?.exposure ?? 0),
        contrast: Number(item.filters?.contrast ?? 0),
        saturation: Number(item.filters?.saturation ?? 0),
        temperature: Number(item.filters?.temperature ?? 0),
        hue: Number(item.filters?.hue ?? 0),
        rotate: Number(item.styles?.rotation ?? item.rotate ?? 0),
        flipX: Boolean(item.styles?.flipX ?? item.flipX),
        flipY: Boolean(item.styles?.flipY ?? item.flipY),
        opacity: Number(item.styles?.opacity ?? item.opacity ?? 1),
        // Исправляем zIndex: если элемент не является фоном, но имеет отрицательный zIndex - это баг
        zIndex: (() => {
          const savedZIndex = Number(item.styles?.zIndex ?? item.zIndex ?? (index + 1));
          // Если элемент не фон и имеет отрицательный zIndex - исправляем на положительный
          if (!item._isBackground && savedZIndex < 0) {
            console.warn(`⚠️ Исправление zIndex для элемента ${item.name || item.id}: ${savedZIndex} -> ${index + 1}`);
            return index + 1;
          }
          return savedZIndex;
        })(),
        // Restore price for cost calculation
        price: Number(item.price) || 0,
        // Restore elementId for favorites lookup
        elementId: item.elementId || null,
        // Restore groupId for group membership
        groupId: item.groupId || null,
        // Restore root category name for calculator grouping
        rootCategoryName: item.rootCategoryName || null,
        // Restore user element data
        isUserElement: Boolean(item.isUserElement),
        userElementId: item.userElementId || null,
      }));

      // Enrich elements with rootCategoryName from API if missing
      this.enrichElementsWithCategories();

      // Restore groups from saved data
      this.groups = groupsData.map((g) => ({
        id: g.id,
        x: Number(g.x || 0),
        y: Number(g.y || 0),
        width: Number(g.width || 0),
        height: Number(g.height || 0),
        originalWidth: Number(g.originalWidth || g.width || 0),
        originalHeight: Number(g.originalHeight || g.height || 0),
        rotate: Number(g.rotate || 0),
        flipX: Boolean(g.flipX),
        flipY: Boolean(g.flipY),
        opacity: Number(g.opacity ?? 1),
        locked: Boolean(g.locked),
        zIndex: Number(g.zIndex || 0),
        filters: g.filters || {},
        perspective: this.normalizePerspective(g.perspective ?? g.styles?.perspective),
        eraser: normalizeEraser(g.eraser),
        elementsOriginalState: g.elementsOriginalState || {},
        elementIds: g.elementIds || g.items || [],
        items: g.elementIds || g.items || [],
      }));
      
      // Restore groupId and relativeX/relativeY on elements from saved groups
      this.groups.forEach((group) => {
        if (group.elementIds && group.elementIds.length > 0) {
          this.droppedImages = this.droppedImages.map((el) => {
            if (group.elementIds.includes(el.id)) {
              // Calculate relative position within the group
              const relativeX = el.x - group.x;
              const relativeY = el.y - group.y;
              return { 
                ...el, 
                groupId: group.id,
                relativeX,
                relativeY 
              };
            }
            return el;
          });
        }
      });

      // Apply background if exists
      this.zoneBackground = backgroundData;
      if (backgroundData) {
        this.$nextTick(() => {
          this.applyBackground(backgroundData);
        });
      } else {
        // Clear background
        const contentSection = this.$refs.contentRef;
        if (contentSection) {
          contentSection.style.backgroundColor = '';
          contentSection.style.backgroundImage = '';
        }
      }

      this.loadFontsForActiveZone();

      if (this.currentSlideId != null) {
        this.zoneContents[this.currentSlideId] = this.droppedImages;
      }
      
      // Sync loaded elements back to Vuex store to ensure totalProjectPrice is computed
      this.$nextTick(() => {
        if (this.droppedImages.length > 0) {
          const elements = this.droppedImages.map((item) => ({
            id: item.id,
            type: item.isText || item.type === 'text' ? 'text' : 'image',
            name: item.name || '',
            content: item.isText || item.type === 'text' ? item.text : item.src,
            perspective: this.normalizePerspective(item.perspective ?? item.styles?.perspective),
            eraser: normalizeEraser(item.eraser),
            price: this.getEffectivePrice(item.elementId, item.price),
            elementId: item.elementId || null,
            position: { x: item.x, y: item.y },
            size: { width: item.width, height: item.height },
            styles: {
              zIndex: item.zIndex,
              rotation: item.rotate || 0,
              flipX: item.flipX || false,
              flipY: item.flipY || false,
              opacity: item.opacity ?? 1,
            },
            filters: {
              exposure: item.exposure || 0,
              contrast: item.contrast || 0,
              saturation: item.saturation || 0,
              temperature: item.temperature || 0,
              hue: item.hue || 0,
            },
            fontName: item.fontName,
            fontCategory: item.fontCategory,
            isGoogleFont: item.isGoogleFont,
            fontUrl: item.fontUrl,
            fontId: item.fontId,
            color: item.color,
            textShadow: item.textShadow,
            fontSize: item.fontSize,
          }));
          this.syncZoneElements({ elements, background: this.zoneBackground });
        }
      });
    },
    setupAutoSave() {
      this.clearAutoSave();

      saveInterval = setInterval(async () => {
        if (this.activeZoneId === null || this.activeZoneId === undefined || !this.hasUnsavedChanges) {
          return;
        }

        try {
          
          const validElements = this.droppedImages
            .filter((el) => {
              if (el.type === 'image' && !el.isColor && !el.content && !el.src) {
                console.warn('⚠️ Skipping element with empty content:', el.id);
                return false;
              }
              return true;
            })
            .map((element) => {
              const baseElement = {
                type: element.type || 'image',
                id: element.id || Date.now(),
                name: element.name || '',
                content: element.type === 'text' ? (element.text || element.content || '') : (element.content || element.src || ''),
                perspective: this.normalizePerspective(element.perspective ?? element.styles?.perspective),
                eraser: normalizeEraser(element.eraser),
                position: {
                  x: Number(element.x ?? element.position?.x ?? 0),
                  y: Number(element.y ?? element.position?.y ?? 0),
                },
                size: {
                  width: Number(element.width ?? element.size?.width ?? 100),
                  height: Number(element.height ?? element.size?.height ?? 100),
                },
                styles: {
                  ...(element.styles || {}),
                  font: element.styles?.font || element.fontName || 'Arial',
                  color: element.color || element.styles?.color || '#000000',
                  opacity: Number(element.opacity ?? element.styles?.opacity ?? 1),
                  rotation: Number(element.rotate ?? element.styles?.rotation ?? 0),
                  zIndex: Number(element.zIndex ?? element.styles?.zIndex ?? 1),
                  flip: Boolean(element.flip ?? element.styles?.flip ?? false),
                  flipX: Boolean(element.flipX ?? element.styles?.flipX ?? false),
                  flipY: Boolean(element.flipY ?? element.styles?.flipY ?? false),
                },
                filters: element.filters ? { ...element.filters } : {},
                isBackground: Boolean(element.isBackground),
                isColor: Boolean(element.isColor),
                locked: Boolean(element.locked),
                createdAt: element.createdAt || new Date().toISOString(),
                // Save effective price (including favorites customPrice) for cost calculation
                price: this.getEffectivePrice(element.elementId, element.price),
                // Save elementId for favorites lookup (custom prices)
                elementId: element.elementId || null,
                // Save font-specific properties for text elements
                fontName: element.fontName || null,
                fontCategory: element.fontCategory || 'sans-serif',
                isGoogleFont: Boolean(element.isGoogleFont),
                fontUrl: element.fontUrl || null,
                fontId: element.fontId || null,
                textShadow: Boolean(element.textShadow),
                // Save color directly for text elements (in addition to styles.color)
                color: element.color || '#000000',
                // Save fontSize for text elements (for proportional scaling)
                fontSize: element.fontSize || null,
                // Save groupId for group membership
                groupId: element.groupId || null,
                // Save root category name for calculator grouping
                rootCategoryName: element.rootCategoryName || null,
                // Save user element data
                isUserElement: Boolean(element.isUserElement),
                userElementId: element.userElementId || null,
              };

              if (element.type === 'image' && !baseElement.content && element.src) {
                baseElement.content = element.src;
              }

              return baseElement;
            });
          
          // Save groups with their element associations - use group.items directly
          const savedGroups = this.groups.map((g) => {
            const elementIds = g.items || [];
            return {
              id: g.id,
              x: g.x,
              y: g.y,
              centerX: g.centerX,
              centerY: g.centerY,
              width: g.width,
              height: g.height,
              originalWidth: g.originalWidth || g.width,
              originalHeight: g.originalHeight || g.height,
              rotate: g.rotate || 0,
              flipX: g.flipX || false,
              flipY: g.flipY || false,
              opacity: g.opacity ?? 1,
              locked: g.locked || false,
              zIndex: g.zIndex || 0,
              filters: g.filters || {},
              perspective: this.normalizePerspective(g.perspective ?? g.styles?.perspective),
              eraser: normalizeEraser(g.eraser),
              elementsOriginalState: g.elementsOriginalState || {},
              elementIds: [...elementIds],
              items: [...elementIds],
            };
          });

          // Prepare zone data with background and groups info
          const zoneData = {
            elements: validElements,
            background: this.zoneBackground,
            groups: savedGroups,
          };

          await this.updateZone({
            zoneId: this.activeZoneId,
            data: zoneData,
          });

          if (this.isFirstZone()) {
            await this.generateAndUploadCover();
          }
        } catch (error) {
          console.error('Auto-save error:', error);
        }
      }, SAVE_DELAY);
    },

    isFirstZone() {
      if (!this.fotozones || this.fotozones.length === 0 || !this.activeZoneId) {
        return false;
      }
      const firstZone = [...this.fotozones].sort((a, b) => {
        const aId = Number(a.id) || Number.MAX_SAFE_INTEGER;
        const bId = Number(b.id) || Number.MAX_SAFE_INTEGER;
        return aId - bId;
      })[0];
      return firstZone && Number(this.activeZoneId) === Number(firstZone.id);
    },

    async generateAndUploadCover() {
      try {
        if (!this.projectId) {
          return;
        }

        if (this.droppedImages.length === 0) {
          return;
        }

        const contentElement = this.$refs.contentRef;
        if (!contentElement) {
          console.warn('Content element not found for cover generation');
          return;
        }

        // Ждём загрузки всех изображений для обложки
        const allImages = contentElement.querySelectorAll('img');
        await Promise.all(Array.from(allImages).map(img => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
            setTimeout(resolve, 3000);
          });
        }));
        await this.$nextTick();

        let coverImage = null;
        try {
          const canvas = await this.captureWithoutEditorControls(() => html2canvas(contentElement, {
            backgroundColor: null,
            scale: 0.5,
            logging: false,
            useCORS: true,
            allowTaint: true,
          }));

          if (!canvas) {
            console.warn('html2canvas failed to generate canvas');
            return;
          }

          coverImage = canvas.toDataURL('image/png');
        } catch (canvasError) {
          console.error('html2canvas generation failed:', canvasError);
          return;
        }

        if (!coverImage) {
          return;
        }

        await this.uploadProjectCover(coverImage);
      } catch (error) {
        console.error('Generate cover error:', error);
      }
    },

    async uploadProjectCover(coverImage) {
      try {
        if (!this.projectId) {
          console.warn('Cannot upload cover: no projectId');
          return;
        }
        const response = await fetch(`/api/save/cover/${this.projectId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
          body: JSON.stringify({ coverImage }),
        });

        if (!response.ok) {
          throw new Error('Failed to upload cover');
        }

        await response.json();
      } catch (error) {
        console.error('Upload cover error:', error);
      }
    },

    clearAutoSave() {
      if (saveInterval) {
        clearInterval(saveInterval);
        saveInterval = null;
      }
    },
    getProjectData() {
      return {
        zone_id: this.activeZoneId,
        zone_title: this.currentZoneTitle,
        data: this.utf8ToBase64(JSON.stringify(this.droppedImages)),
      };
    },
    async saveProject() {
      if (!this.activeZoneId) {
        console.warn('Cannot save: no active zone');
        return;
      }

      try {
        const validElements = this.droppedImages
          .filter((el) => {
            if (el.type === 'image' && !el.isColor && !el.content && !el.src) {
              console.warn('⚠️ Skipping element with empty content:', el.id);
              return false;
            }
            return true;
          })
          .map((element) => {
            const baseElement = {
              type: element.type || 'image',
              id: element.id || Date.now(),
              name: element.name || '',
              content: element.type === 'text' ? (element.text || element.content || '') : (element.content || element.src || ''),
              perspective: this.normalizePerspective(element.perspective ?? element.styles?.perspective),
              eraser: normalizeEraser(element.eraser),
              position: {
                x: Number(element.x ?? element.position?.x ?? 0),
                y: Number(element.y ?? element.position?.y ?? 0),
              },
              size: {
                width: Number(element.width ?? element.size?.width ?? 100),
                height: Number(element.height ?? element.size?.height ?? 100),
              },
              styles: {
                ...(element.styles || {}),
                font: element.styles?.font || element.fontName || 'Arial',
                color: element.color || element.styles?.color || '#000000',
                opacity: Number(element.opacity ?? element.styles?.opacity ?? 1),
                rotation: Number(element.rotate ?? element.styles?.rotation ?? 0),
                zIndex: Number(element.zIndex ?? element.styles?.zIndex ?? 1),
                flip: Boolean(element.flip ?? element.styles?.flip ?? false),
                flipX: Boolean(element.flipX ?? element.styles?.flipX ?? false),
                flipY: Boolean(element.flipY ?? element.styles?.flipY ?? false),
              },
              filters: element.filters ? { ...element.filters } : {},
              isBackground: Boolean(element.isBackground),
              isColor: Boolean(element.isColor),
              locked: Boolean(element.locked),
              createdAt: element.createdAt || new Date().toISOString(),
              // Save price for cost calculation
              price: Number(element.price) || 0,
              // Save font-specific properties for text elements
              fontName: element.fontName || null,
              fontCategory: element.fontCategory || 'sans-serif',
              isGoogleFont: Boolean(element.isGoogleFont),
              fontUrl: element.fontUrl || null,
              fontId: element.fontId || null,
              textShadow: Boolean(element.textShadow),
              color: element.color || '#000000',
              fontSize: element.fontSize || null,
              groupId: element.groupId || null,
              elementId: element.elementId || null,
              rootCategoryName: element.rootCategoryName || null,
              isUserElement: Boolean(element.isUserElement),
              userElementId: element.userElementId || null,
            };

            if (element.type === 'image' && !baseElement.content && element.src) {
              baseElement.content = element.src;
            }

            return baseElement;
          });
        
        // Use group.items directly for reliable persistence
        const savedGroups = this.groups.map((g) => {
          const elementIds = g.items || [];
          return {
            id: g.id,
            x: g.x,
            y: g.y,
            centerX: g.centerX,
            centerY: g.centerY,
            width: g.width,
            height: g.height,
            originalWidth: g.originalWidth || g.width,
            originalHeight: g.originalHeight || g.height,
            rotate: g.rotate || 0,
            flipX: g.flipX || false,
            flipY: g.flipY || false,
            opacity: g.opacity ?? 1,
            locked: g.locked || false,
            zIndex: g.zIndex || 0,
            filters: g.filters || {},
            perspective: this.normalizePerspective(g.perspective ?? g.styles?.perspective),
            eraser: normalizeEraser(g.eraser),
            elementsOriginalState: g.elementsOriginalState || {},
            elementIds: [...elementIds],
            items: [...elementIds],
          };
        });
        
        const zoneData = {
          elements: validElements,
          background: this.zoneBackground,
          groups: savedGroups,
        };

        await this.updateZone({
          zoneId: this.activeZoneId,
          data: zoneData,
        });
        
        this.$store.commit('zones/SET_UNSAVED_CHANGES', false);
        return { success: true };
      } catch (error) {
        console.error('Manual save error:', error);
        throw error;
      }
    },

    // Вызывайте этот метод при ручном сохранении
    async manualSave() {
      await this.saveProject();
    },
    
    async loadFavorites() {
      try {
        this.favorites = await getFavoriteIds();
      } catch (error) {
        console.error('Error loading favorites:', error);
        this.favorites = {};
      }
    },
    
    getEffectivePrice(elementId, originalPrice) {
      const key = String(elementId);
      const fav = this.favorites[key];
      if (fav?.customPrice !== null && fav?.customPrice !== undefined) {
        return Number(fav.customPrice);
      }
      return Number(originalPrice) || 0;
    },

    async refreshPricesFromFavorites() {
      try {
        this.favorites = await getFavoriteIds();
      } catch (e) {
        console.error('Failed to reload favorites:', e);
        this.favorites = {};
      }
      
      let updatedCount = 0;
      this.droppedImages = this.droppedImages.map(item => {
        const originalPrice = item.originalPrice ?? item.price ?? 0;
        const newPrice = this.getEffectivePrice(item.elementId, originalPrice);
        if (newPrice !== item.price) {
          updatedCount++;
        }
        return {
          ...item,
          originalPrice: originalPrice,
          price: newPrice,
          effectivePrice: newPrice
        };
      });
      
      const elements = this.droppedImages.map((item) => ({
        id: item.id,
        type: item.isText || item.type === 'text' ? 'text' : 'image',
        name: item.name || '',
        content: item.isText || item.type === 'text' ? item.text : item.src,
        perspective: this.normalizePerspective(item.perspective ?? item.styles?.perspective),
        eraser: normalizeEraser(item.eraser),
        price: item.price,
        originalPrice: item.originalPrice,
        elementId: item.elementId || null,
        position: { x: item.x, y: item.y },
        size: { width: item.width, height: item.height },
        styles: {
          zIndex: item.zIndex,
          rotation: item.rotate || 0,
          flipX: item.flipX || false,
          flipY: item.flipY || false,
          opacity: item.opacity ?? 1,
        },
        filters: {
          exposure: item.exposure || 0,
          contrast: item.contrast || 0,
          saturation: item.saturation || 0,
          temperature: item.temperature || 0,
          hue: item.hue || 0,
        },
        fontName: item.fontName,
        fontCategory: item.fontCategory,
        isGoogleFont: item.isGoogleFont,
        fontUrl: item.fontUrl,
        fontId: item.fontId,
        color: item.color,
        textShadow: item.textShadow,
        fontSize: item.fontSize,
      }));
      this.syncZoneElements({ elements, background: this.zoneBackground });
      
      this.$store.commit('zones/SET_UNSAVED_CHANGES', true);
      
      if (updatedCount > 0) {
        this.$toast?.success?.(this.$t('editor.pricesUpdated', { count: updatedCount }));
      } else {
        this.$toast?.info?.(this.$t('Цены актуальны'));
      }
    },

    async refreshAllPricesFromDB() {
      try {
        const catalogIds = [
          ...new Set(
            this.droppedImages
              .filter(item => item && !item.isText && item.type !== 'text' && !item.isBackground && item.elementId && !String(item.elementId).startsWith('user_'))
              .map(item => Number(item.elementId))
              .filter(id => !isNaN(id) && id > 0)
          )
        ];

        let freshPrices = {};
        if (catalogIds.length > 0) {
          const response = await getElementsInfo(catalogIds, []);
          if (response?.elementsById) {
            freshPrices = response.elementsById;
          }
        }

        let updatedCount = 0;
        this.droppedImages = this.droppedImages.map(item => {
          if (!item || item.isText || item.type === 'text' || item.isBackground || !item.elementId) {
            return item;
          }
          const idStr = String(item.elementId);
          if (idStr.startsWith('user_')) return item;

          const key = String(item.elementId);
          const fav = this.favorites[key];
          if (fav?.customPrice !== null && fav?.customPrice !== undefined) {
            return item;
          }

          const freshEl = freshPrices[item.elementId];
          if (!freshEl) return item;

          const newPrice = Number(freshEl.price) || 0;
          const oldPrice = Number(item.price) || 0;
          if (newPrice === oldPrice) return item;

          updatedCount++;
          return {
            ...item,
            originalPrice: newPrice,
            price: newPrice,
            effectivePrice: newPrice
          };
        });

        const elements = this.droppedImages.map((item) => ({
          id: item.id,
          type: item.isText || item.type === 'text' ? 'text' : 'image',
          name: item.name || '',
          content: item.isText || item.type === 'text' ? item.text : item.src,
          perspective: this.normalizePerspective(item.perspective ?? item.styles?.perspective),
          eraser: normalizeEraser(item.eraser),
          price: item.price,
          originalPrice: item.originalPrice,
          elementId: item.elementId || null,
          position: { x: item.x, y: item.y },
          size: { width: item.width, height: item.height },
          styles: {
            zIndex: item.zIndex,
            rotation: item.rotate || 0,
            flipX: item.flipX || false,
            flipY: item.flipY || false,
            opacity: item.opacity ?? 1,
          },
          filters: {
            exposure: item.exposure || 0,
            contrast: item.contrast || 0,
            saturation: item.saturation || 0,
            temperature: item.temperature || 0,
            hue: item.hue || 0,
          },
          fontName: item.fontName,
          fontCategory: item.fontCategory,
          isGoogleFont: item.isGoogleFont,
          fontUrl: item.fontUrl,
          fontId: item.fontId,
          color: item.color,
          textShadow: item.textShadow,
          fontSize: item.fontSize,
        }));
        this.syncZoneElements({ elements, background: this.zoneBackground });
        this.$store.commit('zones/SET_UNSAVED_CHANGES', true);

        if (updatedCount > 0) {
          this.$toast?.success?.(this.$t('editor.pricesUpdatedShort', { count: updatedCount }));
        } else {
          this.$toast?.info?.(this.$t('Цены актуальны'));
        }
      } catch (e) {
        console.error('refreshAllPricesFromDB error:', e);
        this.$toast?.error?.(this.$t('Не удалось обновить цены'));
      }
    },
  },

  mounted() {
    // Initialize history system
    this.history = useHistory();
    this.updateHistoryState();

    // Initialize mobile detection
    this.isMobile = window.innerWidth <= 1024;
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 1024;
      this.updateAllToolbarPlacements();
      if (this.isMobile) {
        this.updateLayersPanelHeight();
      }
    });
    
    // Calculate mobile sheet height immediately
    if (this.isMobile) {
      this.$nextTick(() => {
        this.updateLayersPanelHeight();
      });
    }

    document.addEventListener('click', this.handleClickOutside);
    
    // Unified global handler to cleanup state when no interaction is in progress
    this.handleGlobalPointerUp = () => {
      if (this.activeResizeHandle && !this.isResizing && !this.activeInteraction) {
        this.activeResizeHandle = null;
      }
      // Сброс activeInteraction если resize не идёт
      if (this.activeInteraction?.type === 'resize' && !this.isResizing) {
        this.activeInteraction = null;
      }
    };
    document.addEventListener('mouseup', this.handleGlobalPointerUp);
    document.addEventListener('touchend', this.handleGlobalPointerUp);
    document.addEventListener('touchcancel', this.handleGlobalPointerUp);
    
    this.loadProjectFromQuery();
    this.setupAutoSave();
    
    this.fetchCategories();
    this.loadFavorites();
    this.loadAiCredits();
    this.loadUserFonts();
    this.initDragResize();

    if (this.activeImageId) {
      const image = this.droppedImages.find((img) => img.id === this.activeImageId);
      if (image) {
        this.$nextTick(() => {
          this.updateSliderValues(image.filters);
        });
      }
    }

    setTimeout(() => {
      this.droppedImages.forEach((img) => {
        try {
          if (img.type === 'text') {
            this.applyFiltersToDom(img.id);
            this.applyFontToInput(img.id);
          }
        } catch (error) {
          console.error('Error initializing font:', error);
        }
      });
    }, 1500);

    this.$nextTick(() => {
      if (this.$refs.contentRef) {
        this.calculateScale();
        
        this.resizeObserver = new ResizeObserver(() => {
          this.calculateScale();
        });
        this.resizeObserver.observe(this.$refs.contentRef);
      }
    });

    if (localStorage.getItem('guideShown') !== 'true') {
      this.showGuide = true;
      localStorage.setItem('guideShown', 'true');
    }
  },
  activated() {
    this.loadFavorites();
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    this.clearAutoSave();
    document.removeEventListener('click', this.handleClickOutside);
    if (this.handleGlobalPointerUp) {
      document.removeEventListener('mouseup', this.handleGlobalPointerUp);
      document.removeEventListener('touchend', this.handleGlobalPointerUp);
      document.removeEventListener('touchcancel', this.handleGlobalPointerUp);
    }
  },
  watch: {
    sortedCanvasItems: {
      deep: true,
      handler(newVal) {
        console.log('👁️ sortedCanvasItems watcher triggered, items:', newVal.map(i => ({ type: i.type, id: i.data.id, zIndex: i.zIndex })));
      },
    },
    '$route'(to, from) {
      if (to.path !== from.path) {
        this.loadFavorites();
      }
    },
    zonesList: {
      deep: true,
      handler(newZones) {
        if (newZones && newZones.length > 0) {
          this.fotozones = newZones.map(z => ({
            id: z.id,
            title: z.title,
            zoneId: z.zone_id,
          }));
        }
      },
    },
    droppedImages: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.type === 'text' && item.fontUrl) {
              this.applyFontToInput(item.id);
            }
          });
        }
        
        if (newVal && oldVal) {
          this.markDirtyAndSync();
        }
      },
    },

    items: {
      deep: true,
      handler() {
        this.initSliders();
      },
    },

    activeItemId(newId, oldId) {
      if (oldId !== undefined && newId !== oldId) this.exitEraserMode();
      this.showTransformSheet = false;
      if (newId !== null) {
        this.$nextTick(() => {
          this.updateToolbarPlacement('item', newId);
        });
      }
    },
    activeGroup(newGroupId, oldGroupId) {
      if (oldGroupId !== undefined && newGroupId !== oldGroupId) this.exitEraserMode();
      this.showTransformSheet = false;
      if (newGroupId) {
        this.$nextTick(() => {
          this.updateToolbarPlacement('group', newGroupId);
        });
      }
    },
    sidebarIsLocked(isLocked) {
      if (isLocked) this.exitEraserMode();
    },
    isSelectionMode(enabled) {
      if (enabled) this.exitEraserMode();
    },
    eraserEnabled(enabled) {
      if (!enabled) this.showEraserSheet = false;
    },
    showControls(isVisible) {
      if (isVisible) {
        this.$nextTick(() => {
          if (this.activeItemId !== null) {
            this.updateToolbarPlacement('item', this.activeItemId);
          }
          if (this.activeGroup) {
            this.updateToolbarPlacement('group', this.activeGroup);
          }
        });
      }
    },
    currentScale() {
      this.updateAllToolbarPlacements();
    },
    activeImageId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          const image = this.droppedImages.find((img) => img.id === newId);
          if (image) {
            this.$nextTick(() => {
              this.updateSliderValues(image.filters);
            });
          }
        }
      },
    },
    projectId(newId) {
      if (newId) {
        this.loadProject();
      }
    },
    '$route.query.zone': {
      handler(newZoneId) {
        const zoneId = newZoneId !== undefined ? parseInt(newZoneId, 10) : null;
        if (zoneId !== null && zoneId !== this.currentSlideId) {
          this.switchZone(zoneId);
        }
      },
      immediate: true,
    },
    currentSlideId(newZoneId) {
      this.loadZoneContent(newZoneId);
    },
    
  },
  created() {
    // Инициализация toast для Options API
    this.toast = useToast();
    
    const { startGroupDrag: groupDragFn } = useGroupDrag();
    this.startGroupDrag = (group, event, containerEl) => {
      groupDragFn(group, event, containerEl, this.currentScale);
    };
    this.$watch(
      () => this.fotozones,
      (newZones) => {
        newZones.forEach((zone) => {
          if (!this.zonesState[zone.id]) {
            this.zonesState[zone.id] = {
              background: null,
              elements: [],
              settings: {},
            };
          }
        });
      },
      { immediate: true, deep: true }
    );
  },
};
</script>

<style scoped>
.selection-lasso {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
}

.selection-lasso path {
  stroke: #007bff;
  stroke-width: 2;
  fill: rgba(0, 123, 255, 0.1); /* Легкая заливка области */
  stroke-dasharray: 5, 5;
}

/* Граница для группы выделенных элементов */
.group-selection-boundary {
  position: absolute;
  border: 2px dashed #007bff;
  background-color: rgba(0, 123, 255, 0.05);
  pointer-events: none;
  z-index: 999;
  border-radius: 8px;
}

.utils-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  padding: 0;
  margin: 0;
  border-radius: 100px;
  width: 50px;
  height: 50px;
  backdrop-filter: blur(6.666666507720947px);
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.1);
  background: #f6f2ef;
  border: none;
  color: #999999;
  cursor: pointer;
  font-size: 23px;
}

.utils-btn svg {
  width: 1em;
  height: 1em;
}

.utils-btn.is-active {
  background: #496782;
  color: #fff;
}

.background-btn img,
.layers-btn img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.layers-btn.is-active img {
  filter: brightness(0) invert(1);
}

/* Панель слоёв (десктоп) */
.layers-panel {
  position: absolute;
  left: 10px;
  bottom: 70px;
  width: 280px;
  max-height: 400px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  overflow: hidden;
}

.layers-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.layers-panel-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.layers-panel-close {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.layers-panel-close:hover {
  background: #e9ecef;
}

.layers-panel-list {
  max-height: 340px;
  overflow-y: auto;
  padding: 8px;
}

.layers-panel-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.layers-panel-item:hover {
  background: #f0f4f8;
}

.layers-panel-item.is-active {
  background: #e3f2fd;
}

.layer-icon {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.layer-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.layer-type-icon {
  width: 20px;
  height: 20px;
  opacity: 0.6;
}

.layer-placeholder {
  width: 100%;
  height: 100%;
  background: #ddd;
}

.layer-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}

.layer-price {
  font-size: 14px;
  font-weight: 500;
  color: #496782;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
}

.layers-empty {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

/* Мобильная панель слоёв (Bottom Sheet) */
.layers-bottom-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  animation: slideUpLayers 0.3s ease-out;
}

@keyframes slideUpLayers {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.layers-bottom-sheet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
}

.layers-bottom-sheet-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.layers-bottom-sheet-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.layers-bottom-sheet-zone-total {
  font-size: 14px;
  font-weight: 600;
  color: #496782;
}

.layers-bottom-sheet-project-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid #dee2e6;
  gap: 8px;
  white-space: nowrap;
}

.layers-bottom-sheet-project-total .project-total-label {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  flex-shrink: 0;
}

.layers-bottom-sheet-project-total .project-total-value {
  font-size: 15px;
  font-weight: 700;
  color: #26374e;
  min-width: 80px;
  text-align: right;
  flex-shrink: 0;
}

.layers-bottom-sheet-close {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
}

.layers-bottom-sheet-close:active {
  background: #e9ecef;
}

.layers-bottom-sheet-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
  padding-bottom: 30px;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}

.layers-bottom-sheet-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 6px;
}

.layers-bottom-sheet-item:active {
  background: #f0f4f8;
}

.layers-bottom-sheet-item.is-active {
  background: #e3f2fd;
}

.layers-bottom-sheet-item.is-dragging {
  opacity: 0.5;
  background: #e0e0e0;
}

.layers-bottom-sheet-item.drag-over {
  background: #d1e7ff;
  border: 2px dashed #667eea;
}

.layers-bottom-sheet-group {
  margin-bottom: 4px;
}

.layers-bottom-sheet-group.is-dragging {
  opacity: 0.5;
}

.layers-bottom-sheet-group.is-dragging .layers-bottom-sheet-group-header {
  background: #e0e0e0;
}

.layers-bottom-sheet-group.drag-over .layers-bottom-sheet-group-header {
  background: #d1e7ff;
  border: 2px dashed #667eea;
}

.layers-bottom-sheet-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #f0f4f8;
  border-radius: 8px;
}

.layers-bottom-sheet-group-header .group-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  cursor: pointer;
}

.layers-bottom-sheet-group-header .layer-drag-handle {
  cursor: grab;
  color: #aaa;
  padding: 4px;
  margin-left: -4px;
  touch-action: none;
}

.layers-bottom-sheet-group-header:active {
  background: #e0e4e8;
}

.layers-bottom-sheet-group.is-active .layers-bottom-sheet-group-header {
  background: #d1e7ff;
}

.layers-bottom-sheet-group .group-expand-icon {
  color: #666;
  transition: transform 0.2s;
  flex-shrink: 0;
}

.layers-bottom-sheet-group .group-expand-icon.rotated {
  transform: rotate(180deg);
}

.layers-bottom-sheet-group .group-icon {
  color: #667eea;
  flex-shrink: 0;
}

.layers-bottom-sheet-group .lock-icon-small {
  color: #999;
  margin-left: auto;
}

.layers-bottom-sheet-group-children {
  padding-left: 24px;
  margin-top: 4px;
}

.layers-bottom-sheet-item.nested {
  padding-left: 8px;
  border-left: 2px solid #e0e0e0;
  margin-bottom: 2px;
}

.layers-bottom-sheet-item.nested .layer-drag-handle {
  cursor: grab;
  color: #aaa;
  padding: 4px;
  touch-action: none;
}

/* Кнопка открытия калькулятора */
.calculator-open-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 16px;
  margin: 8px 16px;
  width: calc(100% - 32px);
  background: linear-gradient(135deg, #BBCAD8 0%, #496782 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.calculator-open-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(73, 103, 130, 0.4);
}

.calculator-open-btn:active {
  transform: translateY(0);
}

/* Панель калькулятора (Bottom Sheet) - без затемнения, как у слоёв */
.calculator-bottom-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  animation: slideUpLayers 0.3s ease-out;
  height: 70vh;
  max-height: 70vh;
}

/* Подсветка элемента на холсте из калькулятора */
.calculator-highlight {
  outline: 3px solid #667eea !important;
  outline-offset: 2px;
  box-shadow: 0 0 20px rgba(102, 126, 234, 0.6);
  animation: calculator-pulse 1s ease-in-out infinite;
}

@keyframes calculator-pulse {
  0%, 100% {
    box-shadow: 0 0 20px rgba(102, 126, 234, 0.6);
  }
  50% {
    box-shadow: 0 0 30px rgba(102, 126, 234, 0.9);
  }
}

.layer-drag-handle {
  color: #aaa;
  cursor: grab;
  padding: 12px 8px;
  margin: -8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  transition: color 0.2s;
  touch-action: none;
}

.layer-drag-handle:hover {
  color: #667eea;
}

.layers-bottom-sheet-item:active .layer-drag-handle {
  cursor: grabbing;
}

.selection-box {
  position: fixed;
  background: rgba(66, 133, 244, 0.1);
  border: 1px solid #bbcad8;
  border-radius: 5px;
  pointer-events: none;
  z-index: 9999;
  will-change: left, top, width, height;
  transition: none;
}

.group-boundary {
  position: absolute;
  border: 1px solid #bbcad8;
  border-radius: 5px;
  background: rgba(66, 133, 244, 0.1);
  pointer-events: none;
  z-index: 9998;
}

.group-container {
  position: absolute;
  pointer-events: auto;
  transform-origin: center;
  overflow: visible;
}

.group-rotatable-block {
  position: relative;
  width: 100%;
  height: 100%;
}

.group-container.active .group-rotatable-block {
  border: 1px solid #bbcad8;
  border-radius: 5px;
}

.group-container .group-rotatable-block .resize-handle {
  display: none;
}

.group-container.active .group-rotatable-block .resize-handle {
  display: block;
}

.grouped-item {
  position: absolute;
  pointer-events: none;
  box-sizing: border-box;
  outline: none !important;
  margin: 0;
  padding: 0;
  overflow: visible;
}

.group-button {
  position: absolute;
  background: white;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 99999999999999999;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
  touch-action: manipulation;
}

.group-button button {
  background: none;
  border: none;
  cursor: pointer;
  pointer-events: auto;
  touch-action: manipulation;
}

.app-container {
  display: flex;
  height: calc(96vh - 60px);
  width: 100%;
  overflow: hidden;
  padding: 0 20px;
  gap: 20px;
  touch-action: pan-x pan-y;
}

.main-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  margin: 0;
}

@media (min-width: 1025px) {
  .main-content-wrapper {
    padding-right: 210px;
  }
}

.content-section-wrap {
  display: flex;
  gap: 0;
  width: 100%;
  max-height: 80vh;
  margin: 0;
}

.canvas-and-sidebar {
  display: flex;
  width: 100%;
  max-height: 80vh;
}

.canvas-and-sidebar > .content-section {
  flex: 1;
  padding: 5px;
  width: min(100%, calc(80vh * 4 / 3));
  aspect-ratio: 4 / 3;
  max-height: 80vh;
  margin: 0;
  border-radius: 0 0 10px 10px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035), 0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  background-color: #faf9f7;
}

.content-section {
  position: relative;
  z-index: 1;
  user-select: none;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  touch-action: pinch-zoom;
}

.content-section-downloading {
  box-shadow: none;
  border: 0;
  border-radius: 0;
}

.selection-mode {
  cursor: crosshair;
  touch-action: none;
}

.slides-section {
  z-index: 1;
  position: relative;
}

.background-color,
.background-image-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -10000;
  pointer-events: none;
}

.empty-content-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  color: #666;
  max-width: 300px;
  line-height: 1.5;
  z-index: 0;
}

.utils-block {
  position: absolute;
  z-index: 10001;
  width: 100%;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  gap: 0 20px;
}

.utils-block img {
  cursor: pointer;
}

.utils-left-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.utils-right-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.utils-menu-container {
  position: relative;
}

.utils-menu-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #faf9f7;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.utils-menu-trigger:hover {
  background: #f0f4f8;
  border-color: #bbcad8;
}

.utils-menu-trigger span {
  display: block;
  width: 4px;
  height: 4px;
  background-color: #666;
  border-radius: 50%;
}

.utils-dropdown-menu {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px;
  min-width: 220px;
  z-index: 1000;
}

.utils-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  transition: all 0.2s ease;
}

.utils-menu-item:hover {
  background: #f5f7fa;
}

.utils-menu-item.is-active {
  background: #e8f0fc;
  color: #4a90e2;
}

.utils-menu-item img,
.utils-menu-item svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.utils-menu-item.download-item {
  color: #4a90e2;
}

.utils-menu-item.download-item:hover {
  background: #e8f4fc;
}

.utils-menu-item.delete-item {
  color: #e74c3c;
}

.utils-menu-item.delete-item:hover {
  background: #fce8e8;
}

.utils-menu-item.ai-item {
  color: #9b59b6;
}

.utils-menu-item.ai-item:hover {
  background: #f5eef8;
}

.utils-menu-item .credits-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
  color: white;
  font-size: 11px;
  font-weight: 600;
  border-radius: 10px;
  margin-left: auto;
}

.utils-menu-item.locked {
  color: #999;
  cursor: pointer;
}

.utils-menu-item.locked:hover {
  background-color: #f5f5f5;
}

.utils-menu-item .lock-icon {
  color: #999;
  margin-left: auto;
  flex-shrink: 0;
}

.utils-menu-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 6px 0;
}

.utils-dropdown-menu-mobile {
  bottom: auto;
  top: calc(100% + 8px);
}

.download-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.download-icon-btn:hover {
  background: linear-gradient(135deg, #357abd 0%, #2868a8 100%);
  box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);
  transform: translateY(-2px);
}

.download-icon-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);
}

.download-icon-btn img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.dropped-image-container {
  position: absolute;
  box-sizing: border-box;
  outline: none !important;
  margin: 0;
  padding: 0;
  overflow: visible;
}

.rotatable-block {
  position: relative;
  width: 100%;
  height: 100%;
  border: none !important;
  outline: none !important;
  background: transparent;
}

.dropped-image-container.active {
  cursor: move;
}

.dropped-image-container.active .rotatable-block {
  border: 1px solid #bbcad8;
  border-radius: 8px;
}

.dropped-image-container.is-background-container.active {
  z-index: -1000 !important;
}

.resizable-image {
  display: block;
  width: 100%;
  height: 100%;
  user-select: none;
  -webkit-user-drag: none;
  transition: 0.5s;
  border: none !important;
  border-radius: 0 !important;
}

.resizable-image.with-border {
  border: 1px solid #bbcad8;
  border-radius: 5px;
}

.item-controls {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.item-controls > * {
  pointer-events: auto;
}

.group-controls .images-buttons {
  display: none !important;
}

.images-buttons {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  bottom: calc(100% + 60px);
  left: 50%;
  border-radius: 5px;
  transform: translateX(-50%);
  width: auto;
  min-width: 204px;
  height: 34px;
  padding: 0 10px;
  cursor: pointer;
  background: #fff;
  z-index: calc(var(--image-zindex, 1) + 1);
  box-shadow: 0 2px 4px rgba(128, 117, 116, 0.05), 0 4px 8px rgba(128, 117, 116, 0.08), 0 8px 12px rgba(128, 117, 116, 0.1);
}

.images-buttons.toolbar-below {
  bottom: auto;
  top: calc(100% + 60px);
}

.images-buttons .rotate-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.images-buttons .copy-group-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s ease;
  color: #26374e;
}

.images-buttons .copy-group-icon:hover {
  transform: scale(1.1);
}

.images-buttons .ungroup-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s ease;
  color: #26374e;
}

.images-buttons .delete-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.images-buttons .rotate-icon:hover,
.images-buttons .ungroup-icon:hover,
.images-buttons .delete-icon:hover {
  transform: scale(1.1);
}

.images-buttons .delete-icon {
  border-radius: 50%;
}

.dropped-image-container .images-buttons {
  display: none;
}

.dropped-image-container .rotatable-block .resize-handle {
  display: none;
}

.dropped-image-container.active.show-controls .images-buttons {
  display: flex;
}

.dropped-image-container.active.show-controls .rotatable-block .resize-handle {
  display: block;
}

.resize-handle {
  position: absolute;
  background-color: transparent;
  border: 2px solid #5a8bbf;
  opacity: 1 !important;
  transition: background-color 0.15s ease;
}

/* Активный handle - заполненный */
.resize-handle.resize-handle-active {
  background-color: #5a8bbf;
}

.resize-handle-left,
.resize-handle-right {
  width: 6px;
  height: 30px;
  top: 50%;
  transform: translateY(-50%);
  cursor: ew-resize;
  border-radius: 3px;
}

.resize-handle-left {
  left: -3px;
}

.resize-handle-right {
  right: -3px;
}

.resize-handle-top,
.resize-handle-bottom {
  width: 30px;
  height: 6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
  z-index: 10;
  border-radius: 3px;
}

.resize-handle-top {
  top: -3px;
}

.resize-handle-bottom {
  bottom: -3px;
}

/* Mobile: Larger touch zones for edge handles */
@media (max-width: 768px) {
  .resize-handle-left,
  .resize-handle-right {
    width: 10px;
    height: 40px;
  }
  
  .resize-handle-left {
    left: -5px;
  }
  
  .resize-handle-right {
    right: -5px;
  }
  
  .resize-handle-top,
  .resize-handle-bottom {
    width: 40px;
    height: 10px;
  }
  
  .resize-handle-top {
    top: -5px;
  }
  
  .resize-handle-bottom {
    bottom: -5px;
  }
  
  .resize-handle-top-left,
  .resize-handle-top-right,
  .resize-handle-bottom-left,
  .resize-handle-bottom-right {
    width: 18px;
    height: 18px;
  }
}

.resize-handle-top-left,
.resize-handle-top-right,
.resize-handle-bottom-left,
.resize-handle-bottom-right {
  width: 12px;
  height: 12px;
  background-color: transparent;
  border: 2px solid #5a8bbf;
  border-radius: 2px;
  z-index: 0;
}

/* Активные угловые handles */
.resize-handle-top-left.resize-handle-active,
.resize-handle-top-right.resize-handle-active,
.resize-handle-bottom-left.resize-handle-active,
.resize-handle-bottom-right.resize-handle-active {
  background-color: #5a8bbf;
}

.resize-handle-top-left {
  top: -6px;
  left: -6px;
  cursor: nwse-resize;
}

.resize-handle-top-right {
  top: -6px;
  right: -6px;
  cursor: nesw-resize;
}

.resize-handle-bottom-left {
  bottom: -6px;
  left: -6px;
  cursor: nesw-resize;
}

.resize-handle-bottom-right {
  bottom: -6px;
  right: -6px;
  cursor: nwse-resize;
}

.index-block-input {
  position: absolute;
  background: #fff;
  box-shadow: 0 2px 4px rgba(128, 117, 116, 0.05), 0 4px 8px rgba(128, 117, 116, 0.08), 0 8px 12px rgba(128, 117, 116, 0.1);
  border-radius: 5px;
  display: none;
  padding: 10px;
  min-width: 220px;
  z-index: 99999;
}

.indexIcon.is-active .index-block-input {
  display: block;
}

@media (max-width: 1023px) {
  .indexIcon:focus-within .index-block-input {
    display: block;
  }

  .indexIcon {
    outline: none;
  }

  .indexIcon img {
    cursor: pointer;
  }
}

.indexIcon {
  position: relative;
}

.rotateIcon {
  position: relative;
  
  img {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }
  
  &.is-active img {
    opacity: 0.7;
  }
}

.sheet-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 10000;
}
.transform-sheet-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(20, 35, 50, 0.22);
  z-index: 10040;
  display: flex;
  align-items: flex-end;
}
.transform-sheet {
  width: 100%;
  padding: 18px 20px calc(20px + env(safe-area-inset-bottom));
  border-radius: 20px 20px 0 0;
  background: #fff;
  box-shadow: 0 -4px 24px rgba(20, 35, 50, 0.15);
}
.eraser-sheet-backdrop {
  background: transparent;
  pointer-events: none;
}
.eraser-sheet-backdrop .transform-sheet {
  pointer-events: auto;
}
.transform-sheet header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  color: #26374e;
}
.transform-sheet header button {
  width: 36px;
  height: 36px;
  font-size: 24px;
  border: 0;
  border-radius: 50%;
  background: #f4f6f8;
  color: #506378;
  cursor: pointer;
}

.index-inputs-block {
  display: grid;
  grid-template-columns: 110px 150px 40px;
  align-items: center;
  gap: 10px;
}

.index-text {
  color: #26374e;
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  white-space: nowrap;
  text-align: left;
}

.index-number {
  color: #26374e;
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  white-space: nowrap;
  text-align: right;
}

.index-input {
  width: 150px;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  cursor: pointer;
  background: linear-gradient(to right, #496782 0%, #496782 var(--fill-position, 100%), #e0e4e8 var(--fill-position, 100%), #e0e4e8 100%);
  border-radius: 10px;
  outline: none;
}

.index-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #496782;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.layers-control {
  position: relative;
  display: inline-block;
}

.layers-control img {
  cursor: pointer;
  transition: transform 0.2s;
}

.layers-control:hover img {
  transform: scale(1.1);
}

.layers-menu {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  min-width: 200px;
  z-index: 1000;
  display: none;
}

.layers-control.is-active .layers-menu {
  display: block;
}

@media (max-width: 1023px) {
  .layers-control:focus-within .layers-menu {
    display: block;
  }

  .layers-control {
    outline: none;
  }

  .layers-control img {
    cursor: pointer;
  }
}

.layers-menu div {
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
}

.layers-menu div:hover {
  background-color: #f5f5f5;
}

.layers-menu img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.settings-inputs {
  position: absolute;
  background: #fff;
  box-shadow: 0 2px 4px rgba(128, 117, 116, 0.05), 0 4px 8px rgba(128, 117, 116, 0.08), 0 8px 12px rgba(128, 117, 116, 0.1);
  border-radius: 5px;
  display: none;
  gap: 10px;
  flex-direction: column;
  align-items: stretch;
  padding: 10px;
  min-width: 220px;
}

.settings-block.is-active .settings-inputs {
  display: flex;
}

@media (max-width: 1023px) {
  .settings-block:focus-within .settings-inputs {
    display: flex;
  }

  .settings-block {
    outline: none;
  }

  .settings-icon {
    cursor: pointer;
  }
}

.settings-inputs-block {
  display: grid;
  grid-template-columns: 110px 150px 40px;
  align-items: center;
  gap: 10px;
}

.settings-text {
  color: #26374e;
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  white-space: nowrap;
  text-align: left;
}

.settings-number {
  color: #26374e;
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  white-space: nowrap;
  text-align: right;
}

.settings-input {
  width: 150px;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  cursor: pointer;
  background: linear-gradient(to right, #e0e4e8 0%, #e0e4e8 var(--left-fill, 50%), #496782 var(--left-fill, 50%), #496782 var(--right-fill, 50%), #e0e4e8 var(--right-fill, 50%), #e0e4e8 100%);
  border-radius: 10px;
  outline: none;
}

.settings-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #496782;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

@media (max-width: 1023px) {
  .app-container {
    padding: 10px 5px;
    gap: 0;
    flex-direction: column;
    height: calc(100vh - 60px);

    position: relative;
  }

  .main-content-wrapper {
    max-width: 100%;
    width: 100%;
    height: auto;
    /* Оставляем место для сайдбара */
    position: relative;
    padding-bottom: 75px;
    /* Защитный отступ */
  }

  .content-section-wrap {
    aspect-ratio: 4 / 3;
    max-height: none;
    width: 100%;
    border-radius: 12px;
  }

  .content-section {
    height: 100%;
    width: 100%;
    border-radius: 12px;
    position: relative;
    z-index: 1;
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* Изменено с flex-end */
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 0;
    /* Убрали margin */
  }

  /* When Konva editor is active: remove padding/flex so stage fills background exactly */
  .content-section.konva-mode {
    padding: 0 !important;
    display: block !important;
    overflow: hidden !important;
  }

  .app-container > :first-child {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 5000;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }

  .app-container.modal-open > :first-child {
    z-index: 1;
  }

  .utils-block {
    position: absolute;
    left: 0;
    right: 0;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 10001;
    flex-direction: row;
  }

  .utils-block-mobile {
    margin-top: 15px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    position: relative;
    z-index: 1001;
  }

  .download-icon-btn img {
    filter: brightness(0) invert(1);
  }

  /* Скрываем старую панель инструментов над элементом на мобильных */
  .images-buttons {
    display: none !important;
  }

  /* Панель инструментов элемента (мобильная и десктопная) */
  .mobile-element-toolbar {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 10px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(128, 117, 116, 0.05), 0 4px 8px rgba(128, 117, 116, 0.08), 0 8px 12px rgba(128, 117, 116, 0.1);
    padding: 10px;
    position: relative;
  }

  .mobile-toolbar-close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    background: #f5f5f5;
    border: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #666;
    z-index: 10;
    transition: all 0.2s ease;
  }

  .mobile-toolbar-close:active {
    background: #e0e0e0;
    transform: scale(0.95);
  }

  .mobile-toolbar-close svg {
    width: 16px;
    height: 16px;
  }

  .mobile-element-toolbar .toolbar-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    width: 100%;
  }

  .mobile-element-toolbar img {
    width: 32px;
    height: 32px;
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  .mobile-element-toolbar img:hover,
  .mobile-element-toolbar img:active {
    transform: scale(1.1);
  }

  .mobile-element-toolbar img.active {
    background: #3b82f6;
    border-radius: 6px;
    padding: 4px;
    box-sizing: content-box;
  }

  .mobile-element-toolbar .rotate-icon,
  .mobile-element-toolbar .ungroup-icon,
  .mobile-element-toolbar .delete-icon,
  .mobile-element-toolbar .shadow-icon {
    width: 32px;
    height: 32px;
  }

  .mobile-element-toolbar .copy-group-icon,
  .mobile-element-toolbar .ungroup-icon {
    color: #26374e;
  }

  .mobile-element-toolbar .copy-group-icon {
    width: 32px;
    height: 32px;
  }

  .mobile-toolbar-close {
    display: none;
  }

  .mobile-toolbar-close-inline {
    width: 32px;
    height: 32px;
    background: #f5f5f5;
    border: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #e74c3c;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .mobile-toolbar-close-inline:active {
    background: #fee2e2;
    transform: scale(0.95);
  }

  .mobile-toolbar-close-inline svg {
    width: 18px;
    height: 18px;
  }

  .mobile-element-toolbar .shadow-icon.active {
    background-color: rgba(38, 55, 78, 0.15);
    border-radius: 6px;
  }

  .mobile-element-toolbar .color-block {
    position: relative;
    display: inline-block;
  }

  .mobile-element-toolbar .color-preview-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 2px solid #ccc;
    cursor: pointer;
  }

  .mobile-element-toolbar .color-picker-sheet {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    transform: translateY(100%);
    transition: transform 0.3s ease-out;
    z-index: 10000;
    background: #fff;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0 0;
    padding-bottom: 20px;
  }

  .mobile-element-toolbar .color-block.is-active .color-picker-sheet {
    transform: translateY(0);
  }

  /* Font picker styles */
  .mobile-element-toolbar .font-block {
    position: relative;
    display: inline-block;
  }

  .mobile-element-toolbar .font-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 2px solid #ccc;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
  }

  .mobile-element-toolbar .font-block.is-active .font-button {
    border-color: #6366F1;
    background: #EEF2FF;
  }

  .mobile-element-toolbar .font-picker-sheet {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-height: 50vh;
    transform: translateY(100%);
    transition: transform 0.3s ease-out;
    z-index: 10000;
    background: #fff;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0 0;
    display: flex;
    flex-direction: column;
  }

  .mobile-element-toolbar .font-block.is-active .font-picker-sheet {
    transform: translateY(0);
  }

  .mobile-element-toolbar .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    flex-shrink: 0;
  }

  .mobile-element-toolbar .font-picker-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .mobile-element-toolbar .font-picker-close {
    width: 32px;
    height: 32px;
    border: none;
    background: #f5f5f5;
    border-radius: 50%;
    font-size: 20px;
    color: #666;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-element-toolbar .font-picker-list {
    overflow-y: auto;
    padding: 10px 0;
    flex: 1;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-element-toolbar .font-picker-item {
    padding: 14px 20px;
    font-size: 18px;
    color: #333;
    cursor: pointer;
    transition: background 0.2s;
  }

  .mobile-element-toolbar .font-picker-item:active {
    background: #f5f5f5;
  }

  .mobile-element-toolbar .font-picker-item.active {
    background: #EEF2FF;
    color: #6366F1;
    font-weight: 500;
  }

  .mobile-element-toolbar .indexIcon,
  .mobile-element-toolbar .layers-control,
  .mobile-element-toolbar .settings-block {
    position: relative;
    display: inline-block;
  }

  .mobile-element-toolbar .indexIcon img,
  .mobile-element-toolbar .layers-control img,
  .mobile-element-toolbar .settings-block img {
    width: 32px;
    height: 32px;
  }

  .mobile-element-toolbar .index-block-input,
  .mobile-element-toolbar .layers-menu {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
    z-index: 1000;
    display: none;
  }

  .mobile-element-toolbar .settings-inputs {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    transform: translateY(100%);
    transition: transform 0.3s ease-out;
    z-index: 10000;
    display: flex;
    background: #fff;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0 0;
    max-height: 50vh;
    overflow-y: auto;
  }

  .mobile-element-toolbar .indexIcon.is-active .index-block-input {
    display: block !important;
  }

  .mobile-element-toolbar .layers-control.is-active .layers-menu {
    display: block !important;
  }

  .mobile-element-toolbar .settings-block.is-active .settings-inputs {
    display: flex !important;
    transform: translateY(0) !important;
  }

  .rotate-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }

  .settings-backdrop-transparent,
  .rotate-backdrop-transparent {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 9998;
  }

  .layers-menu {
    min-width: 160px;
  }

  .settings-inputs {
    min-width: 100%;
    padding: 8px;
    left: 50%;
    transform: translateX(-50%);
    top: 40px;
  }

  .mobile-element-toolbar .settings-inputs {
    padding: 20px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    /* Переопределяем стили для Bottom Sheet */
    left: 0;
    top: auto;
    min-width: auto;
    gap: 30px;
  }

  .settings-inputs-block {
    grid-template-columns: 1fr 2fr 1fr;
  }

  .mobile-element-toolbar .settings-input {
    width: 100%;
  }

  .settings-text,
  .settings-number {
    font-size: 12px;
  }

  .empty-content-message {
    font-size: 14px;
  }

  .show-header {
    display: none;
  }
}

/* Tablet layout (768–1024px) — same column flow as mobile */
@media (min-width: 768px) and (max-width: 1024px) {
  .app-container {
    padding: 10px 8px;
    gap: 0;
    flex-direction: column;
    height: calc(100vh - 60px);
    position: relative;
  }

  .main-content-wrapper {
    max-width: 100%;
    width: 100%;
    height: auto;
    position: relative;
    padding-bottom: 75px;
  }

  .content-section-wrap {
    aspect-ratio: 4 / 3;
    max-height: none;
    width: 100%;
    border-radius: 12px;
  }

  .canvas-and-sidebar {
    max-height: none;
    height: auto;
  }

  /* On tablet: full-width canvas, no padding so Konva stage matches background exactly.
     height: auto !important overrides the mobile rule's height: 100% so that
     aspect-ratio: 4/3 can determine the height from width alone. */
  .canvas-and-sidebar > .content-section {
    width: 100% !important;
    height: auto !important;
    max-height: none !important;
    padding: 0 !important;
    overflow: visible !important;
    aspect-ratio: 4 / 3;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
  }

  .content-section {
    width: 100%;
    height: auto;
    border-radius: 12px;
    position: relative;
    z-index: 1;
    pointer-events: auto;
    overflow: visible;
    background: #fff;
    margin-bottom: 0;
  }

  .app-container > :first-child {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 5000;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }

  .app-container.modal-open > :first-child {
    z-index: 1;
  }
}

@media (max-width: 767px) {
  .app-container {
    padding: 10px 5px;
    gap: 0;
    flex-direction: column;
    height: calc(100vh - 60px);

    position: relative;
  }

  .main-content-wrapper {
    max-width: 100%;
    width: 100%;
    height: auto;
    /* Оставляем место для сайдбара */
    position: relative;
    padding-bottom: 75px;
    /* Защитный отступ */
  }

  .content-section-wrap {
    aspect-ratio: 4 / 3;
    max-height: none;
    width: 100%;
    border-radius: 12px;
  }

  .content-section {
    height: 100%;
    width: 100%;
    border-radius: 12px;
    position: relative;
    z-index: 1;
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* Изменено с flex-end */
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 0;
    /* Убрали margin */
  }

  /* When Konva editor is active: remove padding/flex so stage fills background exactly */
  .content-section.konva-mode {
    padding: 0 !important;
    display: block !important;
    overflow: hidden !important;
  }

  .app-container > :first-child {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 5000;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }

  .app-container.modal-open > :first-child {
    z-index: 1;
  }

  .utils-block {
    position: absolute;
    left: 0;
    right: 0;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 10001;
    flex-direction: row;
  }

  .utils-block-mobile {
    margin-top: 15px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    position: relative;
    z-index: 1001;
  }

  .download-icon-btn img {
    filter: brightness(0) invert(1);
  }

  /* Скрываем старую панель инструментов над элементом на мобильных */
  .images-buttons {
    display: none !important;
  }

  /* Панель инструментов элемента (мобильная и десктопная) */
  .mobile-element-toolbar {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 10px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(128, 117, 116, 0.05), 0 4px 8px rgba(128, 117, 116, 0.08), 0 8px 12px rgba(128, 117, 116, 0.1);
    padding: 10px;
    position: relative;
  }

  .mobile-toolbar-close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    background: #f5f5f5;
    border: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #666;
    z-index: 10;
    transition: all 0.2s ease;
  }

  .mobile-toolbar-close:active {
    background: #e0e0e0;
    transform: scale(0.95);
  }

  .mobile-toolbar-close svg {
    width: 16px;
    height: 16px;
  }

  .mobile-element-toolbar .toolbar-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    width: 100%;
  }

  .mobile-element-toolbar img {
    width: 32px;
    height: 32px;
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  .mobile-element-toolbar img:hover,
  .mobile-element-toolbar img:active {
    transform: scale(1.1);
  }

  .mobile-element-toolbar img.active {
    background: #3b82f6;
    border-radius: 6px;
    padding: 4px;
    box-sizing: content-box;
  }

  .mobile-element-toolbar .rotate-icon,
  .mobile-element-toolbar .ungroup-icon,
  .mobile-element-toolbar .delete-icon,
  .mobile-element-toolbar .shadow-icon {
    width: 32px;
    height: 32px;
  }

  .mobile-element-toolbar .copy-group-icon,
  .mobile-element-toolbar .ungroup-icon {
    color: #26374e;
  }

  .mobile-element-toolbar .copy-group-icon {
    width: 32px;
    height: 32px;
  }

  .mobile-toolbar-close {
    display: none;
  }

  .mobile-toolbar-close-inline {
    width: 32px;
    height: 32px;
    background: #f5f5f5;
    border: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #e74c3c;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .mobile-toolbar-close-inline:active {
    background: #fee2e2;
    transform: scale(0.95);
  }

  .mobile-toolbar-close-inline svg {
    width: 18px;
    height: 18px;
  }

  .mobile-element-toolbar .shadow-icon.active {
    background-color: rgba(38, 55, 78, 0.15);
    border-radius: 6px;
  }

  .mobile-element-toolbar .color-block {
    position: relative;
    display: inline-block;
  }

  .mobile-element-toolbar .color-preview-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 2px solid #ccc;
    cursor: pointer;
  }

  .mobile-element-toolbar .color-picker-sheet {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    transform: translateY(100%);
    transition: transform 0.3s ease-out;
    z-index: 10000;
    background: #fff;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0 0;
    padding-bottom: 20px;
  }

  .mobile-element-toolbar .color-block.is-active .color-picker-sheet {
    transform: translateY(0);
  }

  /* Font picker styles */
  .mobile-element-toolbar .font-block {
    position: relative;
    display: inline-block;
  }

  .mobile-element-toolbar .font-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 2px solid #ccc;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
  }

  .mobile-element-toolbar .font-block.is-active .font-button {
    border-color: #6366F1;
    background: #EEF2FF;
  }

  .mobile-element-toolbar .font-picker-sheet {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-height: 50vh;
    transform: translateY(100%);
    transition: transform 0.3s ease-out;
    z-index: 10000;
    background: #fff;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0 0;
    display: flex;
    flex-direction: column;
  }

  .mobile-element-toolbar .font-block.is-active .font-picker-sheet {
    transform: translateY(0);
  }

  .mobile-element-toolbar .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    flex-shrink: 0;
  }

  .mobile-element-toolbar .font-picker-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .mobile-element-toolbar .font-picker-close {
    width: 32px;
    height: 32px;
    border: none;
    background: #f5f5f5;
    border-radius: 50%;
    font-size: 20px;
    color: #666;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-element-toolbar .font-picker-list {
    overflow-y: auto;
    padding: 10px 0;
    flex: 1;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-element-toolbar .font-picker-item {
    padding: 14px 20px;
    font-size: 18px;
    color: #333;
    cursor: pointer;
    transition: background 0.2s;
  }

  .mobile-element-toolbar .font-picker-item:active {
    background: #f5f5f5;
  }

  .mobile-element-toolbar .font-picker-item.active {
    background: #EEF2FF;
    color: #6366F1;
    font-weight: 500;
  }

  .mobile-element-toolbar .indexIcon,
  .mobile-element-toolbar .layers-control,
  .mobile-element-toolbar .settings-block {
    position: relative;
    display: inline-block;
  }

  .mobile-element-toolbar .indexIcon img,
  .mobile-element-toolbar .layers-control img,
  .mobile-element-toolbar .settings-block img {
    width: 32px;
    height: 32px;
  }

  .mobile-element-toolbar .index-block-input,
  .mobile-element-toolbar .layers-menu {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
    z-index: 1000;
    display: none;
  }

  .mobile-element-toolbar .settings-inputs {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    transform: translateY(100%);
    transition: transform 0.3s ease-out;
    z-index: 10000;
    display: flex;
    background: #fff;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0 0;
    max-height: 50vh;
    overflow-y: auto;
  }

  .mobile-element-toolbar .indexIcon.is-active .index-block-input {
    display: block !important;
  }

  .mobile-element-toolbar .layers-control.is-active .layers-menu {
    display: block !important;
  }

  .mobile-element-toolbar .settings-block.is-active .settings-inputs {
    display: flex !important;
    transform: translateY(0) !important;
  }

  .rotate-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }

  .settings-backdrop-transparent,
  .rotate-backdrop-transparent {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 9998;
  }

  .layers-menu {
    min-width: 160px;
  }

  .settings-inputs {
    min-width: 100%;
    padding: 8px;
    left: 50%;
    transform: translateX(-50%);
    top: 40px;
  }

  .mobile-element-toolbar .settings-inputs {
    padding: 20px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    /* Переопределяем стили для Bottom Sheet */
    left: 0;
    top: auto;
    min-width: auto;
    gap: 30px;
  }

  .settings-inputs-block {
    grid-template-columns: 1fr 2fr 1fr;
  }

  .mobile-element-toolbar .settings-input {
    width: 100%;
  }

  .settings-text,
  .settings-number {
    font-size: 12px;
  }

  .empty-content-message {
    font-size: 14px;
  }

  .show-header {
    display: none;
  }
}

/* AI Modal Styles */
.ai-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.ai-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.ai-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.ai-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
}

.ai-modal-header h3::before {
  content: '✨';
}

.ai-modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.ai-modal-close:hover {
  background: #e0e0e0;
}

.ai-modal-body {
  padding: 24px;
}

.ai-credits-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f5eef8 0%, #ede7f6 100%);
  border-radius: 10px;
  margin-bottom: 16px;
}

.ai-credits-info span:first-child {
  color: #666;
  font-size: 14px;
}

.ai-credits-info .credits-value {
  font-weight: 700;
  font-size: 18px;
  color: #9b59b6;
}

.ai-description {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 16px;
}

.ai-feature-description {
  text-align: center;
  padding: 20px 0;
}

.ai-feature-description .ai-icon {
  margin-bottom: 16px;
}

.ai-feature-description .ai-description {
  text-align: left;
  margin-bottom: 16px;
}

.ai-features-list {
  text-align: left;
  margin: 0 0 0 20px;
  padding: 0;
  list-style: none;
}

.ai-features-list li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #555;
}

.ai-features-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #667eea;
  font-weight: bold;
}

.ai-processing-note {
  margin-top: 16px;
  padding: 12px 16px;
  background: #f0f4ff;
  border-radius: 8px;
  font-size: 13px;
  color: #5a67d8;
  text-align: center;
}

.ai-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #eee;
}

.ai-btn {
  flex: 1;
  padding: 14px 20px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.ai-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ai-btn-cancel {
  background: #f0f0f0;
  color: #666;
}

.ai-btn-cancel:hover:not(:disabled) {
  background: #e5e5e5;
}

.ai-btn-process {
  background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
  color: white;
}

.ai-btn-process:hover:not(:disabled) {
  background: linear-gradient(135deg, #8e44ad 0%, #7d3c98 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(155, 89, 182, 0.3);
}

.ai-progress-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px;
  width: 320px;
  max-width: 90%;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.25);
  text-align: center;
  z-index: 100001;
}

.ai-progress-icon {
  margin-bottom: 20px;
}

.ai-spinner {
  animation: ai-spin 1.5s linear infinite;
}

@keyframes ai-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.ai-progress-status {
  font-size: 16px;
  color: #333;
  margin: 0 0 20px;
  font-weight: 500;
}

.ai-progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.ai-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #9b59b6, #8e44ad);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.ai-progress-percent {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.ai-success-modal {
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px;
  width: 340px;
  max-width: 90%;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.25);
  text-align: center;
  position: relative;
}

.ai-success-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.ai-success-close:hover {
  transform: rotate(90deg);
}

.ai-success-icon {
  margin-bottom: 16px;
}

.ai-success-message {
  font-size: 22px;
  color: #2E2E2E;
  font-weight: 600;
  margin-bottom: 8px;
  font-family: "Montserrat", sans-serif;
}

.ai-success-description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 24px;
}

.ai-success-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-success-btn {
  padding: 14px 20px;
  font-size: 14px;
  border-radius: 10px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ai-success-btn-primary {
  background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
  color: white;
}

.ai-success-btn-primary:hover {
  background: linear-gradient(135deg, #8e44ad 0%, #7d3c98 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(155, 89, 182, 0.3);
}

.ai-success-btn-secondary {
  background: #f0f0f0;
  color: #555;
}

.ai-success-btn-secondary:hover {
  background: #e5e5e5;
}

@media (max-width: 768px) {
  .ai-success-modal {
    width: 100%;
    max-width: 100%;
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px 20px;
    padding-bottom: 32px;
    z-index: 100001;
  }

  .ai-success-icon svg {
    width: 44px !important;
    height: 44px !important;
  }

  .ai-success-message {
    font-size: 18px;
  }

  .ai-success-description {
    font-size: 13px;
    margin-bottom: 20px;
  }

  .ai-success-btn {
    padding: 12px 16px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .ai-modal-overlay {
    align-items: flex-end;
    padding: 0;
    z-index: 100000;
  }

  .ai-modal {
    max-width: 100%;
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 85vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .ai-modal-header {
    padding: 12px 16px 8px;
    flex-shrink: 0;
  }

  .ai-modal-title {
    font-size: 16px;
  }

  .ai-modal-body {
    padding: 8px 16px;
    flex: 1;
    overflow-y: auto;
  }

  .ai-credits-badge {
    padding: 6px 12px;
    font-size: 12px;
    margin-bottom: 8px;
  }

  .ai-feature-description {
    text-align: left;
  }

  .ai-icon {
    display: none !important;
  }

  .ai-description {
    font-size: 12px;
    margin-bottom: 8px;
    line-height: 1.4;
  }

  .ai-features-list {
    font-size: 11px;
    margin-bottom: 8px;
  }

  .ai-features-list li {
    margin-bottom: 2px;
  }

  .ai-processing-note {
    margin-top: 8px;
    padding: 8px 10px;
    font-size: 11px;
  }

  .ai-modal-footer {
    flex-shrink: 0;
    padding: 12px 16px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 16px));
    background: #fff;
    border-top: 1px solid #eee;
  }

  .ai-btn {
    padding: 10px 14px;
    font-size: 13px;
  }

  .app-container.modal-open .sidebar-menu {
    display: none !important;
  }
}

/* Credits Purchase Modal Styles */
.credits-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.credits-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 450px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.credits-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.credits-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
}

.credits-modal-header h3::before {
  content: '⭐';
}

.credits-modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.credits-modal-close:hover {
  background: #e0e0e0;
}

.credits-modal-body {
  padding: 24px;
}

.credits-current {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-radius: 10px;
  margin-bottom: 16px;
}

.credits-current span:first-child {
  color: #92400e;
  font-size: 14px;
}

.credits-current-value {
  font-weight: 700;
  font-size: 16px;
  color: #b45309;
}

.credits-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 16px;
}

.credits-loading {
  text-align: center;
  padding: 20px;
  color: #666;
}

.credits-packages {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.credits-package {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.credits-package:hover {
  border-color: #f59e0b;
  background: #fffbeb;
}

.credits-package.selected {
  border-color: #f59e0b;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
}

.package-credits {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #333;
}

.package-price {
  font-weight: 700;
  font-size: 18px;
  color: #b45309;
}

.credits-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #eee;
}

.credits-btn {
  flex: 1;
  padding: 14px 20px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.credits-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.credits-btn-cancel {
  background: #f0f0f0;
  color: #666;
}

.credits-btn-cancel:hover:not(:disabled) {
  background: #e5e5e5;
}

.credits-btn-buy {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.credits-btn-buy:hover:not(:disabled) {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.utils-menu-item .credits-badge.clickable {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: linear-gradient(135deg, #fde68a 0%, #fcd34d 100%);
  color: #92400e;
  font-size: 11px;
  font-weight: 600;
  border-radius: 12px;
  margin-left: auto;
  cursor: pointer;
  transition: all 0.2s;
}

.utils-menu-item .credits-badge.clickable:hover {
  background: linear-gradient(135deg, #fcd34d 0%, #fbbf24 100%);
  transform: scale(1.05);
}

.utils-menu-item .credits-badge.clickable svg {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .credits-modal-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .credits-modal {
    max-width: 100%;
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 85vh;
  }

  .credits-modal-footer {
    padding-bottom: calc(20px + env(safe-area-inset-bottom, 16px));
  }
}

/* Zone Loading Skeleton */
.zone-loading-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: inherit;
}

.skeleton-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 80%;
  max-width: 400px;
}

.skeleton-element {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 12px;
}

.skeleton-large {
  width: 100%;
  height: 120px;
}

.skeleton-medium {
  width: 75%;
  height: 80px;
}

.skeleton-small {
  width: 50%;
  height: 60px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@media (max-width: 768px) {
  .skeleton-content {
    width: 90%;
  }
  
  .skeleton-large {
    height: 80px;
  }
  
  .skeleton-medium {
    height: 60px;
  }
  
  .skeleton-small {
    height: 40px;
  }
}

@media (min-width: 1025px) {
  .dropped-image-container.active.show-controls .images-buttons {
    display: none !important;
  }
}

/* Кнопка переключения режима редактирования на мобильном */
.mode-toggle-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f0f0f0;
  border: 2px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.mode-toggle-btn:active {
  transform: scale(0.95);
}

.mode-toggle-btn.resize-mode {
  background: #667eea;
  border-color: #5a6fd6;
  color: white;
}

.font-picker-section-header {
  padding: 12px 20px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #F9FAFB;
  border-bottom: 1px solid #E5E7EB;
}

.user-font-item {
  background: #FEF3C7 !important;
  border-left: 3px solid #F59E0B;
}

.user-font-item:active,
.user-font-item:hover {
  background: #FDE68A !important;
}

/* Font size picker styles for mobile */
.font-size-block {
  position: relative;
  display: inline-block;
}

.font-size-button {
  min-width: 36px;
  height: 32px;
  padding: 0 8px;
  border-radius: 6px;
  border: 2px solid #ccc;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
}

.font-size-block.is-active .font-size-button {
  border-color: #6366F1;
  background: #EEF2FF;
}

.font-size-picker-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  transform: translateY(100%);
  transition: transform 0.3s ease-out;
  z-index: 10000;
  background: #fff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 16px 16px 0 0;
  padding-bottom: env(safe-area-inset-bottom);
}

.font-size-block.is-active .font-size-picker-sheet {
  transform: translateY(0);
}

.font-size-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.font-size-picker-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.font-size-picker-close {
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.font-size-picker-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.font-size-slider {
  width: 100%;
  height: 8px;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 4px;
  outline: none;
}

.font-size-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 24px;
  height: 24px;
  background: #4A90D9;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid #fff;
  box-shadow: 0 2px 6px rgba(74, 144, 217, 0.4);
}

.font-size-slider::-moz-range-thumb {
  width: 24px;
  height: 24px;
  background: #4A90D9;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid #fff;
  box-shadow: 0 2px 6px rgba(74, 144, 217, 0.4);
}

.font-size-value {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}
</style>
